import * as React$1 from 'react';
import React__default, { useState, useRef, useEffect, useCallback, useMemo, forwardRef, createRef, Fragment as Fragment$1, memo, useImperativeHandle, Suspense } from 'react';
import '@linaria/core';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import ReactSelect from 'react-select';
import Creatable from 'react-select/creatable';
import Media, { useMedia } from 'react-media';
import { CSSTransition } from 'react-transition-group';
import { createPortal } from 'react-dom';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { useTable, useFilters, useGroupBy, useExpanded, useSortBy, usePagination as usePagination$2 } from 'react-table';
import _extends$S from '@babel/runtime/helpers/esm/extends';
import { FixedSizeList } from 'react-window';
import ChartistGraph from 'react-chartist';
import { useDragLayer, useDrag, useDrop } from 'react-dnd';
import Dropzone$2, { useDropzone } from 'react-dropzone';
import DPI from 'react-day-picker/DayPickerInput';
import 'react-phone-number-input/style.css';
import PhoneInput$1 from 'react-phone-number-input';
import es from 'react-phone-number-input/locale/es';
import { useExportData } from 'react-table-plugins';
import DatePicker from 'react-datepicker';
import 'react-phone-input-2/lib/style.css';
import P from 'react-phone-input-2';
import es$1 from 'react-phone-input-2/lang/es.json';

var __exports$C = {}; var __module$C = { exports: __exports$C };
                    if (typeof module !== "undefined") for (var prop$C in module) { prop$C !== "exports" && (__module$C[prop$C] = module[prop$C]);}
var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

__module$C.exports = ReactPropTypesSecret$1;
var ReactPropTypesSecret$2 = __module$C.exports;

var __require__import__0$8 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), ReactPropTypesSecret$2, {
  'default': ReactPropTypesSecret$2
}));

function __interopImport$e(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$B = {}; var __module$B = { exports: __exports$B };
                    if (typeof module !== "undefined") for (var prop$B in module) { prop$B !== "exports" && (__module$B[prop$B] = module[prop$B]);}
var ReactPropTypesSecret = __interopImport$e(__require__import__0$8);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

__module$B.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};
var factoryWithThrowingShims = __module$B.exports;

var __require__import__0$7 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), factoryWithThrowingShims, {
  'default': factoryWithThrowingShims
}));

function __interopImport$d(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$A = {}; var __module$A = { exports: __exports$A };
                    if (typeof module !== "undefined") for (var prop$A in module) { prop$A !== "exports" && (__module$A[prop$A] = module[prop$A]);}
{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  __module$A.exports = __interopImport$d(__require__import__0$7)();
}
var PropTypes = __module$A.exports;

var __require__import__1$5 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), PropTypes, {
  'default': PropTypes
}));

const styles$1D="srit8nt";const Breadcrumb=({paths,current,onClickPath})=>{return/*#__PURE__*/jsxs("ul",{className:styles$1D,children:[paths.map(path=>/*#__PURE__*/jsxs("li",{onClick:e=>{e.stopPropagation();onClickPath(path);},children:[/*#__PURE__*/jsx("a",{children:path.name}),/*#__PURE__*/jsx("span",{})]},path.target)),/*#__PURE__*/jsx("li",{children:/*#__PURE__*/jsx("a",{className:"active",children:current})})]});};Breadcrumb.defaultProps={onClickPath:()=>{}};

var __exports$z = {}; var __module$z = { exports: __exports$z };
                    if (typeof module !== "undefined") for (var prop$z in module) { prop$z !== "exports" && (__module$z[prop$z] = module[prop$z]);}/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof __module$z !== 'undefined' && __module$z.exports) {
		classNames.default = classNames;
		__module$z.exports = classNames;
	} else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
		// register as 'classnames', consistent with npm package name
		define('classnames', [], function () {
			return classNames;
		});
	} else {
		window.classNames = classNames;
	}
}());
var cx = __module$z.exports;

var _circle$5, _circle2$2, _circle3$2;

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

function SvgDots(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 20"
  }, props), _circle$5 || (_circle$5 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 6
  }, /*#__PURE__*/React$1.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _circle2$2 || (_circle2$2 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 26,
    cy: 10,
    r: 6
  }, /*#__PURE__*/React$1.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.2
  }))), _circle3$2 || (_circle3$2 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 46,
    cy: 10,
    r: 6
  }, /*#__PURE__*/React$1.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.3
  }))));
}

const styles$1C="s1n1n6kq";const Button=({onClick,children,type,role,loading,htmlProps})=>/*#__PURE__*/jsx("button",Object.assign({className:cx(styles$1C,type,`color-${role}`),onClick:onClick},htmlProps,{children:loading?/*#__PURE__*/jsx(SvgDots,{className:"doots"}):/*#__PURE__*/jsx(Fragment,{children:children})}));Button.defaultProps={children:'label',type:'primary',role:'primary',htmlProps:{},loading:false};

const styles$1B="s1t37n4g";const Select=({value,placeholder,options,onChange,isMulti,canCreate,noOptionsMessage,createLabel,styleName,canClear,reactSelectProps,menuPlacement})=>{const Component=canCreate?Creatable:ReactSelect;return/*#__PURE__*/jsx(Component,Object.assign({value:value,placeholder:placeholder,isMulti:isMulti,onChange:onChange,options:options,className:[styles$1B,styleName].join(' '),classNamePrefix:"select",isClearable:canClear,noOptionsMessage:noOptionsMessage,formatCreateLabel:createLabel,menuPlacement:menuPlacement},reactSelectProps));};Select.defaultProps={value:null,isMulti:false,canCreate:false,canClear:false,noOptionsMessage:()=>/*#__PURE__*/jsx("span",{children:"No hay resultados."}),reactSelectProps:{},createLabel:value=>/*#__PURE__*/jsxs("p",{children:["Create new: ",/*#__PURE__*/jsx("b",{children:value})]}),styleName:'',menuPlacement:'auto'};

const styles$1A="siqjie5";const AccountDetail=({title,detail,image,Icon,background,withoutBorderBottom,onClick})=>{return/*#__PURE__*/jsx("div",{className:styles$1A,children:/*#__PURE__*/jsxs("div",{className:`${withoutBorderBottom?'witout-border-bottom':''}`,children:[image&&/*#__PURE__*/jsx("img",{src:image}),background&&/*#__PURE__*/jsx("div",{className:"bg-color",style:{backgroundColor:background}}),/*#__PURE__*/jsxs("div",{className:"items",children:[/*#__PURE__*/jsx("p",{children:title}),/*#__PURE__*/jsxs("p",{children:[Icon&&/*#__PURE__*/jsx(Icon,{}),/*#__PURE__*/jsx("span",{className:cx({click:!!onClick}),onClick:onClick,children:detail})]})]})]})});};AccountDetail.defaultProps={image:null,background:null,withoutBorderBottom:false,onClick:null};

var _path$D;

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

function SvgCamera(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 38"
  }, props), _path$D || (_path$D = /*#__PURE__*/React$1.createElement("path", {
    fill: "#FFF",
    d: "M10.43.395c.385 0 .74.154 1.001.417.262.247.416.618.416 1.004v.03h2.558c.509 0 .956.201 1.28.541.338.325.539.773.539 1.282v7.693c0 .494-.216.957-.54 1.282-.323.34-.77.54-1.279.54H1.831c-.494 0-.956-.216-1.28-.54a1.755 1.755 0 01-.539-1.282V3.669c0-.494.216-.957.54-1.282.323-.34.77-.54 1.279-.54h2.542v-.031c0-.386.154-.742.416-1.004A1.417 1.417 0 015.806.395zm0 .803H5.821a.606.606 0 00-.432.17.606.606 0 00-.17.432v.448a.414.414 0 01-.415.417H1.83a.99.99 0 00-.71.294.994.994 0 00-.292.71v7.693a.99.99 0 00.293.71.99.99 0 00.709.294h12.574a.99.99 0 00.709-.294.99.99 0 00.293-.71h.015V3.669a.99.99 0 00-.293-.71.983.983 0 00-.708-.294h-2.975a.415.415 0 01-.416-.417V1.8a.602.602 0 00-.17-.432.601.601 0 00-.43-.17zM8.117 3.716a3.79 3.79 0 013.791 3.799 3.79 3.79 0 01-6.472 2.688 3.812 3.812 0 010-5.375 3.79 3.79 0 012.68-1.112zm0 .85c-.817 0-1.557.324-2.096.864a3.02 3.02 0 00-.863 2.1c0 .82.324 1.561.863 2.102.54.525 1.28.865 2.096.865a3.01 3.01 0 002.096-.865 2.898 2.898 0 00.863-2.101c0-.819-.324-1.56-.863-2.1a3.008 3.008 0 00-2.096-.866zm5.486-.866a.757.757 0 010 1.514.756.756 0 010-1.514z"
  })));
}

const styles$1z="s18v5eeg";const AccountAvatar=({source,userName,canEdit,size,onImageUpload})=>{const[srcError,setSrcError]=useState(false);const classnames=cx(styles$1z,{'can-edit':canEdit});return/*#__PURE__*/jsxs("div",{className:classnames,style:{width:size,height:size},children:[canEdit&&/*#__PURE__*/jsxs("div",{className:"upload-zone",children:[/*#__PURE__*/jsx("label",{children:/*#__PURE__*/jsx("input",{type:"file",onChange:onImageUpload,accept:".png, .jpg, .jpeg, .gif"})}),/*#__PURE__*/jsx("div",{children:/*#__PURE__*/jsx(SvgCamera,{})})]}),source&&!srcError?/*#__PURE__*/jsx("img",{src:source,onError:()=>setSrcError(true)}):/*#__PURE__*/jsx("div",{className:"default-image",children:userName&&/*#__PURE__*/jsx("p",{children:userName.charAt(0)})})]});};AccountAvatar.defaultProps={source:'',userName:'',canEdit:false,size:'100%',onImageUpload:()=>{}};

const styles$1y="s1tb3v9s";const Hamburger=({open})=>/*#__PURE__*/jsx("div",{className:cx(styles$1y,{open}),children:/*#__PURE__*/jsx("div",{className:"menu-btn__burger"})});Hamburger.defaultProps={open:false};

var _path$C;

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

function SvgBell(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$P({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$C || (_path$C = /*#__PURE__*/React$1.createElement("path", {
    d: "M1 14.25a.75.75 0 000 1.5v-1.5zm2.7-6.717h-.75.75zm12.6 0h.75-.75zM19 15.75a.75.75 0 000-1.5v1.5zm-6.33 1.589a.75.75 0 00-1.34-.674l1.34.674zm-3-.674a.75.75 0 10-1.34.674l1.34-.674zM1 15.75c1.93 0 3.45-1.615 3.45-3.55h-1.5c0 1.158-.899 2.05-1.95 2.05v1.5zm3.45-3.55V7.533h-1.5V12.2h1.5zm0-4.667c0-3.22 2.51-5.783 5.55-5.783V.25c-3.92 0-7.05 3.287-7.05 7.283h1.5zM10 1.75c3.04 0 5.55 2.563 5.55 5.783h1.5C17.05 3.537 13.92.25 10 .25v1.5zm5.55 5.783V12.2h1.5V7.533h-1.5zm0 4.667c0 1.935 1.52 3.55 3.45 3.55v-1.5c-1.052 0-1.95-.892-1.95-2.05h-1.5zM19 14.25H1v1.5h18v-1.5zm-7.67 2.415c-.201.4-.534.583-.83.583v1.5c.94 0 1.75-.576 2.17-1.41l-1.34-.673zm-.83.583c-.296 0-.629-.183-.83-.583l-1.34.674c.42.833 1.23 1.41 2.17 1.41v-1.5z",
    fill: "#6C7280"
  })));
}

var _path$B;

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

function SvgLogout(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21"
  }, props), _path$B || (_path$B = /*#__PURE__*/React$1.createElement("path", {
    fill: "#B1ABAB",
    d: "M7.684 2.245a1.68 1.68 0 011.133 1.582v12.891h2.703c.573 0 1.04-.466 1.04-1.04v-3.742a.624.624 0 111.247 0v3.743a2.288 2.288 0 01-2.287 2.287H8.817v.832c0 .917-.746 1.663-1.663 1.663a1.73 1.73 0 01-.516-.077l-5.005-1.668A1.678 1.678 0 01.5 17.135V2.164C.5 1.246 1.246.5 2.163.5h9.357a2.29 2.29 0 012.287 2.288V6.53a.624.624 0 11-1.247 0V2.788c0-.574-.467-1.04-1.04-1.04H6.192l1.492.497zm-5.52-.497a.416.416 0 00-.416.416v14.97c0 .178.119.342.288.401l4.982 1.66a.437.437 0 00.136.019.417.417 0 00.415-.416V3.828a.432.432 0 00-.288-.402l-4.982-1.66a.472.472 0 00-.136-.018zM17.16 5.672l3.119 3.119.03.034.008.01-.038-.044a.616.616 0 01.171.322l.006.044a.403.403 0 01.005.05v.026l-.003.05.003-.023c0 .015-.002.03-.004.045v-.008l-.009.063-.01.045a.645.645 0 01-.082.174l-.018.026a.743.743 0 01-.052.062l-.007.006-3.119 3.12a.623.623 0 11-.882-.882l2.053-2.055-6.395.001a.625.625 0 010-1.248h6.396l-2.055-2.055a.625.625 0 01.883-.882z"
  })));
}

var _path$A, _path2$5;

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

function SvgWarningIcon(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$N({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/React$1.createElement("path", {
    clipRule: "evenodd",
    d: "M10.945 5.85L3.244 18.35a1.725 1.725 0 00-.005 1.759c.32.546.913.885 1.56.892H20.2a1.828 1.828 0 001.56-.892 1.725 1.725 0 00-.005-1.76L14.055 5.852A1.83 1.83 0 0012.5 5a1.83 1.83 0 00-1.555.85z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React$1.createElement("path", {
    d: "M12.5 11v3.366M12.5 16.842v.16",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const styles$1x="s1m5vcy9";const stylesAlert="sd810i4";const TopBar=({onMenuClick,onNotificationClick,userRoles,accountSubmenuItems,selects,accountAvatarProps,generalAlert,showAlert,quantityNotifications,showNotificationsButton,menuOpen})=>{const[showSubmenu,openSubmenu]=useState(false);const node=useRef();const roleVerifiedRules=items=>items.filter(item=>item.requiredRoles&&userRoles!==null&&userRoles!==void 0&&userRoles.length?item.requiredRoles.some(rol=>userRoles.includes(rol)):true);const handleUserMenuClick=e=>{if(!node.current.contains(e.target)){openSubmenu(false);}};useEffect(()=>{document.addEventListener('mousedown',handleUserMenuClick);return ()=>{document.removeEventListener('mousedown',handleUserMenuClick);};},[]);return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsxs("nav",{className:styles$1x,children:[/*#__PURE__*/jsx("button",{type:"button",onClick:onMenuClick,className:"menuicon",children:/*#__PURE__*/jsx(Hamburger,{open:menuOpen})}),/*#__PURE__*/jsx("div",{className:"topbar-spacer"}),/*#__PURE__*/jsxs("div",{className:"right-section",ref:node,children:[selects.length>0&&selects.map(selectProps=>/*#__PURE__*/jsxs("div",{className:"select",children:[/*#__PURE__*/jsx("p",{children:selectProps.placeholder}),/*#__PURE__*/jsx(Select,Object.assign({},selectProps,{reactSelectProps:{isSearchable:false}}),selectProps.placeholder)]},selectProps.placeholder)),showNotificationsButton&&/*#__PURE__*/jsxs("button",{type:"button",className:"notifications",onClick:onNotificationClick,children:[/*#__PURE__*/jsx(SvgBell,{}),quantityNotifications>0&&/*#__PURE__*/jsx("span",{className:"dot",children:quantityNotifications>99?'+99':quantityNotifications})]}),/*#__PURE__*/jsxs("div",{className:"user-menu",onClick:()=>openSubmenu(state=>!state),children:[showSubmenu&&/*#__PURE__*/jsxs("ul",{className:"account-submenu",children:[accountSubmenuItems&&roleVerifiedRules(accountSubmenuItems).map(submenu=>/*#__PURE__*/jsx("li",{children:/*#__PURE__*/jsxs("a",{href:submenu.target,children:[/*#__PURE__*/jsx(submenu.icon,{}),/*#__PURE__*/jsx("span",{children:submenu.label})]})},submenu.key)),/*#__PURE__*/jsx("li",{children:/*#__PURE__*/jsxs("a",{href:"/logout",children:[/*#__PURE__*/jsx(SvgLogout,{}),/*#__PURE__*/jsx("span",{children:"Cerrar sesi\xF3n"})]})})]}),/*#__PURE__*/jsx(AccountAvatar,Object.assign({size:"42px"},accountAvatarProps))]})]})]}),showAlert&&/*#__PURE__*/jsxs("div",{className:`${stylesAlert} ${generalAlert.type}`,children:[/*#__PURE__*/jsx("div",{className:"icon",children:generalAlert.icon?/*#__PURE__*/jsx(generalAlert.icon,{}):/*#__PURE__*/jsx(SvgWarningIcon,{})}),/*#__PURE__*/jsxs("div",{className:"alert-content",children:[/*#__PURE__*/jsx("div",{className:"text",children:generalAlert.textAlert}),/*#__PURE__*/jsx("div",{className:"link",onClick:generalAlert.linkAction,children:generalAlert.linkText})]})]})]});};TopBar.defaultProps={onMenuClick:()=>{},onNotificationClick:()=>{},selects:[],accountAvatarProps:{},showAlert:false,showNotificationsButton:false,quantityNotifications:null,generalAlert:{type:'error',icon:null,textAlert:'',linkText:'',linkAction:()=>{}},userRoles:[],menuOpen:false};

const styles$1w="sg70ys3";const HeadBand=({type,onClickAction,haveAction,children})=>/*#__PURE__*/jsx("div",{className:cx(styles$1w,type,haveAction?'with-action':''),onClick:onClickAction,children:children});HeadBand.defaultProps={type:'info',onClickAction:()=>{},haveAction:false};

const itemDataType=PropTypes.exact({key:PropTypes.string.isRequired,label:PropTypes.string.isRequired,icon:PropTypes.elementType,iconUrl:PropTypes.string,target:PropTypes.string.isRequired,submenu:PropTypes.arrayOf(PropTypes.shape({key:PropTypes.string.isRequired,label:PropTypes.string.isRequired,target:PropTypes.string.isRequired})),requiredRoles:PropTypes.array});({userRoles:PropTypes.array,itemData:PropTypes.arrayOf(itemDataType).isRequired,MenuLogo:PropTypes.elementType,MenuLogoMini:PropTypes.elementType,itemOnClick:PropTypes.func,activeItem:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),onMenuClose:PropTypes.func,logo:PropTypes.oneOf(['full','small']),activeSupport:PropTypes.bool,logoOnBot:PropTypes.bool});

const _excluded$8=["data","activeItem","miniMode"];function _objectWithoutPropertiesLoose$9(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const styles$1v="s1e6rf1b";const subMenuStyles="s1v4geba";const MenuItem=_ref=>{var _data$submenu$some,_data$submenu;let{data,// onClick,
activeItem,miniMode}=_ref,props=_objectWithoutPropertiesLoose$9(_ref,_excluded$8);const hasSubMenu=data.submenu!==undefined;/*
  const handleClick = onClick
    ? (e) => {
        e.preventDefault()
        e.stopPropagation()
        onClick(data)
      }
    : null
  */const mask=data.iconUrl?`url(${data.iconUrl}) no-repeat center`:null;const active=data.key===activeItem||((_data$submenu$some=(_data$submenu=data.submenu)===null||_data$submenu===void 0?void 0:_data$submenu.some(subItem=>activeItem===subItem.key))!==null&&_data$submenu$some!==void 0?_data$submenu$some:false);if(hasSubMenu&&!miniMode){return/*#__PURE__*/jsxs("div",Object.assign({className:`${subMenuStyles} has-submenu`},props,{children:[/*#__PURE__*/jsx("input",{id:`menu-checkbox-${data.label}`,type:"checkbox",defaultChecked:active,disabled:miniMode}),/*#__PURE__*/jsxs("label",{htmlFor:`menu-checkbox-${data.label}`,className:cx(styles$1v,{active}),children:[mask?/*#__PURE__*/jsx("div",{className:"menu-item-icon",style:{WebkitMask:mask,mask}}):data.icon&&/*#__PURE__*/jsx(data.icon,{}),!miniMode&&/*#__PURE__*/jsx("span",{className:"menu-item-label",children:data.label})]}),/*#__PURE__*/jsx("div",{className:"ul",children:data.submenu.map(subItem=>/*#__PURE__*/jsx("a",{href:subItem.target,className:cx({active:subItem.key===activeItem})// onClick={handleClick}
,children:subItem.label},subItem.key))})]}));}return/*#__PURE__*/jsxs("a",{href:data.target,className:cx(styles$1v,{active}),children:[mask?/*#__PURE__*/jsx("div",{className:"menu-item-icon",style:{WebkitMask:mask,mask}}):data.icon&&/*#__PURE__*/jsx(data.icon,{}),!miniMode&&/*#__PURE__*/jsx("span",{className:"menu-item-label",children:data.label})]});};MenuItem.defaultProps={onClick:null,activeItem:'',miniMode:false};

var _path$z;

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

function SvgLogo(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$M({
    width: 160,
    height: 22,
    viewBox: "0 0 160 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/React$1.createElement("path", {
    d: "M73.46 2.305c.876.818 1.3 1.918 1.3 3.328 0 .818-.198 1.523-.565 2.115-.367.592-.932 1.044-1.695 1.326v.084c1.864.62 2.796 1.975 2.796 4.09 0 1.495-.452 2.68-1.384 3.525-.932.846-2.23 1.27-3.925 1.27h-7.513V1.093h7.286c1.582 0 2.825.394 3.7 1.212zm-4.01 6.12c1.017 0 1.78-.226 2.316-.705.536-.48.79-1.156.79-2.059 0-.93-.254-1.607-.79-2.087-.537-.48-1.3-.705-2.316-.705h-4.83v5.528h4.83v.028zm2.796 7.023c.593-.508.876-1.27.876-2.257 0-.987-.283-1.72-.876-2.256-.593-.508-1.44-.761-2.542-.761h-5.056v6.064h5.056c1.102 0 1.949-.254 2.542-.79zM86.594 16.266a4.066 4.066 0 01-1.638 1.523c-.706.366-1.469.536-2.344.536-1.271 0-2.345-.367-3.164-1.129-.819-.761-1.242-1.861-1.242-3.3V5.549h2.005v7.643c0 1.213.226 2.088.706 2.623.48.536 1.215.818 2.231.818.96 0 1.751-.338 2.43-1.043.677-.705.988-1.749.988-3.103V5.548h2.005v12.495h-1.892v-1.777h-.085zM98.541 7.466c-.593-.423-1.27-.62-2.033-.62-.82 0-1.497.169-1.977.536-.48.366-.735.846-.735 1.466 0 .564.226.96.678 1.213.452.254 1.073.451 1.892.592l1.328.226c1.299.225 2.316.592 3.022 1.072.734.507 1.073 1.325 1.073 2.51 0 1.24-.48 2.2-1.44 2.848-.96.677-2.203 1.016-3.7 1.016-1.497 0-2.74-.367-3.728-1.072-.989-.705-1.554-1.664-1.723-2.82l1.836-.395c.17.874.593 1.55 1.242 2.03.65.48 1.44.705 2.401.705.904 0 1.638-.197 2.203-.592.565-.395.847-.959.847-1.636 0-.592-.226-1.043-.706-1.297-.48-.282-1.186-.48-2.118-.677l-1.3-.226c-1.185-.197-2.146-.564-2.824-1.043-.706-.48-1.045-1.297-1.045-2.397 0-.706.198-1.326.594-1.89.395-.564.96-.987 1.694-1.27.734-.31 1.553-.45 2.486-.45.847 0 1.638.169 2.372.479.734.31 1.299.733 1.751 1.27.452.535.734 1.127.847 1.748l-1.835.395c-.17-.706-.537-1.298-1.102-1.72zM106.619.866v2.285h-2.034V.866h2.034zm-.028 4.682v12.495h-2.006V5.548h2.006zM112.183 7.353a4.181 4.181 0 011.61-1.523c.706-.366 1.469-.536 2.344-.536 1.271 0 2.345.367 3.192 1.129.847.761 1.271 1.861 1.271 3.3v8.348h-2.006v-7.644c0-1.212-.254-2.087-.734-2.622-.48-.536-1.243-.818-2.259-.818-.594 0-1.158.14-1.667.45-.508.311-.932.762-1.242 1.383-.311.62-.481 1.41-.481 2.313v6.938h-2.005V5.576h1.892v1.777h.085zM132.688 17.225c-.904.733-2.146 1.1-3.728 1.1-1.13 0-2.118-.282-2.994-.818-.875-.536-1.553-1.298-2.033-2.285-.481-.987-.735-2.143-.735-3.44 0-1.298.226-2.454.706-3.442.48-.987 1.158-1.748 2.006-2.284.875-.536 1.864-.818 3.022-.818 1.101 0 2.09.254 2.965.762.876.507 1.554 1.269 2.034 2.228.48.987.734 2.115.734 3.469 0 .225 0 .423-.028.536h-9.433c.028 1.325.395 2.369 1.073 3.187.678.818 1.581 1.212 2.655 1.212 1.017 0 1.807-.253 2.4-.733.565-.48.989-1.072 1.215-1.72l2.034.253c-.368 1.157-.989 2.06-1.893 2.793zm-6.326-9.223c-.65.733-1.017 1.636-1.102 2.708h7.343c-.084-1.072-.48-1.975-1.129-2.708-.65-.733-1.497-1.1-2.57-1.1-1.046 0-1.893.367-2.542 1.1zM144.07 7.466c-.593-.423-1.271-.62-2.033-.62-.819 0-1.497.169-1.977.536-.48.366-.735.846-.735 1.466 0 .564.226.96.678 1.213.452.254 1.074.451 1.893.592l1.327.226c1.299.225 2.316.592 3.022 1.072.735.507 1.073 1.325 1.073 2.51 0 1.24-.48 2.2-1.44 2.848-.96.677-2.203 1.016-3.7 1.016-1.497 0-2.74-.367-3.728-1.072-.989-.705-1.553-1.664-1.723-2.82l1.836-.395c.169.874.593 1.55 1.243 2.03.649.48 1.44.705 2.4.705.904 0 1.638-.197 2.203-.592.565-.395.848-.959.848-1.636 0-.592-.226-1.043-.706-1.297-.481-.282-1.187-.48-2.119-.677l-1.299-.226c-1.186-.197-2.146-.564-2.824-1.043-.706-.48-1.045-1.297-1.045-2.397 0-.706.197-1.326.593-1.89.395-.564.96-.987 1.694-1.27.735-.31 1.554-.45 2.486-.45.847 0 1.638.169 2.372.479.735.31 1.3.733 1.751 1.27.452.535.735 1.127.848 1.748l-1.836.395a2.708 2.708 0 00-1.102-1.72zM156.752 7.466c-.593-.423-1.271-.62-2.033-.62-.82 0-1.497.169-1.978.536-.48.366-.734.846-.734 1.466 0 .564.226.96.678 1.213.452.254 1.073.451 1.892.592l1.328.226c1.299.225 2.316.592 3.022 1.072.734.507 1.073 1.325 1.073 2.51 0 1.24-.48 2.2-1.44 2.848-.961.677-2.203 1.016-3.7 1.016-1.497 0-2.74-.367-3.728-1.072-.989-.705-1.554-1.664-1.723-2.82l1.836-.395c.169.874.593 1.55 1.242 2.03.65.48 1.441.705 2.401.705.904 0 1.638-.197 2.203-.592.565-.395.847-.959.847-1.636 0-.592-.226-1.043-.706-1.297-.48-.282-1.186-.48-2.118-.677l-1.299-.226c-1.187-.197-2.147-.564-2.825-1.043-.706-.48-1.045-1.297-1.045-2.397 0-.706.198-1.326.593-1.89.396-.564.961-.987 1.695-1.27.734-.31 1.553-.45 2.486-.45.847 0 1.638.169 2.372.479.734.31 1.299.733 1.751 1.27.452.535.734 1.127.847 1.748l-1.835.395c-.17-.706-.537-1.298-1.102-1.72zM.196.838h5.282v6.064c.395-.536.932-1.015 1.582-1.41s1.412-.62 2.316-.62c1.355 0 2.429.422 3.191 1.24.79.846 1.158 1.975 1.158 3.441v8.49H8.444v-6.77c0-.535-.142-.986-.424-1.297a1.314 1.314 0 00-1.017-.451c-.395 0-.763.141-1.073.451-.31.31-.452.733-.452 1.298v6.769H.196V.838zM19.854 18.353c-1.356 0-2.429-.423-3.192-1.241-.79-.846-1.158-1.974-1.158-3.441V5.18h5.282v6.77c0 .564.141.987.424 1.297.282.31.621.451 1.016.451.396 0 .763-.14 1.074-.451.31-.31.452-.733.452-1.297V5.18h5.281v12.861h-5.281v-1.72c-.396.536-.932 1.015-1.582 1.41-.65.423-1.412.62-2.316.62zM37.76 21.878c-1.412 0-2.683-.14-3.813-.423a16.58 16.58 0 01-3.248-1.184l1.639-3.244c.706.367 1.44.677 2.174.903a8.286 8.286 0 002.43.338c.988 0 1.75-.254 2.259-.733.508-.508.762-1.185.762-2.087v-.367c-.197.198-.395.423-.65.62a4.219 4.219 0 01-.818.565c-.311.169-.65.31-1.017.423-.367.113-.79.169-1.215.169-.819 0-1.581-.141-2.259-.423a4.982 4.982 0 01-1.808-1.213 5.265 5.265 0 01-1.186-1.861c-.282-.734-.424-1.523-.424-2.426v-.056c0-.903.142-1.72.424-2.454.282-.733.678-1.382 1.158-1.89a4.908 4.908 0 011.723-1.212 5.224 5.224 0 012.09-.423c.932 0 1.695.169 2.288.479.593.31 1.13.705 1.61 1.213V5.238h5.281v9.618c0 1.184-.141 2.2-.395 3.045a4.995 4.995 0 01-1.271 2.144c-.565.592-1.328 1.043-2.231 1.382-.904.282-2.062.451-3.503.451zm.085-8.969c.65 0 1.158-.197 1.553-.592.368-.395.565-.874.565-1.438v-.057a2.03 2.03 0 00-.565-1.41c-.395-.395-.903-.592-1.553-.592-.65 0-1.158.197-1.553.592a2.047 2.047 0 00-.565 1.439v.056c0 .564.198 1.015.565 1.41.395.395.904.592 1.553.592zM53.633 4.815c-3.84 0-6.948 3.018-6.948 6.769 0 3.751 3.107 6.769 6.948 6.769 3.842 0 6.948-3.018 6.948-6.77 0-3.75-3.106-6.768-6.948-6.768zm-.056 9.053c-1.3 0-2.344-1.015-2.344-2.284 0-1.27 1.045-2.285 2.344-2.285 1.3 0 2.344 1.016 2.344 2.285 0 1.269-1.045 2.284-2.344 2.284z",
    fill: "#5C0F8B"
  })));
}

var _path$y, _path2$4, _path3, _path4, _path5, _path6;

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

function SvgLogoSmall(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$L({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/React$1.createElement("path", {
    d: "M16.692.987c7.061 0 10.959 0 13.331 2.37 2.373 2.368 2.373 6.26 2.373 13.312 0 7.05 0 10.943-2.373 13.312-2.372 2.369-6.27 2.369-13.33 2.369-7.062 0-10.96 0-13.332-2.37C.989 27.613.989 23.72.989 16.67s0-10.944 2.372-13.313C5.734.987 9.631.987 16.692.987zm0-.987C9.377 0 5.31 0 2.655 2.651 0 5.302 0 9.364 0 16.67c0 7.304 0 11.366 2.655 14.017 2.655 2.65 6.722 2.65 14.037 2.65s11.382 0 14.037-2.65c2.655-2.651 2.655-6.713 2.655-14.017 0-7.305 0-11.367-2.655-14.018S24.007 0 16.692 0z",
    fill: "#5C0F8B"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React$1.createElement("path", {
    d: "M14.743 18.643h6.016a5.98 5.98 0 004.435-1.974 5.98 5.98 0 00-4.435-1.975h-6.016A8.034 8.034 0 016.75 7.615v18.107c.48-3.977 3.87-7.08 7.993-7.08z",
    fill: "#BD8BEA"
  })), _path3 || (_path3 = /*#__PURE__*/React$1.createElement("path", {
    d: "M6.694 6.656c0 .339.028.649.056.987v-.987h-.056z",
    fill: "#5C0F8B"
  })), _path4 || (_path4 = /*#__PURE__*/React$1.createElement("path", {
    d: "M14.743 14.694h6.016a5.98 5.98 0 014.435 1.975c1.214-1.354 1.864-3.244 1.44-5.275-.593-2.82-3.22-4.738-6.1-4.738H6.721v.987a8.082 8.082 0 008.021 7.051z",
    fill: "#5C0F8B"
  })), _path5 || (_path5 = /*#__PURE__*/React$1.createElement("path", {
    d: "M6.694 26.709h.056v-.987c-.028.338-.056.649-.056.987z",
    fill: "#B4E5B1"
  })), _path6 || (_path6 = /*#__PURE__*/React$1.createElement("path", {
    d: "M26.634 21.943c.424-2.06-.226-3.92-1.44-5.274a5.98 5.98 0 01-4.435 1.974h-6.016a8.034 8.034 0 00-7.993 7.079v.987h13.812c2.88 0 5.479-1.946 6.072-4.766z",
    fill: "#17A392"
  })));
}

const listStyles="ldu6u2e";const logoStyles="l1htons2";const MenuContent=({className,userRoles,itemData,MenuLogo,MenuLogoMini,activeItem,logo,miniMode,activeSupport})=>{const roleVerifiedRules=items=>items.filter(item=>item.requiredRoles&&userRoles.length?item.requiredRoles.some(rol=>userRoles.includes(rol)):true);const logoComponent=/*#__PURE__*/jsx("div",{className:cx(logoStyles,'menu-logo'),children:logo==='full'?MenuLogo?/*#__PURE__*/jsx(MenuLogo,{className:"logo"},"logo"):/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx(SvgLogoSmall,{className:"logo"},"logo-mini"),/*#__PURE__*/jsx(SvgLogo,{className:"logo"},"logo-default")]}):MenuLogoMini?/*#__PURE__*/jsx(MenuLogoMini,{className:"logo"},"logo-mini"):/*#__PURE__*/jsx(SvgLogoSmall,{className:"logo"},"logo-mini-default")});return/*#__PURE__*/jsxs("div",{className:className,children:[logoComponent,/*#__PURE__*/jsxs("div",{className:cx('items',listStyles,{mini:miniMode}),children:[roleVerifiedRules(itemData).map(item=>/*#__PURE__*/jsx(MenuItem,{data:Object.assign({},item,{submenu:item.submenu?roleVerifiedRules(item.submenu):undefined}),activeItem:activeItem,miniMode:miniMode},item.target)),activeSupport&&/*#__PURE__*/jsx(MenuItem,{style:{marginTop:'auto'},data:{key:'support',label:'soporte',// icon: SupportIcon,
target:'/support'},activeItem:activeItem})]})]});};MenuContent.defaultProps={className:'',userRoles:[],activeItem:'',onMenuClose:()=>{},hasClose:false,logo:'full',miniMode:false,activeSupport:true,logoOnBot:false};

const styles$1u="s1va5qts";const DesktopMenu=props=>{const[miniMode,setMiniMode]=useState(()=>{const stickyValue=window.localStorage.getItem('mini');return stickyValue!==null?JSON.parse(stickyValue):false;});const node=useRef();const menuClasses=cx('container-menu',{mini:miniMode});const handleSocietyCollapse=bool=>{setMiniMode(bool);const inputs=node.current.getElementsByTagName('input');for(let i=0;i<inputs.length;i+=1){if(bool){inputs[i].checked=false;inputs[i].disabled=true;}else {inputs[i].checked=true;inputs[i].disabled=false;}}};useEffect(()=>{window.localStorage.setItem('mini',JSON.stringify(miniMode));},[miniMode]);return/*#__PURE__*/jsxs("div",{className:styles$1u,ref:node,children:[/*#__PURE__*/jsx(MenuContent,Object.assign({},props,{logo:miniMode?'small':'full',miniMode:miniMode,activeSupport:false,className:menuClasses})),/*#__PURE__*/jsx("div",{className:"collapse",onClick:()=>handleSocietyCollapse(!miniMode)})]});};DesktopMenu.defaultProps={itemData:[],itemOnClick:()=>{},activeItem:null};

const _excluded$7=["userRoles","itemData","activeItem","menuOpen","onMenuClose"];function _objectWithoutPropertiesLoose$8(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const styles$1t="s195djb3";const menuContentStyles="m1jwvd4w";const MobileMenu=_ref=>{let{userRoles,itemData,activeItem,menuOpen,onMenuClose}=_ref,props=_objectWithoutPropertiesLoose$8(_ref,_excluded$7);useEffect(()=>{// we will close the menu every time we navigate
if(menuOpen){onMenuClose();}},[activeItem]);return/*#__PURE__*/jsx("div",{className:cx(styles$1t,{open:menuOpen}),children:/*#__PURE__*/jsx(CSSTransition,{in:menuOpen,timeout:{enter:200,exit:400},classNames:"container-menu",children:/*#__PURE__*/jsxs("div",{className:"container-menu",children:[/*#__PURE__*/jsx(CSSTransition,{in:menuOpen,timeout:300,classNames:"overlay",children:/*#__PURE__*/jsx("div",{className:"overlay",onClick:onMenuClose,children:/*#__PURE__*/jsx("div",{})})}),/*#__PURE__*/jsx(CSSTransition,{in:menuOpen,timeout:300,classNames:"menu",children:/*#__PURE__*/jsx("div",{className:"menu",children:/*#__PURE__*/jsx("div",{className:"container-content",children:/*#__PURE__*/jsx(MenuContent,Object.assign({},props,{className:menuContentStyles,userRoles:userRoles,itemData:itemData,activeSupport:false,activeItem:activeItem}))})})})]})})});};

const Menu$1=props=>/*#__PURE__*/jsx(Media,{query:{minWidth:769},children:matches=>matches?/*#__PURE__*/jsx(DesktopMenu,Object.assign({},props)):/*#__PURE__*/jsx(MobileMenu,Object.assign({},props))});

const styles$1s="s99sdvm";const PageHeader$1=({title,Actions})=>/*#__PURE__*/jsxs("div",{className:styles$1s,children:[title&&/*#__PURE__*/jsx("h1",{children:title}),Actions&&Actions.length>0&&/*#__PURE__*/jsx("div",{className:"actions",children:Actions})]});PageHeader$1.defaultProps={title:null,Actions:null};

const styles$1r="s17ekb2d";const MainMenu=({title,navActions,menuProps,topBarProps,children,showBreadCrumb,activeBreadcrumb,onClickPathBreadcrumb,breadcrumbPaths,disabledActions,activeItem,showHeadBand,headBandProps})=>{const[menuOpen,setMenuOpen]=useState(false);const toggleMenu=()=>setMenuOpen(state=>!state);const closeMenu=()=>setMenuOpen(false);useEffect(()=>{if(menuOpen){document.body.classList.add('menu-open');}else {document.body.classList.remove('menu-open');}},[menuOpen]);return/*#__PURE__*/jsxs("div",{className:styles$1r,children:[/*#__PURE__*/jsx(Menu$1,Object.assign({},menuProps,{onMenuClose:closeMenu,menuOpen:menuOpen,activeItem:activeItem})),/*#__PURE__*/jsxs("div",{className:"content",children:[/*#__PURE__*/jsx(TopBar,Object.assign({onMenuClick:toggleMenu,menuOpen:menuOpen},topBarProps)),showHeadBand&&headBandProps.contentText!==''&&/*#__PURE__*/jsx(HeadBand,Object.assign({},headBandProps)),/*#__PURE__*/jsxs("header",{children:[showBreadCrumb&&breadcrumbPaths.length>0&&/*#__PURE__*/jsx(Breadcrumb,{paths:breadcrumbPaths,current:title!==null&&title!==void 0?title:activeBreadcrumb,onClickPath:onClickPathBreadcrumb}),/*#__PURE__*/jsx(PageHeader$1,{title:title,Actions:!disabledActions&&navActions.map(action=>/*#__PURE__*/jsx(Button,{onClick:action.onClick,role:action.main?'secondary':'primary',type:action.main?'primary':'outline',children:action.label},`actions-${action.target}`))})]}),/*#__PURE__*/jsx("main",{id:"main",children:children})]})]},"main-menu");};MainMenu.defaultProps={title:'',hasNotification:false,navActions:[],breadcrumbPaths:[],showBreadCrumb:false,onClickPathBreadcrumb:()=>{},topBarProps:{},disabledActions:false,activeItem:'',showHeadBand:false,headBandProps:{contentText:'',Icon:null,type:'info',onClickAction:()=>{},haveAction:false}};

const styles$1q="s1ei2g91";const PageHeader=({title,bannerTitle,bannerSubtitle,BannerIcon,routePath,Actions,breadcrumbPaths,onClickPathBreadcrumb})=>{return/*#__PURE__*/jsxs("div",{className:styles$1q,children:[routePath=='/'&&/*#__PURE__*/jsxs("div",{className:"banner-content",children:[/*#__PURE__*/jsx("label",{children:BannerIcon&&/*#__PURE__*/jsx(BannerIcon,{})}),/*#__PURE__*/jsxs("div",{className:"banner-description",children:[bannerTitle&&/*#__PURE__*/jsx("h1",{children:bannerTitle}),bannerSubtitle&&/*#__PURE__*/jsx("h3",{children:bannerSubtitle})]})]}),routePath!='/'&&/*#__PURE__*/jsxs("div",{className:"banner-nav",children:[/*#__PURE__*/jsx("h1",{children:title}),breadcrumbPaths.length>0&&/*#__PURE__*/jsx(Breadcrumb,{paths:breadcrumbPaths,current:title,onClickPath:onClickPathBreadcrumb})]}),Actions.length>0&&/*#__PURE__*/jsx("div",{className:"actions",children:Actions})]});};PageHeader.defaultProps={bannerTitle:'',bannerSubtitle:'',Actions:null};

const styles$1p="sb7yn6t";const MenuBanner=({title,bannerTitle,bannerSubtitle,BannerIcon,routePath,navActions,menuProps,breadcrumbPaths,onClickPathBreadcrumb,topBarProps,children})=>{const[menuOpen,setMenuOpen]=useState(false);const openMenu=()=>setMenuOpen(true);const closeMenu=()=>setMenuOpen(false);useEffect(()=>{if(menuOpen){document.body.classList.add('menu-open');}else {document.body.classList.remove('menu-open');}},[menuOpen]);return/*#__PURE__*/jsxs("div",{className:styles$1p,children:[/*#__PURE__*/jsx(Menu$1,Object.assign({},menuProps,{onMenuClose:closeMenu,menuOpen:menuOpen})),/*#__PURE__*/jsxs("div",{className:"content",children:[/*#__PURE__*/jsx(TopBar,Object.assign({onMenuClick:openMenu},topBarProps)),/*#__PURE__*/jsx("header",{children:/*#__PURE__*/jsx(PageHeader,{title:title,bannerTitle:bannerTitle,bannerSubtitle:bannerSubtitle,BannerIcon:BannerIcon,routePath:routePath,breadcrumbPaths:breadcrumbPaths,onClickPathBreadcrumb:onClickPathBreadcrumb,Actions:navActions.map(action=>/*#__PURE__*/jsx(Button,{onClick:action.onClick,role:action.main?'secondary':'primary',type:action.main?'primary':'outline',children:action.label},`actions-${action.target}`))})}),/*#__PURE__*/jsx("main",{id:"main",children:children})]})]});};MenuBanner.defaultProps={title:'',bannerTitle:'',bannerSubtitle:'',hasNotification:false,navActions:[],breadcrumbPaths:[],topBarProps:{}};

const styles$1o="sicnpxx";const TwoColumnCard=({title,description,image,children})=>/*#__PURE__*/jsx("div",{className:styles$1o,children:/*#__PURE__*/jsxs("div",{children:[/*#__PURE__*/jsxs("div",{className:"left",children:[/*#__PURE__*/jsx("h3",{children:title}),/*#__PURE__*/jsx("p",{children:description}),image&&/*#__PURE__*/jsx("div",{className:"image",children:/*#__PURE__*/jsx("img",{src:image})})]}),/*#__PURE__*/jsx("div",{className:"right",children:children})]})});TwoColumnCard.defaultProps={image:''};

// import { useEffect } from 'react'
const Portal=({children})=>{const mount=document.getElementById('portal');// const el = document.createElement('div')
/*
  useEffect(() => {
    mount.appendChild(el)
    return () => mount.removeChild(el)
  }, [el, mount])
  */return/*#__PURE__*/createPortal(children,mount);};

const styles$1n="s1nu0cb";const Modal$1=({title,children,onClose,size})=>/*#__PURE__*/jsx(Portal,{children:/*#__PURE__*/jsx("div",{className:styles$1n,children:/*#__PURE__*/jsxs("div",{className:`content ${size}`,children:[/*#__PURE__*/jsxs("header",{children:[/*#__PURE__*/jsx("h1",{children:title}),/*#__PURE__*/jsx("a",{onClick:onClose,children:"\xD7"})]}),/*#__PURE__*/jsx("main",{id:"modal-body",children:children})]})})});Modal$1.defaultProps={title:'',onClose:()=>{},size:'lg'};

var _path$x;

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

function SvgRightArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path$x || (_path$x = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#667387",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.167 10h11.666M10 4.167L15.833 10 10 15.833"
  })));
}

var _path$w;

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

function SvgLeftArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path$w || (_path$w = /*#__PURE__*/React$1.createElement("path", {
    stroke: "#667387",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.833 10H4.167M10 15.833L4.167 10 10 4.167"
  })));
}

const styles$1m="s1tghci5";const SideMenuCard=({itemsMenu,currentIndex,HeaderComponent,children,onNavigationChange})=>{const[showNavigation,setShowNavigation]=useState(true);const currentItem=itemsMenu[currentIndex];return/*#__PURE__*/jsxs("div",{className:`${styles$1m}`,children:[/*#__PURE__*/jsxs("div",{className:`navigation ${showNavigation?'show-navigation':''}`,children:[HeaderComponent&&/*#__PURE__*/jsx("div",{className:"header-navigation",children:/*#__PURE__*/jsx(HeaderComponent,{})}),/*#__PURE__*/jsx("ul",{children:itemsMenu.map((menu,index)=>/*#__PURE__*/jsxs("li",{className:`${index===currentIndex?'active':''}`,onClick:()=>{setShowNavigation(false);onNavigationChange(index);},children:[/*#__PURE__*/jsxs("div",{children:[menu.icon&&/*#__PURE__*/jsx(menu.icon,{}),menu.text]}),/*#__PURE__*/jsx("div",{className:"arrow-icon",children:/*#__PURE__*/jsx(SvgRightArrow,{})})]},menu.id))})]}),/*#__PURE__*/jsx("div",{className:`content ${showNavigation?'show-navigation':''}`,children:/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsxs("div",{className:"menu-header",children:[/*#__PURE__*/jsx("div",{className:"header-content",children:/*#__PURE__*/jsxs("h2",{onClick:()=>setShowNavigation(true),children:[/*#__PURE__*/jsx("div",{className:"back-icon",children:/*#__PURE__*/jsx(SvgLeftArrow,{})}),/*#__PURE__*/jsxs("div",{children:[currentItem.text,/*#__PURE__*/jsx("p",{children:currentItem.description})]})]})}),/*#__PURE__*/jsx("div",{className:"actions"})]}),/*#__PURE__*/jsx("div",{className:"component",children:children[currentIndex]})]})})]});};SideMenuCard.defaultProps={idCurrent:'',HeaderComponent:undefined,navigationChangeCallback:()=>{}};

var _path$v;

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

function SvgCheckIcon(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$v || (_path$v = /*#__PURE__*/React$1.createElement("path", {
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
  })));
}

var _path$u;

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

function SvgArrowRight(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$H({
    viewBox: "0 0 22 80",
    fill: "currentcolor",
    preserveAspectRatio: "none"
  }, props), _path$u || (_path$u = /*#__PURE__*/React$1.createElement("path", {
    d: "M0-2l20 42L0 82",
    stroke: "#d2d6dc"
  })));
}

const styles$1l="s78e7ul";const NavigationSteps=({items,currentStep,onStepClick// completedSteps,
// activeSteps,
})=>{const currentIndex=items.findIndex(i=>i.id===currentStep);return/*#__PURE__*/jsx("nav",{className:styles$1l,children:/*#__PURE__*/jsx("ul",{children:items&&items.map((item,index)=>/*#__PURE__*/jsxs("li",{className:index<=currentIndex?index===currentIndex?'current':'completed':'to-complete',onClick:()=>onStepClick(item.id),children:[index>0&&/*#__PURE__*/jsx("div",{className:"arrow-right",children:/*#__PURE__*/jsx(SvgArrowRight,{})}),/*#__PURE__*/jsxs("div",{className:"item",children:[index!==0&&/*#__PURE__*/jsx("div",{className:"bar-container",children:/*#__PURE__*/jsx("div",{className:index<=currentIndex?'bar filled':'bar empty'})}),/*#__PURE__*/jsxs("div",{className:"item-content",children:[/*#__PURE__*/jsx("div",{className:"circle-container",children:index<currentIndex?/*#__PURE__*/jsx(SvgCheckIcon,{}):/*#__PURE__*/jsx("p",{children:index+1})}),/*#__PURE__*/jsxs("div",{className:"text-container",children:[/*#__PURE__*/jsx("p",{className:"step-name",children:item.name}),/*#__PURE__*/jsx("p",{className:"description",children:item.description})]})]})]})]},item.id))})});};NavigationSteps.defaultProps={currentStep:'',onStepClick:()=>{}};

const styles$1k="s1jov565";const Wizard=({navigationStepsProps,currentStep,children})=>{const currentIndex=navigationStepsProps.items.findIndex(item=>item.id===currentStep);return/*#__PURE__*/jsxs("div",{className:styles$1k,children:[/*#__PURE__*/jsx("div",{className:"bg"}),/*#__PURE__*/jsx(NavigationSteps,Object.assign({},navigationStepsProps)),children[currentIndex]]});};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MainMenu: MainMenu,
  MenuBanner: MenuBanner,
  TwoColumnCard: TwoColumnCard,
  Modal: Modal$1,
  SideMenuCard: SideMenuCard,
  Wizard: Wizard
});

const styles$1j="s1w4h6an";const Accordion=({id,title,content,unfolded})=>{return/*#__PURE__*/jsxs("div",{className:styles$1j,children:[/*#__PURE__*/jsx("input",{id:id,type:"checkbox",defaultChecked:unfolded}),/*#__PURE__*/jsx("label",{htmlFor:id,children:title}),/*#__PURE__*/jsx("div",{children:/*#__PURE__*/jsx("div",{children:content})})]});};Accordion.defaultProps={unfolded:false};

const styles$1i="s11aq4gt";const ActionCard=({title,subtitle,icon,items,buttonProps})=>/*#__PURE__*/jsxs("div",{className:cx(styles$1i),children:[/*#__PURE__*/jsxs("div",{className:"container-title",children:[/*#__PURE__*/jsx("div",{className:"icon",style:{backgroundImage:`url(${icon})`}}),/*#__PURE__*/jsxs("div",{className:"title",children:[/*#__PURE__*/jsx("h2",{children:title}),/*#__PURE__*/jsx("p",{children:subtitle})]})]}),/*#__PURE__*/jsxs("div",{className:"container-items",children:[/*#__PURE__*/jsx("ul",{children:items&&items.map(item=>/*#__PURE__*/jsx("li",{className:"option",children:/*#__PURE__*/jsx("div",{className:"text",children:item})},item))}),/*#__PURE__*/jsx(Button,Object.assign({},buttonProps))]})]});ActionCard.defaultProps={subtitle:'',buttonProps:{},items:[],icon:''};

const styles$1h="stdf8hn";const RadioList=({selectedID,items,onItemSelect,onNewItem,onItemRemove,addActionText,deleteActionText,withIcon})=>/*#__PURE__*/jsxs("div",{className:styles$1h,children:[/*#__PURE__*/jsx("ul",{children:items&&items.map(item=>/*#__PURE__*/jsx("li",{children:/*#__PURE__*/jsxs("label",{children:[withIcon&&item.icon,/*#__PURE__*/jsxs("p",{className:item.id===selectedID?'active':'',children:[item.name,Object.prototype.hasOwnProperty.call(item,'detail')&&/*#__PURE__*/jsx("span",{children:item.detail}),Object.prototype.hasOwnProperty.call(item,'detailExtra')&&/*#__PURE__*/jsx("span",{children:item.detailExtra})]}),/*#__PURE__*/jsx("input",{type:"radio",checked:item.id===selectedID,onChange:()=>onItemSelect(item)})]})},item.id))}),/*#__PURE__*/jsxs("div",{className:items.length?'':'empty',children:[onItemRemove&&items.length>0&&selectedID&&/*#__PURE__*/jsx("button",{type:"button",className:"delete",onClick:onItemRemove,children:deleteActionText}),onNewItem&&/*#__PURE__*/jsx("button",{type:"button",className:"add",onClick:onNewItem,children:addActionText})]})]});RadioList.defaultProps={selectedID:'',items:[],onItemSelect:()=>{},onNewItem:()=>{},onItemRemove:()=>{},addActionText:'',deleteActionText:'eliminar',withIcon:false};

const styles$1g="sh8suoy";const AddressList=({selected,addresses,onAddressSelect,onNewAddress,onAddressRemove})=>{return/*#__PURE__*/jsx("div",{className:styles$1g,children:addresses.length===0?/*#__PURE__*/jsx("button",{className:"empty-button",type:"submit",onClick:onNewAddress,children:"+ Agregar direcci\xF3n"}):/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("label",{htmlFor:"card-select"}),/*#__PURE__*/jsx("input",{id:"card-select",type:"checkbox",className:"hidden-input"}),/*#__PURE__*/jsxs("div",{className:"selected",children:[/*#__PURE__*/jsxs("div",{className:"details",children:[/*#__PURE__*/jsx("p",{children:selected.name}),/*#__PURE__*/jsx("p",{children:selected.detail}),/*#__PURE__*/jsx("p",{children:selected.detailExtra})]}),/*#__PURE__*/jsx("div",{className:"caret-holder",children:/*#__PURE__*/jsx("span",{className:"caret"})})]}),/*#__PURE__*/jsx("div",{className:"addresses",children:/*#__PURE__*/jsx(RadioList,{selectedID:selected.id,items:addresses,onItemSelect:onAddressSelect,onNewItem:onNewAddress,onItemRemove:onAddressRemove,addActionText:"Agregar direcci\xF3n"})})]})});};AddressList.defaultProps={selected:null,onAddressSelect:()=>{},onNewAddress:()=>{},onAddressRemove:()=>{}};

const _excluded$6=["onClick"];function _objectWithoutPropertiesLoose$7(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const styles$1f="s13u0k66";const ArrowButton=_ref=>{let{onClick}=_ref,rest=_objectWithoutPropertiesLoose$7(_ref,_excluded$6);return/*#__PURE__*/jsx("button",Object.assign({onClick:onClick,type:"button",className:styles$1f},rest,{children:/*#__PURE__*/jsxs("svg",{width:"21",height:"20",viewBox:"0 0 21 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[/*#__PURE__*/jsx("path",{d:"M4.94531 10H16.612",stroke:"currentColor",strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"}),/*#__PURE__*/jsx("path",{d:"M10.7793 4.16797L16.6126 10.0013L10.7793 15.8346",stroke:"currentColor",strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"})]})}));};

const styles$1e="siielxd";const Banner=({text,buttonProps,type})=>/*#__PURE__*/jsxs("div",{className:cx(styles$1e,type),children:[/*#__PURE__*/jsx("div",{className:"container-text",children:/*#__PURE__*/jsx("p",{children:text})}),Object.keys(buttonProps).length&&/*#__PURE__*/jsx("div",{className:"container-actions",children:/*#__PURE__*/jsx(Button,{onClick:buttonProps.onClick,role:type==='red'?'warn':'white',children:buttonProps.children})})]});Banner.defaultProps={buttonProps:{},type:'purple'};

var __exports$y = {}; var exports$j = __exports$y; var __module$y = { exports: __exports$y };
                    if (typeof module !== "undefined") for (var prop$y in module) { prop$y !== "exports" && (__module$y[prop$y] = module[prop$y]);}!function(t,e){"object"==typeof exports$j&&"undefined"!=typeof __module$y?__module$y.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e();}(undefined,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else {var i=t.name;v[i]=t,r=i;}return !n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));var dayjs = __module$y.exports;

var __require__import__0$6 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), dayjs, {
  'default': dayjs
}));

var __exports$x = {}; var exports$i = __exports$x; var __module$x = { exports: __exports$x };
                    if (typeof module !== "undefined") for (var prop$x in module) { prop$x !== "exports" && (__module$x[prop$x] = module[prop$x]);}!function(e,t){"object"==typeof exports$i&&"undefined"!=typeof __module$x?__module$x.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_isSameOrAfter=t();}(undefined,(function(){return function(e,t){t.prototype.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)};}}));var isSameOrAfter = __module$x.exports;

var __exports$w = {}; var exports$h = __exports$w; var __module$w = { exports: __exports$w };
                    if (typeof module !== "undefined") for (var prop$w in module) { prop$w !== "exports" && (__module$w[prop$w] = module[prop$w]);}!function(e,i){"object"==typeof exports$h&&"undefined"!=typeof __module$w?__module$w.exports=i():"function"==typeof define&&define.amd?define(i):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_isSameOrBefore=i();}(undefined,(function(){return function(e,i){i.prototype.isSameOrBefore=function(e,i){return this.isSame(e,i)||this.isBefore(e,i)};}}));var isSameOrBefore = __module$w.exports;

dayjs.extend(isSameOrAfter);dayjs.extend(isSameOrBefore);const styles$1d="s1b5nnjm";const Calendar=({from,to,setFrom,setTo})=>{const today=new Date();const locationProps={locale:'es-us',months:['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],weekdaysLong:['Lunes','Martes','Miercoles','Jueves','Viernes','Sabado','Domingo'],weekdaysShort:['D','L','M','M','J','V','S'],firstDayOfWeek:1,labels:{nextMonth:'Siguiente mes',previousMonth:'Mes Anterior'}};// const disabledDays = { before: today }
const modifiers={start:from,end:to};const selectedDays=[from,{from,to}];const handleResetClick=()=>{setFrom(null);setTo(null);};const isSelectingFirstDay=(start,end,day)=>{const isBeforeFirstDay=start&&dayjs(day).isSameOrBefore(dayjs(start));const isRangeSelected=start&&end;return !start||isBeforeFirstDay||isRangeSelected;};const handleDayClick=day=>{if(from&&to&&day>=from&&day<=to){handleResetClick();return;}if(dayjs(day).isSameOrAfter(dayjs(today),'day')){if(isSelectingFirstDay(from,to,day)){setFrom(day);setTo(null);}else {setTo(day);/*
        const range = {
          from,
          to: day,
        }
        onSelectedDate(range)
        */}}};return/*#__PURE__*/jsx("div",{className:styles$1d,children:/*#__PURE__*/jsx(DayPicker,{className:"Selectable",numberOfMonths:1// disabledDays={disabledDays}
,modifiers:modifiers,onDayClick:handleDayClick,selectedDays:selectedDays,locale:locationProps.locale,months:locationProps.months,weekdaysLong:locationProps.weekdaysLong,weekdaysShort:locationProps.weekdaysShort,firstDayOfWeek:1,labels:locationProps.labels})});};Calendar.defaultProps={from:null,to:null};

const styles$1c="smdvnng";const CardPayoff=({title,amount,extraTextTitle,extraTextDetail,type,onClickCard,disabled})=>{return/*#__PURE__*/jsxs("div",{className:styles$1c,onClick:onClickCard,children:[/*#__PURE__*/jsxs("div",{className:`data ${disabled?'disabled':''}`,children:[/*#__PURE__*/jsx("div",{className:`color-stripe ${type}`}),/*#__PURE__*/jsxs("div",{className:"text-detail",children:[/*#__PURE__*/jsx("p",{className:"title",children:title}),/*#__PURE__*/jsx("p",{className:"amount",children:amount}),extraTextTitle&&extraTextDetail&&/*#__PURE__*/jsxs("p",{className:"extra-text",children:[extraTextTitle,": ",extraTextDetail]})]})]}),/*#__PURE__*/jsx("div",{className:"arrow",children:/*#__PURE__*/jsx("span",{})})]});};CardPayoff.defaultProps={extraTextTitle:'',extraTextDetail:'',type:'yellow',onClickCard:()=>{},disabled:false};

const styles$1b="sceiwaj";const CardPayoffResume=({title,total,resumeText,quantity,type})=>{return/*#__PURE__*/jsx("div",{className:styles$1b,children:/*#__PURE__*/jsxs("div",{className:`data ${type}`,children:[/*#__PURE__*/jsxs("div",{children:[/*#__PURE__*/jsx("p",{className:"title",children:title}),/*#__PURE__*/jsx("p",{className:"amount",children:total})]}),/*#__PURE__*/jsxs("div",{className:"resume",children:[/*#__PURE__*/jsx("p",{children:resumeText}),/*#__PURE__*/jsx("p",{className:"resume-number",children:quantity})]})]})});};CardPayoffResume.defaultProps={type:'yellow',quantity:0};

const styles$1a="s1p94ohn";const CardPayoffTotal=({resumeText,quantity,total})=>{return/*#__PURE__*/jsxs("div",{className:styles$1a,children:[/*#__PURE__*/jsxs("div",{className:"header",children:[/*#__PURE__*/jsx("p",{children:resumeText}),/*#__PURE__*/jsx("p",{className:"purple-text",children:quantity})]}),/*#__PURE__*/jsxs("div",{className:"resume",children:[/*#__PURE__*/jsx("p",{children:"Total"}),/*#__PURE__*/jsx("p",{className:"purple-text total",children:total})]})]});};CardPayoffTotal.defaultProps={quantity:0};

const styles$19="s1s437ll";const CardPayoffDetail=({title,unfolded,details,total,totalColor})=>{const[unfoldDetails,setUnfoldDetails]=useState(unfolded);const toggleUnfoldDetails=()=>{setUnfoldDetails(!unfoldDetails);};return/*#__PURE__*/jsxs("div",{className:styles$19,children:[details.length>0?/*#__PURE__*/jsxs("div",{className:"header",onClick:toggleUnfoldDetails,children:[/*#__PURE__*/jsx("p",{children:title}),/*#__PURE__*/jsx("div",{className:"arrow",children:/*#__PURE__*/jsx("span",{className:unfoldDetails?'unfold':''})})]}):/*#__PURE__*/jsx("div",{className:"header",children:/*#__PURE__*/jsx("p",{children:title})}),/*#__PURE__*/jsx("div",{className:`details ${unfoldDetails?'show-details':''}`,children:/*#__PURE__*/jsx("ul",{children:details&&details.map(detail=>/*#__PURE__*/jsxs("li",{children:[/*#__PURE__*/jsx("div",{className:"name",children:detail.name}),/*#__PURE__*/jsxs("div",{className:`detail ${Math.sign(detail.amount)===-1?'negative':''}`,children:[/*#__PURE__*/jsx("span",{}),detail.amount]})]},`total-${detail.name}`))})}),/*#__PURE__*/jsxs("div",{className:"resume",children:[/*#__PURE__*/jsx("p",{children:"Subtotal"}),/*#__PURE__*/jsxs("p",{className:`total ${totalColor} ${Math.sign(total)===-1?'negative':''}`,children:[/*#__PURE__*/jsx("span",{}),total]})]})]});};CardPayoffDetail.defaultProps={unfolded:false,totalColor:'',details:[]};

const styles$18="s4xnte9";const CardSection=({title,subtitle,type,disabled,handleClick})=>{return/*#__PURE__*/jsx("div",{className:styles$18,onClick:handleClick,children:/*#__PURE__*/jsxs("div",{className:`card ${type} ${disabled?'disabled':''}`,children:[/*#__PURE__*/jsx("h2",{children:title}),/*#__PURE__*/jsx("p",{children:subtitle})]})});};CardSection.defaultProps={type:'primary',disabled:false,handleClick:()=>{}};

const styles$17="s125yg4l";const CardSectionAction=({title,ButtonText,type,handleClick,disabled})=>{return/*#__PURE__*/jsx("div",{className:styles$17,children:/*#__PURE__*/jsxs("div",{className:`card ${type} ${disabled?'disabled':''}`,children:[/*#__PURE__*/jsx("h2",{children:title}),/*#__PURE__*/jsx(Button,{onClick:handleClick,role:"primary",children:ButtonText})]})});};CardSectionAction.defaultProps={type:'primary',disabled:false};

var __exports$v = {}; var __module$v = { exports: __exports$v };
                    if (typeof module !== "undefined") for (var prop$v in module) { prop$v !== "exports" && (__module$v[prop$v] = module[prop$v]);}var characterMap = {
	"À": "A",
	"Á": "A",
	"Â": "A",
	"Ã": "A",
	"Ä": "A",
	"Å": "A",
	"Ấ": "A",
	"Ắ": "A",
	"Ẳ": "A",
	"Ẵ": "A",
	"Ặ": "A",
	"Æ": "AE",
	"Ầ": "A",
	"Ằ": "A",
	"Ȃ": "A",
	"Ç": "C",
	"Ḉ": "C",
	"È": "E",
	"É": "E",
	"Ê": "E",
	"Ë": "E",
	"Ế": "E",
	"Ḗ": "E",
	"Ề": "E",
	"Ḕ": "E",
	"Ḝ": "E",
	"Ȇ": "E",
	"Ì": "I",
	"Í": "I",
	"Î": "I",
	"Ï": "I",
	"Ḯ": "I",
	"Ȋ": "I",
	"Ð": "D",
	"Ñ": "N",
	"Ò": "O",
	"Ó": "O",
	"Ô": "O",
	"Õ": "O",
	"Ö": "O",
	"Ø": "O",
	"Ố": "O",
	"Ṍ": "O",
	"Ṓ": "O",
	"Ȏ": "O",
	"Ù": "U",
	"Ú": "U",
	"Û": "U",
	"Ü": "U",
	"Ý": "Y",
	"à": "a",
	"á": "a",
	"â": "a",
	"ã": "a",
	"ä": "a",
	"å": "a",
	"ấ": "a",
	"ắ": "a",
	"ẳ": "a",
	"ẵ": "a",
	"ặ": "a",
	"æ": "ae",
	"ầ": "a",
	"ằ": "a",
	"ȃ": "a",
	"ç": "c",
	"ḉ": "c",
	"è": "e",
	"é": "e",
	"ê": "e",
	"ë": "e",
	"ế": "e",
	"ḗ": "e",
	"ề": "e",
	"ḕ": "e",
	"ḝ": "e",
	"ȇ": "e",
	"ì": "i",
	"í": "i",
	"î": "i",
	"ï": "i",
	"ḯ": "i",
	"ȋ": "i",
	"ð": "d",
	"ñ": "n",
	"ò": "o",
	"ó": "o",
	"ô": "o",
	"õ": "o",
	"ö": "o",
	"ø": "o",
	"ố": "o",
	"ṍ": "o",
	"ṓ": "o",
	"ȏ": "o",
	"ù": "u",
	"ú": "u",
	"û": "u",
	"ü": "u",
	"ý": "y",
	"ÿ": "y",
	"Ā": "A",
	"ā": "a",
	"Ă": "A",
	"ă": "a",
	"Ą": "A",
	"ą": "a",
	"Ć": "C",
	"ć": "c",
	"Ĉ": "C",
	"ĉ": "c",
	"Ċ": "C",
	"ċ": "c",
	"Č": "C",
	"č": "c",
	"C̆": "C",
	"c̆": "c",
	"Ď": "D",
	"ď": "d",
	"Đ": "D",
	"đ": "d",
	"Ē": "E",
	"ē": "e",
	"Ĕ": "E",
	"ĕ": "e",
	"Ė": "E",
	"ė": "e",
	"Ę": "E",
	"ę": "e",
	"Ě": "E",
	"ě": "e",
	"Ĝ": "G",
	"Ǵ": "G",
	"ĝ": "g",
	"ǵ": "g",
	"Ğ": "G",
	"ğ": "g",
	"Ġ": "G",
	"ġ": "g",
	"Ģ": "G",
	"ģ": "g",
	"Ĥ": "H",
	"ĥ": "h",
	"Ħ": "H",
	"ħ": "h",
	"Ḫ": "H",
	"ḫ": "h",
	"Ĩ": "I",
	"ĩ": "i",
	"Ī": "I",
	"ī": "i",
	"Ĭ": "I",
	"ĭ": "i",
	"Į": "I",
	"į": "i",
	"İ": "I",
	"ı": "i",
	"Ĳ": "IJ",
	"ĳ": "ij",
	"Ĵ": "J",
	"ĵ": "j",
	"Ķ": "K",
	"ķ": "k",
	"Ḱ": "K",
	"ḱ": "k",
	"K̆": "K",
	"k̆": "k",
	"Ĺ": "L",
	"ĺ": "l",
	"Ļ": "L",
	"ļ": "l",
	"Ľ": "L",
	"ľ": "l",
	"Ŀ": "L",
	"ŀ": "l",
	"Ł": "l",
	"ł": "l",
	"Ḿ": "M",
	"ḿ": "m",
	"M̆": "M",
	"m̆": "m",
	"Ń": "N",
	"ń": "n",
	"Ņ": "N",
	"ņ": "n",
	"Ň": "N",
	"ň": "n",
	"ŉ": "n",
	"N̆": "N",
	"n̆": "n",
	"Ō": "O",
	"ō": "o",
	"Ŏ": "O",
	"ŏ": "o",
	"Ő": "O",
	"ő": "o",
	"Œ": "OE",
	"œ": "oe",
	"P̆": "P",
	"p̆": "p",
	"Ŕ": "R",
	"ŕ": "r",
	"Ŗ": "R",
	"ŗ": "r",
	"Ř": "R",
	"ř": "r",
	"R̆": "R",
	"r̆": "r",
	"Ȓ": "R",
	"ȓ": "r",
	"Ś": "S",
	"ś": "s",
	"Ŝ": "S",
	"ŝ": "s",
	"Ş": "S",
	"Ș": "S",
	"ș": "s",
	"ş": "s",
	"Š": "S",
	"š": "s",
	"Ţ": "T",
	"ţ": "t",
	"ț": "t",
	"Ț": "T",
	"Ť": "T",
	"ť": "t",
	"Ŧ": "T",
	"ŧ": "t",
	"T̆": "T",
	"t̆": "t",
	"Ũ": "U",
	"ũ": "u",
	"Ū": "U",
	"ū": "u",
	"Ŭ": "U",
	"ŭ": "u",
	"Ů": "U",
	"ů": "u",
	"Ű": "U",
	"ű": "u",
	"Ų": "U",
	"ų": "u",
	"Ȗ": "U",
	"ȗ": "u",
	"V̆": "V",
	"v̆": "v",
	"Ŵ": "W",
	"ŵ": "w",
	"Ẃ": "W",
	"ẃ": "w",
	"X̆": "X",
	"x̆": "x",
	"Ŷ": "Y",
	"ŷ": "y",
	"Ÿ": "Y",
	"Y̆": "Y",
	"y̆": "y",
	"Ź": "Z",
	"ź": "z",
	"Ż": "Z",
	"ż": "z",
	"Ž": "Z",
	"ž": "z",
	"ſ": "s",
	"ƒ": "f",
	"Ơ": "O",
	"ơ": "o",
	"Ư": "U",
	"ư": "u",
	"Ǎ": "A",
	"ǎ": "a",
	"Ǐ": "I",
	"ǐ": "i",
	"Ǒ": "O",
	"ǒ": "o",
	"Ǔ": "U",
	"ǔ": "u",
	"Ǖ": "U",
	"ǖ": "u",
	"Ǘ": "U",
	"ǘ": "u",
	"Ǚ": "U",
	"ǚ": "u",
	"Ǜ": "U",
	"ǜ": "u",
	"Ứ": "U",
	"ứ": "u",
	"Ṹ": "U",
	"ṹ": "u",
	"Ǻ": "A",
	"ǻ": "a",
	"Ǽ": "AE",
	"ǽ": "ae",
	"Ǿ": "O",
	"ǿ": "o",
	"Þ": "TH",
	"þ": "th",
	"Ṕ": "P",
	"ṕ": "p",
	"Ṥ": "S",
	"ṥ": "s",
	"X́": "X",
	"x́": "x",
	"Ѓ": "Г",
	"ѓ": "г",
	"Ќ": "К",
	"ќ": "к",
	"A̋": "A",
	"a̋": "a",
	"E̋": "E",
	"e̋": "e",
	"I̋": "I",
	"i̋": "i",
	"Ǹ": "N",
	"ǹ": "n",
	"Ồ": "O",
	"ồ": "o",
	"Ṑ": "O",
	"ṑ": "o",
	"Ừ": "U",
	"ừ": "u",
	"Ẁ": "W",
	"ẁ": "w",
	"Ỳ": "Y",
	"ỳ": "y",
	"Ȁ": "A",
	"ȁ": "a",
	"Ȅ": "E",
	"ȅ": "e",
	"Ȉ": "I",
	"ȉ": "i",
	"Ȍ": "O",
	"ȍ": "o",
	"Ȑ": "R",
	"ȑ": "r",
	"Ȕ": "U",
	"ȕ": "u",
	"B̌": "B",
	"b̌": "b",
	"Č̣": "C",
	"č̣": "c",
	"Ê̌": "E",
	"ê̌": "e",
	"F̌": "F",
	"f̌": "f",
	"Ǧ": "G",
	"ǧ": "g",
	"Ȟ": "H",
	"ȟ": "h",
	"J̌": "J",
	"ǰ": "j",
	"Ǩ": "K",
	"ǩ": "k",
	"M̌": "M",
	"m̌": "m",
	"P̌": "P",
	"p̌": "p",
	"Q̌": "Q",
	"q̌": "q",
	"Ř̩": "R",
	"ř̩": "r",
	"Ṧ": "S",
	"ṧ": "s",
	"V̌": "V",
	"v̌": "v",
	"W̌": "W",
	"w̌": "w",
	"X̌": "X",
	"x̌": "x",
	"Y̌": "Y",
	"y̌": "y",
	"A̧": "A",
	"a̧": "a",
	"B̧": "B",
	"b̧": "b",
	"Ḑ": "D",
	"ḑ": "d",
	"Ȩ": "E",
	"ȩ": "e",
	"Ɛ̧": "E",
	"ɛ̧": "e",
	"Ḩ": "H",
	"ḩ": "h",
	"I̧": "I",
	"i̧": "i",
	"Ɨ̧": "I",
	"ɨ̧": "i",
	"M̧": "M",
	"m̧": "m",
	"O̧": "O",
	"o̧": "o",
	"Q̧": "Q",
	"q̧": "q",
	"U̧": "U",
	"u̧": "u",
	"X̧": "X",
	"x̧": "x",
	"Z̧": "Z",
	"z̧": "z",
};

var chars = Object.keys(characterMap).join('|');
var allAccents = new RegExp(chars, 'g');
var firstAccent = new RegExp(chars, '');

var removeAccents = function(string) {	
	return string.replace(allAccents, function(match) {
		return characterMap[match];
	});
};

var hasAccents = function(string) {
	return !!string.match(firstAccent);
};

__module$v.exports = removeAccents;
__module$v.exports.has = hasAccents;
__module$v.exports.remove = removeAccents;
var removeAccents$1 = __module$v.exports;

var rankings = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
matchSorter.rankings = rankings;

var defaultBaseSortFn = function defaultBaseSortFn(a, b) {
  return String(a.rankedValue).localeCompare(String(b.rankedValue));
};
/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */


function matchSorter(items, value, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      keys = _options.keys,
      _options$threshold = _options.threshold,
      threshold = _options$threshold === void 0 ? rankings.MATCHES : _options$threshold,
      _options$baseSort = _options.baseSort,
      baseSort = _options$baseSort === void 0 ? defaultBaseSortFn : _options$baseSort,
      _options$sorter = _options.sorter,
      sorter = _options$sorter === void 0 ? function (matchedItems) {
    return matchedItems.sort(function (a, b) {
      return sortRankedValues(a, b, baseSort);
    });
  } : _options$sorter;
  var matchedItems = items.reduce(reduceItemsToRanked, []);
  return sorter(matchedItems).map(function (_ref) {
    var item = _ref.item;
    return item;
  });

  function reduceItemsToRanked(matches, item, index) {
    var rankingInfo = getHighestRanking(item, keys, value, options);
    var rank = rankingInfo.rank,
        _rankingInfo$keyThres = rankingInfo.keyThreshold,
        keyThreshold = _rankingInfo$keyThres === void 0 ? threshold : _rankingInfo$keyThres;

    if (rank >= keyThreshold) {
      matches.push(_extends$S({}, rankingInfo, {
        item: item,
        index: index
      }));
    }

    return matches;
  }
}
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */


function getHighestRanking(item, keys, value, options) {
  if (!keys) {
    // if keys is not specified, then we assume the item given is ready to be matched
    var stringItem = item;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: stringItem,
      rank: getMatchRanking(stringItem, value, options),
      keyIndex: -1,
      keyThreshold: options.threshold
    };
  }

  var valuesToRank = getAllValuesToRank(item, keys);
  return valuesToRank.reduce(function (_ref2, _ref3, i) {
    var rank = _ref2.rank,
        rankedValue = _ref2.rankedValue,
        keyIndex = _ref2.keyIndex,
        keyThreshold = _ref2.keyThreshold;
    var itemValue = _ref3.itemValue,
        attributes = _ref3.attributes;
    var newRank = getMatchRanking(itemValue, value, options);
    var newRankedValue = rankedValue;
    var minRanking = attributes.minRanking,
        maxRanking = attributes.maxRanking,
        threshold = attributes.threshold;

    if (newRank < minRanking && newRank >= rankings.MATCHES) {
      newRank = minRanking;
    } else if (newRank > maxRanking) {
      newRank = maxRanking;
    }

    if (newRank > rank) {
      rank = newRank;
      keyIndex = i;
      keyThreshold = threshold;
      newRankedValue = itemValue;
    }

    return {
      rankedValue: newRankedValue,
      rank: rank,
      keyIndex: keyIndex,
      keyThreshold: keyThreshold
    };
  }, {
    rankedValue: item,
    rank: rankings.NO_MATCH,
    keyIndex: -1,
    keyThreshold: options.threshold
  });
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */


function getMatchRanking(testString, stringToRank, options) {
  testString = prepareValueForComparison(testString, options);
  stringToRank = prepareValueForComparison(stringToRank, options); // too long

  if (stringToRank.length > testString.length) {
    return rankings.NO_MATCH;
  } // case sensitive equals


  if (testString === stringToRank) {
    return rankings.CASE_SENSITIVE_EQUAL;
  } // Lower casing before further comparison


  testString = testString.toLowerCase();
  stringToRank = stringToRank.toLowerCase(); // case insensitive equals

  if (testString === stringToRank) {
    return rankings.EQUAL;
  } // starts with


  if (testString.startsWith(stringToRank)) {
    return rankings.STARTS_WITH;
  } // word starts with


  if (testString.includes(" " + stringToRank)) {
    return rankings.WORD_STARTS_WITH;
  } // contains


  if (testString.includes(stringToRank)) {
    return rankings.CONTAINS;
  } else if (stringToRank.length === 1) {
    // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
  } // acronym


  if (getAcronym(testString).includes(stringToRank)) {
    return rankings.ACRONYM;
  } // will return a number between rankings.MATCHES and
  // rankings.MATCHES + 1 depending  on how close of a match it is.


  return getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */


function getAcronym(string) {
  var acronym = '';
  var wordsInString = string.split(' ');
  wordsInString.forEach(function (wordInString) {
    var splitByHyphenWords = wordInString.split('-');
    splitByHyphenWords.forEach(function (splitByHyphenWord) {
      acronym += splitByHyphenWord.substr(0, 1);
    });
  });
  return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */


function getClosenessRanking(testString, stringToRank) {
  var matchingInOrderCharCount = 0;
  var charNumber = 0;

  function findMatchingCharacter(matchChar, string, index) {
    for (var j = index, J = string.length; j < J; j++) {
      var stringChar = string[j];

      if (stringChar === matchChar) {
        matchingInOrderCharCount += 1;
        return j + 1;
      }
    }

    return -1;
  }

  function getRanking(spread) {
    var spreadPercentage = 1 / spread;
    var inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
    var ranking = rankings.MATCHES + inOrderPercentage * spreadPercentage;
    return ranking;
  }

  var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);

  if (firstIndex < 0) {
    return rankings.NO_MATCH;
  }

  charNumber = firstIndex;

  for (var i = 1, I = stringToRank.length; i < I; i++) {
    var matchChar = stringToRank[i];
    charNumber = findMatchingCharacter(matchChar, testString, charNumber);
    var found = charNumber > -1;

    if (!found) {
      return rankings.NO_MATCH;
    }
  }

  var spread = charNumber - firstIndex;
  return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */


function sortRankedValues(a, b, baseSort) {
  var aFirst = -1;
  var bFirst = 1;
  var aRank = a.rank,
      aKeyIndex = a.keyIndex;
  var bRank = b.rank,
      bKeyIndex = b.keyIndex;
  var same = aRank === bRank;

  if (same) {
    if (aKeyIndex === bKeyIndex) {
      // use the base sort function as a tie-breaker
      return baseSort(a, b);
    } else {
      return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    }
  } else {
    return aRank > bRank ? aFirst : bFirst;
  }
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */


function prepareValueForComparison(value, _ref4) {
  var keepDiacritics = _ref4.keepDiacritics;
  // value might not actually be a string at this point (we don't get to choose)
  // so part of preparing the value for comparison is ensure that it is a string
  value = "" + value; // toString

  if (!keepDiacritics) {
    value = removeAccents$1(value);
  }

  return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */


function getItemValues(item, key) {
  if (typeof key === 'object') {
    key = key.key;
  }

  var value;

  if (typeof key === 'function') {
    value = key(item);
  } else if (item == null) {
    value = null;
  } else if (Object.hasOwnProperty.call(item, key)) {
    value = item[key];
  } else if (key.includes('.')) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return getNestedValues(key, item);
  } else {
    value = null;
  } // because `value` can also be undefined


  if (value == null) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [String(value)];
}
/**
 * Given path: "foo.bar.baz"
 * And item: {foo: {bar: {baz: 'buzz'}}}
 *   -> 'buzz'
 * @param path a dot-separated set of keys
 * @param item the item to get the value from
 */


function getNestedValues(path, item) {
  var keys = path.split('.');
  var values = [item];

  for (var i = 0, I = keys.length; i < I; i++) {
    var nestedKey = keys[i];
    var nestedValues = [];

    for (var j = 0, J = values.length; j < J; j++) {
      var nestedItem = values[j];
      if (nestedItem == null) continue;

      if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
        var nestedValue = nestedItem[nestedKey];

        if (nestedValue != null) {
          nestedValues.push(nestedValue);
        }
      } else if (nestedKey === '*') {
        // ensure that values is an array
        nestedValues = nestedValues.concat(nestedItem);
      }
    }

    values = nestedValues;
  }

  if (Array.isArray(values[0])) {
    // keep allowing the implicit wildcard for an array of strings at the end of
    // the path; don't use `.flat()` because that's not available in node.js v10
    var result = [];
    return result.concat.apply(result, values);
  } // Based on our logic it should be an array of strings by now...
  // assuming the user's path terminated in strings


  return values;
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */


function getAllValuesToRank(item, keys) {
  var allValues = [];

  for (var j = 0, J = keys.length; j < J; j++) {
    var key = keys[j];
    var attributes = getKeyAttributes(key);
    var itemValues = getItemValues(item, key);

    for (var i = 0, I = itemValues.length; i < I; i++) {
      allValues.push({
        itemValue: itemValues[i],
        attributes: attributes
      });
    }
  }

  return allValues;
}

var defaultKeyAttributes = {
  maxRanking: Infinity,
  minRanking: -Infinity
};
/**
 * Gets all the attributes for the given key
 * @param key - the key from which the attributes will be retrieved
 * @return object containing the key's attributes
 */

function getKeyAttributes(key) {
  if (typeof key === 'string') {
    return defaultKeyAttributes;
  }

  return _extends$S({}, defaultKeyAttributes, key);
}

const styles$16="s39tkxp";/*
const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef()
  const resolvedRef = ref || defaultRef

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate
  }, [resolvedRef, indeterminate])

  return (
    <div className="indeterminate-checkbox">
      <label>
        <input
          type="checkbox"
          ref={resolvedRef}
          className="opacity-0 absolute"
          {...rest}
        />
        <div className="check">
          <svg viewBox="0 0 20 20">
            <path fill="#FFF" d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        </div>
        <div className="plus">+</div>
      </label>
    </div>
  )
})
*/function fuzzyTextFilterFn$3(rows,id,filterValue){return matchSorter(rows,filterValue,{keys:[row=>row.values[id]]});}fuzzyTextFilterFn$3.autoRemove=val=>!val;const CategorySelector$1=({data,accessor,agregator,imageAccessor,idAccessor,selectedRows,setSelectedRows,searchPlaceholder:_searchPlaceholder=''})=>{const[isOpen,setOpen]=useState(false);// const [selectedRow, setSelectedRow] = useState(0)
const node=useRef();const handleClickOutside=e=>{if(!node.current.contains(e.target)){// close on click outside
setOpen(false);}};useEffect(()=>{document.addEventListener('mousedown',handleClickOutside);return ()=>{document.removeEventListener('mousedown',handleClickOutside);};},[]);const filterTypes=React__default.useMemo(()=>({fuzzyText:fuzzyTextFilterFn$3/*
    text: (rows, id, filterValue) => {
      return rows.filter((row) => {
        const rowValue = row.values[id]
        return rowValue !== undefined
          ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
          : true
      })
    },
    */}),[]);const columns=React__default.useMemo(()=>[{Header:'Accessor',accessor,filter:'fuzzyText',InnerCell:({value,row:{original}})=>/*#__PURE__*/jsxs("div",{className:"name-row",children:[/*#__PURE__*/jsx("div",{className:"image",children:original[imageAccessor]?/*#__PURE__*/jsx("img",{src:original[imageAccessor]}):/*#__PURE__*/jsx("img",{src:"/images/unnamed.png"})}),/*#__PURE__*/jsx("span",{children:value})]})},{Header:'Agregator',accessor:agregator,isGrouped:true,Filter:false},{Header:'Selected',accessor:idAccessor,InnerCell:({row:{original}})=>/*#__PURE__*/jsx("div",{className:"indeterminate-checkbox",children:/*#__PURE__*/jsxs("label",{children:[/*#__PURE__*/jsx("input",{type:"checkbox",className:"opacity-0 absolute",checked:typeof selectedRows.find(selectedRow=>selectedRow[idAccessor]===original[idAccessor])!=='undefined',onChange:event=>{if(event.target.checked){setSelectedRows(oldRows=>[...oldRows,Object.assign({},original,{quantity:1})]);}else {setSelectedRows([...selectedRows.filter(row=>original[idAccessor]!==row[idAccessor])]);}}}),/*#__PURE__*/jsx("div",{className:"check",children:/*#__PURE__*/jsx("svg",{viewBox:"0 0 20 20",children:/*#__PURE__*/jsx("path",{fill:"#FFF",d:"M0 11l2-2 5 5L18 3l2 2L7 18z"})})}),/*#__PURE__*/jsx("div",{className:"plus",children:"+"})]})})}],[selectedRows]);const defaultColumn=React__default.useMemo(()=>({Filter:({column:{filterValue,setFilter}})=>/*#__PURE__*/jsx("input",{value:filterValue||'',onChange:e=>setFilter(e.target.value||undefined),onFocus:()=>setOpen(true),placeholder:_searchPlaceholder}),Cell:({value})=>value||'',InnerCell:({value})=>/*#__PURE__*/jsx("span",{children:value})}),[]);const{headerGroups,prepareRow,rows}=useTable({columns,data,defaultColumn,filterTypes,disableMultiSort:true,initialState:{groupBy:[agregator]}},useFilters,useGroupBy,useExpanded);const Row=React__default.useCallback(({index,style})=>{const row=rows[index];prepareRow(row);return/*#__PURE__*/jsx("label",Object.assign({tabIndex:"1",className:cx({row:row.isGrouped,'inner-row':!row.isGrouped,expanded:row.isExpanded})},row.getRowProps({style}),{children:row.cells.map(cell=>{const rowProps=row.getToggleRowExpandedProps();const cellProps=cell.getCellProps();rowProps.title='';return/*#__PURE__*/jsxs(React__default.Fragment,{children:[cell.isGrouped&&/*#__PURE__*/jsxs("div",Object.assign({className:"cell"},cellProps,rowProps,{children:[/*#__PURE__*/jsx("span",{className:cx({caret:true,'caret-open':row.isExpanded})}),cell.render('Cell')," ",`(${row.subRows.length})`]})),!cell.isGrouped&&!cell.isAggregated&&!cell.isPlaceholder&&/*#__PURE__*/jsx("div",Object.assign({className:"cell"},cellProps,{children:cell.render('InnerCell')}))]},`cell-${row.id}-${cell.column.id}`);})}),`row-${index}`);},[prepareRow,rows]);// force pick the second column
const column=headerGroups[0].headers[1];return/*#__PURE__*/jsxs("div",{ref:node,className:cx(styles$16,{open:isOpen}),tabIndex:"0",children:[/*#__PURE__*/jsxs("div",{className:"search-box",children:[column.render('Filter'),/*#__PURE__*/jsx("svg",{viewBox:"0 0 56.966 56.966",children:/*#__PURE__*/jsx("path",{d:"M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"})})]}),isOpen?/*#__PURE__*/jsx("div",{className:"drop-down",children:/*#__PURE__*/jsx(FixedSizeList,{height:200,itemCount:rows.length,itemSize:45,children:Row})}):null]});};

var _path$t;

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

function SvgSearch$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$G({
    viewBox: "0 0 56.966 56.966"
  }, props), _path$t || (_path$t = /*#__PURE__*/React$1.createElement("path", {
    d: "M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z"
  })));
}

const styles$15="s8fccj0";const buttonStyles="b1ooy32o";function fuzzyTextFilterFn$2(rows,id,filterValue){return matchSorter(rows,filterValue,{keys:[row=>row.values[id]]});}fuzzyTextFilterFn$2.autoRemove=val=>!val;const IndeterminateCheckbox=({checked,onChange})=>/*#__PURE__*/jsx("div",{className:"indeterminate-checkbox",children:/*#__PURE__*/jsx("label",{children:/*#__PURE__*/jsx("input",{type:"checkbox",className:"opacity-0 absolute",checked:checked,onChange:onChange})})});const CategorySelector=({data,accessor,agregator,imageAccessor,idAccessor,searchPlaceholder:_searchPlaceholder='',moneyFormattingFunction:_moneyFormattingFunction=value=>value,onSelect:_onSelect=()=>{},preSelectedItems:_preSelectedItems=[]})=>{const[isOpen,setOpen]=useState(false);const[selectedItems,setSelectedItems]=useState();const node=useRef();useEffect(()=>setSelectedItems(_preSelectedItems.map(p=>p.productId)),[_preSelectedItems]);const filterTypes=React__default.useMemo(()=>({fuzzyText:fuzzyTextFilterFn$2}),[]);const columns=React__default.useMemo(()=>[{Header:'Accessor',accessor,filter:'fuzzyText',InnerCell:({row:{original},formatMoney})=>/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("div",{className:"image",children:original[imageAccessor]?/*#__PURE__*/jsx("img",{src:original[imageAccessor]}):/*#__PURE__*/jsx("img",{src:"/images/unnamed.png"})}),/*#__PURE__*/jsx("span",{className:"name",children:original.name}),/*#__PURE__*/jsx("span",{className:"price",children:formatMoney(original.price)})]})},{Header:'Agregator',accessor:agregator,isGrouped:true,Filter:false,CatCheckbox:({row})=>{const category=row.groupByVal;const categoryItems=data.filter(d=>d.collection===category).map(c=>c.productId);const isChecked=categoryItems.every(e=>selectedItems.indexOf(e)>-1);return/*#__PURE__*/jsx(IndeterminateCheckbox,{checked:isChecked,onChange:()=>{if(!isChecked){// check all items
setSelectedItems(items=>[...items,...categoryItems]);}else {// check all items
setSelectedItems(items=>items.filter(item=>categoryItems.indexOf(item)===-1));}}});}},{Header:'Selected',accessor:idAccessor,InnerCell:({row:{original}})=>/*#__PURE__*/jsx(IndeterminateCheckbox,{checked:selectedItems.indexOf(original.productId)>-1,onChange:()=>{const index=selectedItems.indexOf(original.productId);if(index===-1){setSelectedItems(items=>[...items,original.productId]);}else {setSelectedItems(items=>items.slice(0,index).concat(selectedItems.slice(index+1)));}}})}],[data,selectedItems,idAccessor]);const defaultColumn=React__default.useMemo(()=>({Filter:({column:{filterValue,setFilter}})=>/*#__PURE__*/jsx("input",{value:filterValue||'',onChange:e=>setFilter(e.target.value||undefined),onFocus:()=>setOpen(true),placeholder:_searchPlaceholder}),Cell:({value})=>value||'',CatCheckbox:()=>'',InnerCell:({value})=>/*#__PURE__*/jsx("span",{children:value})}),[]);const{headerGroups,prepareRow,rows}=useTable({columns,data,defaultColumn,filterTypes,disableMultiSort:true,initialState:{groupBy:[agregator]},// other attributes
formatMoney:_moneyFormattingFunction},useFilters,useGroupBy,useExpanded);const Row=React__default.useCallback(({index,style})=>{const row=rows[index];prepareRow(row);return/*#__PURE__*/jsx("label",Object.assign({tabIndex:"1",className:cx({row:row.isGrouped,'inner-row':!row.isGrouped,expanded:row.isExpanded})},row.getRowProps({style}),{children:row.cells.map(cell=>{const rowProps=row.getToggleRowExpandedProps();const cellProps=cell.getCellProps();rowProps.title='';return/*#__PURE__*/jsxs("div",{children:[cell.isGrouped&&/*#__PURE__*/jsxs("div",{className:"cell-wrapper",children:[/*#__PURE__*/jsxs("div",Object.assign({className:"cell"},cellProps,rowProps,{children:[/*#__PURE__*/jsx("span",{className:cx({caret:true,'caret-open':row.isExpanded})}),cell.render('Cell'),' ',`(${row.subRows.length})`]})),cell.render('CatCheckbox')]}),!cell.isGrouped&&!cell.isAggregated&&!cell.isPlaceholder&&/*#__PURE__*/jsx("div",Object.assign({className:"cell"},cellProps,{children:cell.render('InnerCell')}))]},`cell-${row.id}-${cell.column.id}`);})}),`row-${index}`);},[prepareRow,rows]);const handleClose=()=>{setOpen(false);};const handleContinue=()=>{_onSelect(selectedItems);setOpen(false);};const handleClickOutside=e=>{if(node.current&&!node.current.contains(e.target)){handleClose();}};useEffect(()=>{document.addEventListener('mousedown',handleClickOutside);return ()=>{document.removeEventListener('mousedown',handleClickOutside);};},[]);const column=headerGroups[0].headers[1];return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("div",{className:buttonStyles,children:/*#__PURE__*/jsxs(Button,{role:"secondary",onClick:()=>{setOpen(true);},children:["Agregar productos",/*#__PURE__*/jsx(SvgSearch$1,{})]})}),isOpen&&/*#__PURE__*/jsx(Portal,{children:/*#__PURE__*/jsx("div",{className:styles$15,tabIndex:"0",children:/*#__PURE__*/jsxs("div",{className:"content",ref:node,children:[/*#__PURE__*/jsxs("header",{children:[/*#__PURE__*/jsx("h1",{children:"Agregar productos"}),/*#__PURE__*/jsx("a",{onClick:handleClose,children:"\xD7"})]}),/*#__PURE__*/jsxs("main",{children:[/*#__PURE__*/jsxs("div",{className:"search-box",children:[column.render('Filter'),/*#__PURE__*/jsx(SvgSearch$1,{})]}),/*#__PURE__*/jsx(FixedSizeList,{height:500,itemCount:rows.length,itemSize:75,children:Row})]}),/*#__PURE__*/jsxs("footer",{children:[/*#__PURE__*/jsxs("div",{className:"total",children:[selectedItems.length," producto",selectedItems.length!==1&&'s'," seleccionado",selectedItems.length!==1&&'s']}),/*#__PURE__*/jsxs("div",{className:"buttons",children:[/*#__PURE__*/jsx("div",{className:"spacer"}),/*#__PURE__*/jsx(Button,{type:"outline",onClick:handleClose,children:"Cancelar"}),/*#__PURE__*/jsx(Button,{onClick:handleContinue,children:"Continuar"})]})]})]})})})]});};

const styles$14="sxtky4v";const Checkbox=({label,name,checked,onClick,disabled,type,icon,iconPosition,value})=>/*#__PURE__*/jsxs("div",{className:styles$14,children:[icon?/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("img",{src:icon,className:iconPosition==='left'?'image left':'image right'}),/*#__PURE__*/jsx("input",{id:`input-${name}`,name:name,type:"checkbox",className:iconPosition==='left'?`${type} right`:`${type} left`,checked:checked,onChange:onClick,disabled:disabled,value:value})]}):/*#__PURE__*/jsx("input",{id:`input-${name}`,name:name,type:"checkbox",className:type,checked:checked,onChange:onClick,disabled:disabled,value:value}),/*#__PURE__*/jsx("label",{htmlFor:`input-${name}`,className:`label-${type}`,children:label})]});Checkbox.defaultProps={label:'',checked:false,disabled:false,value:'',icon:'',iconPosition:'left',type:'secondary'};

const styles$13="s5q9yge";const CheckboxList=({items,checkboxSelected,handleCheckItem,addItemText,onAddItem,enableActions,handleDeleteItem,handleEditElement})=>{return/*#__PURE__*/jsxs("div",{className:styles$13,children:[/*#__PURE__*/jsx("ul",{children:items&&items.map(item=>/*#__PURE__*/jsxs("li",{className:"option",children:[/*#__PURE__*/jsx(Checkbox,{label:item.target?/*#__PURE__*/jsx("a",{href:item.target,rel:"noreferrer",target:"_blank",children:item.name}):item.name,name:`${item.id}`,checked:checkboxSelected.includes(item.id),onClick:()=>handleCheckItem(item.id),disabled:item.disabled||false}),enableActions&&!item.default?/*#__PURE__*/jsxs("div",{className:"option-actions",children:[/*#__PURE__*/jsx("a",{onClick:handleDeleteItem,children:"Borrar"}),/*#__PURE__*/jsx("a",{onClick:handleEditElement,children:"Editar"})]}):null]},item.id))}),addItemText?/*#__PURE__*/jsx("p",{className:"add-option",children:/*#__PURE__*/jsx("a",{onClick:onAddItem,children:addItemText})}):null]});};CheckboxList.defaultProps={items:[],checkboxSelected:[],handleCheckItem:()=>{},addItemText:'',onAddItem:()=>{},enableActions:false,handleDeleteItem:()=>{},handleEditElement:()=>{}};

const CompleteState=({children,data,activeStepIndex,onBack,onNext})=>/*#__PURE__*/jsx(Fragment,{children:children.map((child,index)=>activeStepIndex===index?/*#__PURE__*/React__default.cloneElement(child,{// eslint-disable-next-line react/no-array-index-key
key:`complete-state-${index}`,stepIndex:index,activeStepIndex,onNext,onBack,stepsLength:children.length,data}):null)});CompleteState.defaultProps={onNext:()=>{},onBack:()=>{}};

const styles$12="s1en97ts";const CompleteStateStep=({children,stepIndex,onSubmit,onBack,// canSkip,
isValid,title,description,Image,stepsLength,infoLink,loading})=>/*#__PURE__*/jsxs("div",{className:styles$12,children:[/*#__PURE__*/jsxs("div",{className:"col-1",children:[stepIndex?/*#__PURE__*/jsx(ArrowButton,{onClick:onBack,disabled:loading}):/*#__PURE__*/jsx("div",{className:"placeholder-arrow"}),Image&&/*#__PURE__*/jsx(Image,{}),/*#__PURE__*/jsxs("div",{className:"text-container",children:[/*#__PURE__*/jsx("p",{className:"steps-count",children:stepIndex+1!==stepsLength&&/*#__PURE__*/jsxs(Fragment,{children:[stepIndex+1," DE ",stepsLength-1]})}),/*#__PURE__*/jsx("h1",{className:"title",children:title}),/*#__PURE__*/jsx("p",{className:"description",children:description}),infoLink&&/*#__PURE__*/jsx("a",{className:"more-info",href:infoLink,target:"_blank",rel:"noreferrer",children:"M\xE1s informaci\xF3n"})]})]}),/*#__PURE__*/jsxs("div",{className:`col-2 ${stepIndex+1===stepsLength?'success':''}`,children:[/*#__PURE__*/jsx("div",{className:"section-container",children:children}),/*#__PURE__*/jsx("div",{className:"btn-container",children:/*#__PURE__*/jsx(Button,{className:"save",onClick:onSubmit,htmlProps:{disabled:loading||!isValid},loading:loading,children:"Guardar y Continuar >"})})]})]});CompleteStateStep.defaultProps={onSubmit:()=>{},onBack:()=>{},// canSkip: false,
// currentStep: '',
infoLink:null,isValid:true,Image:null,loading:false};

var _g$9;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

function SvgCircularIconTrash(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61"
  }, props), _g$9 || (_g$9 = /*#__PURE__*/React$1.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React$1.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "#FFE8E8"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#FF4F4F",
    fillRule: "nonzero",
    d: "M32.8 15c.906 0 1.642.737 1.642 1.643v1.813h5.568c.796 0 1.502.508 1.754 1.264l.662 1.986a1.488 1.488 0 01-1.41 1.956h-.383l-1.524 18.844A2.725 2.725 0 0136.408 45H24.404a2.726 2.726 0 01-2.702-2.494l-1.524-18.844h-.692a1.489 1.489 0 01-1.41-1.957l.662-1.985a1.849 1.849 0 011.755-1.264h5.567v-1.813c0-.906.737-1.643 1.642-1.643zm6.07 8.662H21.941l1.512 18.702c.04.493.457.878.95.878h12.004c.492 0 .91-.385.949-.878l1.512-18.702zm-3.4 1.041a.88.88 0 01.832.924l-.825 15.843a.878.878 0 01-.877.833h-.046a.88.88 0 01-.832-.924l.825-15.844a.877.877 0 01.923-.832zm-10.44 0a.878.878 0 01.925.83l.865 15.844a.879.879 0 01-.83.925l-.049.001a.88.88 0 01-.877-.83L24.2 25.628a.88.88 0 01.83-.926zm5.231-.001c.485 0 .879.393.879.879v15.843a.88.88 0 11-1.758 0V25.581a.88.88 0 01.879-.88zm9.749-4.489H20.493a.092.092 0 00-.087.063l-.543 1.628H40.64l-.544-1.628a.091.091 0 00-.086-.063zm-7.325-3.455h-4.867v1.698h4.867v-1.698z"
  }))));
}

var _g$8;

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

function SvgCircularIconCheck(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React$1.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React$1.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D5F8F3"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#06AA90",
    fillRule: "nonzero",
    d: "M13.913 19.783a.65.65 0 01-.463.192.65.65 0 01-.463-.192l-3.7-3.7a.983.983 0 010-1.389l.464-.463a.983.983 0 011.39 0l2.309 2.31 6.24-6.24a.983.983 0 011.39 0l.463.463a.983.983 0 010 1.39l-7.63 7.63z"
  }))));
}

var _g$7;

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

function SvgCircularIconQuestion(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React$1.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React$1.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "#d3d4ed"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#5b1a8a",
    d: "M33.981 41.95a3.248 3.248 0 11-6.497 0 3.252 3.252 0 013.249-3.25 3.247 3.247 0 013.248 3.25zM30.835 14c-5.237 0-9.178 3.5-9.178 10.4H26.8c0-2.995 1.178-5.446 3.931-5.446 1.621 0 3.341 1.077 3.49 3.135.16 2.165-.998 3.264-2.46 4.656-3.802 3.614-3.661 5.264-3.661 9.355h5.126c0-1.888-.204-3.26 2.39-6.057 1.73-1.866 3.88-4.188 3.926-7.726.061-5.151-3.576-8.317-8.706-8.317z"
  }))));
}

const styles$11="s11e9g0";const ConfirmAction=({type,title,confirmText,description,cancelText,onCancel,acceptText,acceptButtonRole,disableAccept,onAccept,acceptLoading,show,timeout,children,showActions})=>{const notificationClasses=cx(styles$11,type);const Icon=()=>{// TODO: implement other types
switch(type){case'none':return/*#__PURE__*/jsx("div",{});case'success':return/*#__PURE__*/jsx(SvgCircularIconCheck,{});case'question':return/*#__PURE__*/jsx(SvgCircularIconQuestion,{});default:return/*#__PURE__*/jsx(SvgCircularIconTrash,{});}};return/*#__PURE__*/jsx(CSSTransition,{in:show,mountOnEnter:true,unmountOnExit:true,timeout:{enter:timeout,exit:300},classNames:"notification",children:/*#__PURE__*/jsx("div",{className:notificationClasses,children:/*#__PURE__*/jsxs("div",{className:"content",children:[/*#__PURE__*/jsx("div",{className:"container-icon",children:/*#__PURE__*/jsx(Icon,{})}),/*#__PURE__*/jsxs("div",{className:"container-text",children:[/*#__PURE__*/jsx("p",{className:"title",children:title}),/*#__PURE__*/jsx("p",{className:"description",children:description}),/*#__PURE__*/jsx("p",{className:"message",children:confirmText}),children&&/*#__PURE__*/jsx("div",{className:"child",children:children}),showActions&&/*#__PURE__*/jsxs("div",{className:"actions",children:[/*#__PURE__*/jsx(Button,{label:"cancel",onClick:onCancel,type:"outline",children:cancelText}),/*#__PURE__*/jsx(Button,{label:acceptText,onClick:onAccept,type:"primary",role:acceptButtonRole,htmlProps:{disabled:acceptLoading||disableAccept},loading:acceptLoading,children:acceptText})]})]})]})})});};ConfirmAction.defaultProps={title:'',children:null,confirmText:'',onCancel:()=>{},onAccept:()=>{},cancelText:'cancelar',acceptText:'aceptar',disableAccept:false,show:false,timeout:3000,description:'',acceptButtonRole:'primary',acceptLoading:false,showActions:true};

const styles$10="s3g43s";const CopyText=({children})=>{const[copied,setCopied]=useState(false);useEffect(()=>{setCopied(false);},[children]);const isArray=children.length>1;const getValue=object=>{if(isArray){const result=object.find(item=>item.props.type==='textarea');return result.props.value||result.props.children;}const{props}=object;return props.value||props.children;};const copyLink=async()=>{setCopied(true);if(navigator.clipboard){await navigator.clipboard.writeText(getValue(children));setCopied(true);}else {try{const el=document.getElementById('copy-me');el.focus();const oldContentEditable=el.contentEditable;const oldReadOnly=el.readOnly;const range=document.createRange();el.contentEditable=true;el.readOnly=false;range.selectNodeContents(el);const s=window.getSelection();s.removeAllRanges();s.addRange(range);el.setSelectionRange(0,999999);el.contentEditable=oldContentEditable;el.readOnly=oldReadOnly;if(document.execCommand('copy')){setCopied(true);}}catch(err){// eslint-disable-next-line no-console
console.error('could not copy');}}};return/*#__PURE__*/jsxs("div",{className:styles$10,children:[/*#__PURE__*/jsxs("div",{className:"link",children:[isArray&&/*#__PURE__*/jsx("div",{className:"form",children:children.filter(item=>item.props.type!=='textarea')}),/*#__PURE__*/jsxs("div",{className:"embed",onClick:copyLink,children:[isArray?children.filter(item=>item.props.type==='textarea'):children,copied?/*#__PURE__*/jsx("div",{className:"icon check",children:"\u2713"}):/*#__PURE__*/jsx("div",{className:"icon copy",children:"\u2398"})]})]}),/*#__PURE__*/jsx(Button,{onClick:copyLink,role:"secondary",children:copied?'Copiado':'Copiar en portapapeles'})]});};

const styles$$="sy6zw6m";const DashboardChart=({data,rowHeight,title,formattedTotalAmount,totalCount})=>{const svgContainer=useRef();const opts={stretch:true,onlyInteger:true,showPoint:false,showArea:true,// lineSmooth: Chartist.Interpolation.none(),
showGrid:true,height:`${data.series[0].length*rowHeight+25}px`,axisY:{scaleMinSpace:30,low:0,divisor:6,onlyInteger:true},axisX:{scaleMinSpace:30}};const updateHeight=()=>{const chartSvg=document.getElementsByClassName('ct-chart-line')[0];if(chartSvg){const svgHeight=chartSvg.getAttribute('height').match(/(\d+)/)[0];const bottomMargin=window.innerWidth<768?50:10;chartSvg.style.height=`${parseInt(svgHeight,10)+bottomMargin}px`;}};const onCreated=()=>{const grid=document.getElementsByClassName('ct-grids')[0];if(grid){const gridLines=grid.getElementsByClassName('ct-horizontal');const currentDayGridLine=gridLines[data.series[1].length-1];if(currentDayGridLine){currentDayGridLine.style.transition='opacity 300ms ease-in-out';currentDayGridLine.style.strokeDasharray='3px';setTimeout(()=>{currentDayGridLine.style.opacity=1;},500);}}};const drawLines=d=>{updateHeight();if(d.type==='line'||d.type==='area'){d.element.animate({d:{begin:100*d.index,dur:2000,from:d.path.clone().scale(1,0).translate(0,d.chartRect.height()).stringify(),to:d.path.clone().stringify()// easing: Chartist.Svg.Easing.easeOutQuint,
}});}};return/*#__PURE__*/jsxs("div",{className:styles$$,children:[formattedTotalAmount&&totalCount&&/*#__PURE__*/jsxs("div",{className:"pre-header",children:[/*#__PURE__*/jsxs("p",{children:["Monto Acumulado: ",/*#__PURE__*/jsx("span",{children:formattedTotalAmount})]}),/*#__PURE__*/jsxs("p",{children:["Acumulado: ",/*#__PURE__*/jsx("span",{children:totalCount})]})]}),/*#__PURE__*/jsxs("div",{className:"header",children:[/*#__PURE__*/jsx("p",{children:title}),/*#__PURE__*/jsxs("div",{children:[/*#__PURE__*/jsx("span",{className:"before",children:"Semana pasada"}),/*#__PURE__*/jsx("span",{className:"actual",children:"Semana actual"})]})]}),/*#__PURE__*/jsx("div",{className:"container-chart",ref:svgContainer,children:/*#__PURE__*/jsx(ChartistGraph,{className:"chart",data:data,options:opts,type:"Line",listener:{draw:drawLines,created:onCreated}})})]});};DashboardChart.defaultProps={rowHeight:25,formattedTotalAmount:'',totalCount:''};

var _path$s;

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

function SvgOrder(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22"
  }, props), _path$s || (_path$s = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3,
    d: "M15.927 6.138a.407.407 0 00-.405-.38h-3.08V4.554C12.442 2.59 10.9 1 8.998 1S5.554 2.59 5.554 4.554v1.204h-3.08a.412.412 0 00-.405.38L1.007 18.73a2.134 2.134 0 00.528 1.594A2 2 0 003.029 21h11.942a2 2 0 001.494-.676c.385-.432.576-1.01.528-1.594L15.927 6.138zM6.364 4.554c0-1.501 1.18-2.718 2.634-2.718 1.455 0 2.634 1.217 2.634 2.718v1.204H6.364V4.554zm9.502 15.204c-.229.26-.555.408-.895.406H3.025a1.2 1.2 0 01-.896-.406 1.281 1.281 0 01-.315-.957L2.843 6.594h2.71v2.608c-.65.207-1.058.875-.956 1.57.1.696.68 1.21 1.362 1.21s1.26-.514 1.362-1.21c.102-.695-.305-1.363-.957-1.57V6.59h5.268v2.613c-.652.207-1.059.875-.957 1.57.1.696.68 1.21 1.362 1.21s1.26-.514 1.362-1.21c.102-.695-.305-1.363-.957-1.57V6.59h2.707l1.03 12.208a1.27 1.27 0 01-.313.961zM5.898 9.98c.04.006.081.006.122 0 .3.033.522.303.505.613a.576.576 0 01-.566.554.576.576 0 01-.567-.554.58.58 0 01.506-.613zm6.078 0c.04.006.081.006.122 0 .3.033.522.303.505.613a.576.576 0 01-.566.554.576.576 0 01-.567-.554.58.58 0 01.506-.613h0z"
  })));
}

var _path$r, _path2$3;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

function SvgLink(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$B({
    fill: "currentColor",
    width: 18,
    height: 18,
    viewBox: "0 0 60 60"
  }, props), _path$r || (_path$r = /*#__PURE__*/React$1.createElement("path", {
    d: "M51.173 3.801c-5.068-5.068-13.315-5.066-18.384 0l-9.192 9.192a2 2 0 102.828 2.828l9.192-9.192a8.938 8.938 0 016.363-2.622c2.413 0 4.673.932 6.364 2.623s2.623 3.951 2.623 6.364a8.934 8.934 0 01-2.623 6.363L36.325 31.379c-3.51 3.508-9.219 3.508-12.729 0a2 2 0 10-2.828 2.828c2.534 2.534 5.863 3.801 9.192 3.801s6.658-1.267 9.192-3.801l12.021-12.021c2.447-2.446 3.795-5.711 3.795-9.192 0-3.482-1.348-6.746-3.795-9.193z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React$1.createElement("path", {
    d: "M27.132 40.57l-7.778 7.778a8.935 8.935 0 01-6.364 2.623 8.937 8.937 0 01-6.364-2.623c-3.509-3.509-3.509-9.219 0-12.728L17.94 24.306a8.938 8.938 0 016.364-2.622c2.412 0 4.672.932 6.363 2.622a2 2 0 102.828-2.828c-5.067-5.067-13.314-5.068-18.384 0L3.797 32.793C1.351 35.239.003 38.504.003 41.985c0 3.48 1.348 6.745 3.795 9.191a12.905 12.905 0 009.191 3.795c3.481 0 6.746-1.348 9.192-3.795l7.778-7.778a2 2 0 00-2.827-2.828z"
  })));
}

const COMPONENT_TYPES={ORDER:'order',LINK:'link'};const STATUS_TYPES={ACTIVE:'active',PENDING:'pending',PAID:'paid',CANCELLED:'cancelled'};const Icon=type=>{switch(type){case COMPONENT_TYPES.ORDER:return/*#__PURE__*/jsx(SvgOrder,{});default:return/*#__PURE__*/jsx(SvgLink,{});}};const styles$_="s1y7mved";const statusText=(status,type)=>{let genreSuffix;switch(type){case COMPONENT_TYPES.LINK:genreSuffix='o';break;default:genreSuffix='a';break;}switch(status){case STATUS_TYPES.ACTIVE:return `activ${genreSuffix}`;case STATUS_TYPES.CANCELLED:return `cancelad${genreSuffix} / expirad${genreSuffix}`;case STATUS_TYPES.PAID:return `pagad${genreSuffix}`;default:return 'pendiente';}};const text=(type,status,total)=>{const st=statusText(status,type);switch(type){case COMPONENT_TYPES.ORDER:return `órden${total>1||total===0?'es':''} ${st}${total>1||total===0?'s':''}`;default:return `link${total>1||total===0?'s':''} ${st}${total>1||total===0?'s':''}`;}};const DashboardCard=({type,status,total,percentage})=>/*#__PURE__*/jsxs("div",{className:[styles$_,status].join(' '),children:[/*#__PURE__*/jsx("span",{children:Icon(type)}),/*#__PURE__*/jsxs("div",{children:[/*#__PURE__*/jsxs("p",{className:"total",children:[total,percentage>=0&&!Number.isNaN(percentage)&&/*#__PURE__*/jsx("span",{children:percentage})]}),/*#__PURE__*/jsx("p",{className:"desc",children:text(type,status,total)})]})]});DashboardCard.defaultProps={total:null,percentage:-1};

const styles$Z="s19gmwvc";const Divider=({text:_text=''})=>{return/*#__PURE__*/jsx("div",{className:styles$Z,children:_text});};

var _path$q;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

function SvgDrag(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$A({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React$1.createElement("path", {
    d: "M.667 6.333h6.666a.667.667 0 000-1.333H4.667V2.607l.526.533a.667.667 0 001.093-.217.667.667 0 00-.146-.73L4.473.527a.667.667 0 00-.22-.14.667.667 0 00-.506 0 .667.667 0 00-.22.14L1.86 2.193a.67.67 0 10.947.947l.526-.533V5H.667a.667.667 0 000 1.333zm6.666 1.334H.667A.667.667 0 00.667 9h2.666v2.393l-.526-.533a.67.67 0 00-.947.947l1.667 1.666c.063.061.138.109.22.14a.626.626 0 00.506 0 .666.666 0 00.22-.14l1.667-1.666a.67.67 0 00-.947-.947l-.526.533V9h2.666a.667.667 0 000-1.333z",
    fill: "#718096"
  })));
}

var _path$p;

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

function SvgLock(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$z({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/React$1.createElement("path", {
    d: "M6 7.667a.993.993 0 00-.667 1.74v.926a.667.667 0 101.334 0v-.926A.993.993 0 006 7.667zM9.333 5V3.667a3.333 3.333 0 00-6.666 0V5a2 2 0 00-2 2v4.667a2 2 0 002 2h6.666a2 2 0 002-2V7a2 2 0 00-2-2zM4 3.667a2 2 0 114 0V5H4V3.667zm6 8a.667.667 0 01-.667.666H2.667A.667.667 0 012 11.667V7a.667.667 0 01.667-.667h6.666A.667.667 0 0110 7v4.667z",
    fill: "#718096"
  })));
}

const styles$Y="s1hc2x2t";const CustomDragLayer=({layer,isDragging})=>{const{initialOffset,currentOffset}=useDragLayer(monitor=>({initialOffset:monitor.getInitialSourceClientOffset(),currentOffset:monitor.getSourceClientOffset()}));const getItemStyles=useCallback((initialPosition,currentPosition)=>{if(!initialPosition||!currentPosition){return {display:'none'};}const{x,y}=currentPosition;const transform=`translate(${x}px, ${y}px)`;return {transform};},[]);if(!isDragging){return null;}return/*#__PURE__*/jsx("div",{className:styles$Y,children:/*#__PURE__*/jsx("div",{style:getItemStyles(initialOffset,currentOffset),children:layer})});};

const styles$X="spp5s2e";const DraggeableItem=({children,index,someDrag,setSomeDrag,renderNumber,showIcon,isLocked,move,onClick})=>{const[{isDragging},drag]=useDrag(()=>({type:'ITEM',collect:monitor=>({isDragging:monitor.isDragging()}),item:()=>{setSomeDrag(true);return {index};},canDrag:()=>!isLocked,end:()=>{setSomeDrag(false);}}),[index]);const[{isOver},drop]=useDrop(()=>({item:{index},accept:'ITEM',collect:monitor=>({isOver:isLocked?false:monitor.isOver()}),canDrop:()=>!isLocked,drop:item=>{move(item.index,index);}}),[index]);const refType=useMemo(()=>!someDrag?drag:drop,[someDrag]);const layer=/*#__PURE__*/jsxs("div",{className:styles$X,children:[renderNumber===undefined?/*#__PURE__*/jsx("div",{className:"number",children:index+1}):renderNumber(index+1),/*#__PURE__*/jsx("div",{className:"body",children:children}),showIcon&&/*#__PURE__*/jsx("div",{className:"icon",children:/*#__PURE__*/jsx(SvgDrag,{})})]});return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsxs("div",{ref:refType,className:cx(styles$X,{opaque:isDragging,over:isOver,lock:isLocked}),onClick:onClick,children:[renderNumber===undefined?/*#__PURE__*/jsx("div",{className:"number",children:index+1}):renderNumber(index+1),/*#__PURE__*/jsx("div",{className:"body",children:children}),showIcon&&/*#__PURE__*/jsx("div",{className:"icon",children:isLocked?/*#__PURE__*/jsx(SvgLock,{}):/*#__PURE__*/jsx(SvgDrag,{})})]}),/*#__PURE__*/jsx(CustomDragLayer,{isDragging:isDragging,layer:layer})]});};DraggeableItem.defaultProps={isLocked:false,showIcon:false,renderNumber:undefined,onClick:()=>{}};

const styles$W="s1on1y3n";const Droplist=({showIcon,list,setList,renderItem,renderNumber,onClick,lockAccessor})=>{const[someDrag,setSomeDrag]=useState(false);const move=(initialPosition,finalPosition)=>{if(initialPosition===finalPosition)return false;const newOrders=[{id:list[initialPosition].id,newOrder:list[finalPosition].order},{id:list[finalPosition].id,newOrder:list[initialPosition].order}];setList({newOrders,initialPosition,finalPosition});return false;};return/*#__PURE__*/jsx("div",{className:styles$W,children:list.map((item,index)=>{return/*#__PURE__*/jsx(DraggeableItem,{index:index,someDrag:someDrag,setSomeDrag:setSomeDrag,move:move,isLocked:lockAccessor&&item[lockAccessor],showIcon:showIcon,onClick:()=>onClick(item),renderNumber:renderNumber,children:renderItem(item)},item.id);})});};Droplist.defaultProps={showIcon:false,lockAccessor:null,showOrder:false,renderNumber:undefined,onClick:()=>{}};

var _path$o;

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

function SvgDrop$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$y({
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path$o || (_path$o = /*#__PURE__*/React$1.createElement("path", {
    d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$n;

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

function SvgClose$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$x({
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$n || (_path$n = /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  })));
}

var _path$m, _path2$2;

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

function SvgStar(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001"
  }, props), _path$m || (_path$m = /*#__PURE__*/React$1.createElement("path", {
    d: "M499.92 188.26l-165.839-15.381L268.205 19.91c-4.612-10.711-19.799-10.711-24.411 0l-65.875 152.97L12.08 188.26c-11.612 1.077-16.305 15.52-7.544 23.216l125.126 109.922-36.618 162.476c-2.564 11.376 9.722 20.302 19.749 14.348L256 413.188l143.207 85.034c10.027 5.954 22.314-2.972 19.75-14.348l-36.619-162.476 125.126-109.922c8.761-7.696 4.068-22.139-7.544-23.216z",
    fill: "#ffdc64"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React$1.createElement("path", {
    d: "M268.205 19.91c-4.612-10.711-19.799-10.711-24.411 0l-65.875 152.97L12.08 188.26c-11.612 1.077-16.305 15.52-7.544 23.216l125.126 109.922-36.618 162.476c-2.564 11.376 9.722 20.302 19.749 14.348l31.963-18.979c4.424-182.101 89.034-310.338 156.022-383.697L268.205 19.91z",
    fill: "#ffc850"
  })));
}

const styles$V="s1q66rww";const Dropzone$1=({acceptedTypes,maxFiles,buttonLabel,sublabel,onDrop,onRemove,images,maxSize,canDelete,makeFeatured,featuredImage})=>{const[files,setFiles]=useState(images);const[error,setError]=useState('');const{getRootProps,getInputProps,isDragActive}=useDropzone({accept:acceptedTypes,minSize:1000,multiple:false,// TODO: parametrizar
disabled:files.length===maxFiles,onDrop:useCallback(accFiles=>{if(accFiles.some(f=>f.size>maxSize)){setError('El archivo excede el límite permitido.');}else {if(error){setError('');}setFiles([...files,...accFiles.map(file=>Object.assign({},file,{url:URL.createObjectURL(file),asBase64:()=>new Promise((resolve,reject)=>{try{const reader=new FileReader();reader.readAsDataURL(file);reader.onload=event=>{resolve(event.target.result.split(',')[1]);};}catch(err){reject(err.message);}})}))]);}})});const dropClasses=cx('dropzone',{active:isDragActive,disabled:files.length===maxFiles});useEffect(()=>{onDrop(files);if(featuredImage===''&&files.length){makeFeatured(files[0].url);}return ()=>files.forEach(file=>URL.revokeObjectURL(file.preview));},[files]);useEffect(()=>{if(images.length){if(files.length===0){setFiles(images);}}else if(files.length){setFiles([]);}},[images]);return/*#__PURE__*/jsxs("div",{className:styles$V,children:[/*#__PURE__*/jsxs("div",Object.assign({},getRootProps({className:dropClasses}),{children:[/*#__PURE__*/jsx("input",Object.assign({},getInputProps())),/*#__PURE__*/jsxs("div",{className:"content",children:[/*#__PURE__*/jsx(SvgDrop$1,{}),/*#__PURE__*/jsx("button",{tabIndex:"-1",type:"button",children:buttonLabel}),/*#__PURE__*/jsx("p",{children:sublabel})]})]})),error&&/*#__PURE__*/jsx("p",{className:"error-message",children:error}),files.length>0&&/*#__PURE__*/jsx("div",{className:"previews",children:files.map(file=>/*#__PURE__*/jsxs("span",{children:[featuredImage===file.url&&/*#__PURE__*/jsx(SvgStar,{}),/*#__PURE__*/jsx("img",{src:file.url,onClick:()=>makeFeatured(file.url)}),canDelete&&/*#__PURE__*/jsx("button",{tabIndex:"-1",type:"button",onClick:()=>{onRemove(file);setFiles(stateFiles=>stateFiles.filter(stateFile=>stateFile.url!==file.url));},children:/*#__PURE__*/jsx(SvgClose$1,{})})]},file.url))})]});};Dropzone$1.defaultProps={maxFiles:50,buttonLabel:'Upload',sublabel:'Drag or click to select',images:[],maxSize:50000000,onError:reason=>{// eslint-disable-next-line
console.error(reason);},canDelete:true,makeFeatured:()=>{},featuredImage:''};

var _g$6;

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

function SvgTrash$2(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$v({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React$1.createElement("g", {
    stroke: "none",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React$1.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M4 6.5h17M19 6.8v13.3c0 1.05-.831 1.9-1.857 1.9H7.857C6.831 22 6 21.15 6 20.1V6.8M8.786 6V4.5c0-.828.831-1.5 1.857-1.5h3.714c1.026 0 1.857.672 1.857 1.5V6M10.5 11v6M14.5 11v6"
  })))));
}

var _path$l;

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

function SvgFile$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$u({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/React$1.createElement("path", {
    d: "M25 19.667c0 .618-.253 1.212-.703 1.65-.45.437-1.06.683-1.697.683H3.4a2.435 2.435 0 01-1.697-.683A2.301 2.301 0 011 19.667V3.333a2.3 2.3 0 01.703-1.65A2.435 2.435 0 013.4 1h6l2.4 3.5h10.8c.636 0 1.247.246 1.697.683.45.438.703 1.031.703 1.65v12.834z",
    stroke: "#5B1A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$k, _circle$4, _path2$1;

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

function SvgAddFile$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$t({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React$1.createElement("path", {
    d: "M45.9 36.833c0 1.052-.43 2.061-1.195 2.805A4.14 4.14 0 0141.82 40.8H9.18a4.14 4.14 0 01-2.885-1.162A3.912 3.912 0 015.1 36.833V9.067c0-1.052.43-2.061 1.195-2.805A4.14 4.14 0 019.18 5.1h10.2l4.08 5.95h18.36a4.14 4.14 0 012.885 1.162 3.912 3.912 0 011.195 2.805v21.816z",
    stroke: "#C6CCD5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$4 || (_circle$4 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 42,
    cy: 35,
    r: 11,
    fill: "#fff",
    stroke: "#C6CCD5",
    strokeWidth: 2
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React$1.createElement("path", {
    d: "M42 31.5v7M38.5 35h7",
    stroke: "#C6CCD5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const styles$U="skmzob2";const Dropzone=({acceptedTypes,maxFiles,buttonLabel,sublabel,onDrop,onRemove,files,maxSize,canDelete})=>{const[filesState,setFiles]=useState(files);const[error,setError]=useState('');const{getRootProps,getInputProps,isDragActive}=useDropzone({accept:acceptedTypes,minSize:1000,multiple:false,// TODO: parametrizar
disabled:filesState.length===maxFiles,onDrop:useCallback(accFiles=>{if(accFiles.some(f=>f.size>maxSize)){setError('El archivo excede el límite permitido.');}else {if(error){setError('');}setFiles([...filesState,...accFiles.map(file=>Object.assign({},file,{type:file.type,url:URL.createObjectURL(file),asBase64:()=>new Promise((resolve,reject)=>{try{const reader=new FileReader();reader.readAsDataURL(file);reader.onload=event=>{resolve(event.target.result);};}catch(err){reject(err.message);}})}))]);}})});const dropClasses=cx('dropzone',{active:isDragActive,disabled:filesState.length===maxFiles});useEffect(()=>{onDrop(filesState);return ()=>filesState.forEach(file=>URL.revokeObjectURL(file.preview));},[filesState]);useEffect(()=>{if(files.length){if(filesState.length===0){setFiles(files);}}else if(filesState.length){setFiles([]);}},[files]);return/*#__PURE__*/jsxs("div",{className:styles$U,children:[/*#__PURE__*/jsxs("div",Object.assign({},getRootProps({className:dropClasses}),{children:[/*#__PURE__*/jsx("input",Object.assign({},getInputProps())),/*#__PURE__*/jsxs("div",{className:"content",children:[/*#__PURE__*/jsx(SvgAddFile$1,{}),/*#__PURE__*/jsx("button",{id:"uploadBtn",tabIndex:"-1",type:"button",children:buttonLabel}),/*#__PURE__*/jsx("p",{children:sublabel})]})]})),error?/*#__PURE__*/jsx("p",{className:"error-message",children:error}):/*#__PURE__*/jsx(Fragment,{children:filesState.length>0&&/*#__PURE__*/jsx("div",{className:"previews",children:filesState.map(file=>/*#__PURE__*/jsxs("span",{children:[/*#__PURE__*/jsx(SvgFile$1,{}),/*#__PURE__*/jsx("p",{children:file.path}),canDelete&&/*#__PURE__*/jsx("button",{tabIndex:"-1",type:"button",onClick:()=>{onRemove(file);setFiles(stateFiles=>stateFiles.filter(stateFile=>stateFile.url!==file.url));},children:/*#__PURE__*/jsx(SvgTrash$2,{})})]},file.url))})})]});};Dropzone.defaultProps={maxFiles:50,buttonLabel:'Upload',sublabel:'Drag or click to select',files:[],maxSize:50000000,onError:reason=>{// eslint-disable-next-line
console.error(reason);},canDelete:true};

var _g$5;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

function SvgTrash$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$s({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React$1.createElement("g", {
    stroke: "none",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React$1.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M4 6.5h17M19 6.8v13.3c0 1.05-.831 1.9-1.857 1.9H7.857C6.831 22 6 21.15 6 20.1V6.8M8.786 6V4.5c0-.828.831-1.5 1.857-1.5h3.714c1.026 0 1.857.672 1.857 1.5V6M10.5 11v6M14.5 11v6"
  })))));
}

var _path$j;

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

function SvgFile(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$r({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React$1.createElement("path", {
    d: "M25 19.667c0 .618-.253 1.212-.703 1.65-.45.437-1.06.683-1.697.683H3.4a2.435 2.435 0 01-1.697-.683A2.301 2.301 0 011 19.667V3.333a2.3 2.3 0 01.703-1.65A2.435 2.435 0 013.4 1h6l2.4 3.5h10.8c.636 0 1.247.246 1.697.683.45.438.703 1.031.703 1.65v12.834z",
    stroke: "#5B1A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path$i, _circle$3, _path2;

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

function SvgAddFile(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$q({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React$1.createElement("path", {
    d: "M45.9 36.833c0 1.052-.43 2.061-1.195 2.805A4.14 4.14 0 0141.82 40.8H9.18a4.14 4.14 0 01-2.885-1.162A3.912 3.912 0 015.1 36.833V9.067c0-1.052.43-2.061 1.195-2.805A4.14 4.14 0 019.18 5.1h10.2l4.08 5.95h18.36a4.14 4.14 0 012.885 1.162 3.912 3.912 0 011.195 2.805v21.816z",
    stroke: "#C6CCD5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$3 || (_circle$3 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 42,
    cy: 35,
    r: 11,
    fill: "#fff",
    stroke: "#C6CCD5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React$1.createElement("path", {
    d: "M42 31.5v7M38.5 35h7",
    stroke: "#C6CCD5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const styles$T="s1129al7";const DropzoneFiles2=({acceptedTypes,maxFiles,buttonLabel,sublabel,onDrop,onRemove,files,maxSize,canDelete})=>{const[filesState,setFiles]=useState(files);const[error,setError]=useState('');const{getRootProps,getInputProps,isDragActive}=useDropzone({accept:acceptedTypes,minSize:1000,multiple:false,disabled:filesState.length===maxFiles,onDrop:useCallback(accFiles=>{if(accFiles.some(f=>f.size>maxSize)){setError('El archivo excede el límite permitido.');}else {if(error){setError('');}setFiles([...filesState,...accFiles]);}})});const dropClasses=cx('dropzone',{active:isDragActive,disabled:filesState.length===maxFiles});useEffect(()=>{onDrop(filesState);return ()=>filesState.forEach(file=>URL.revokeObjectURL(file.preview));},[filesState]);useEffect(()=>{if(files.length){if(filesState.length===0){setFiles(files);}}else if(filesState.length){setFiles([]);}},[files]);return/*#__PURE__*/jsxs("div",{className:styles$T,children:[/*#__PURE__*/jsxs("div",Object.assign({},getRootProps({className:dropClasses}),{children:[/*#__PURE__*/jsx("input",Object.assign({},getInputProps())),/*#__PURE__*/jsxs("div",{className:"content",children:[/*#__PURE__*/jsx(SvgAddFile,{}),/*#__PURE__*/jsx("button",{id:"uploadBtn",tabIndex:"-1",type:"button",children:buttonLabel}),/*#__PURE__*/jsx("p",{children:sublabel})]})]})),error?/*#__PURE__*/jsx("p",{className:"error-message",children:error}):/*#__PURE__*/jsx(Fragment,{children:filesState.length>0&&/*#__PURE__*/jsx("div",{className:"previews",children:filesState.map(file=>/*#__PURE__*/jsxs("span",{children:[/*#__PURE__*/jsx(SvgFile,{}),/*#__PURE__*/jsx("p",{children:file.path}),canDelete&&/*#__PURE__*/jsx("button",{tabIndex:"-1",type:"button",onClick:()=>{onRemove(file);setFiles(stateFiles=>stateFiles.filter(stateFile=>stateFile.url!==file.url));},children:/*#__PURE__*/jsx(SvgTrash$1,{})})]},file.path))})})]});};DropzoneFiles2.defaultProps={maxFiles:50,buttonLabel:'Upload',sublabel:'Drag or click to select',files:[],maxSize:50000000,canDelete:true};

function __interopImport$c(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$u = {}; var exports$g = __exports$u; var __module$u = { exports: __exports$u };
                    if (typeof module !== "undefined") for (var prop$u in module) { prop$u !== "exports" && (__module$u[prop$u] = module[prop$u]);}!function(e,s){"object"==typeof exports$g&&"undefined"!=typeof __module$u?__module$u.exports=s(__interopImport$c(__require__import__0$6)):"function"==typeof define&&define.amd?define(["dayjs"],s):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_locale_es_us=s(e.dayjs);}(undefined,(function(e){function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=s(e),d={name:"es-us",weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinal:function(e){return e+"º"},formats:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"}};return o.default.locale(d,null,!0),d}));__module$u.exports;

var _path$h;

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

function SvgIconHelp(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path$h || (_path$h = /*#__PURE__*/React$1.createElement("path", {
    fill: "#565557",
    d: "M6.3 11.2h1.4V9.8H6.3v1.4M7 0a7 7 0 100 14A7 7 0 007 0m0 12.6A5.607 5.607 0 011.4 7c0-3.087 2.513-5.6 5.6-5.6 3.087 0 5.6 2.513 5.6 5.6 0 3.087-2.513 5.6-5.6 5.6m0-9.8a2.8 2.8 0 00-2.8 2.8h1.4a1.4 1.4 0 012.8 0c0 1.4-2.1 1.225-2.1 3.5h1.4c0-1.575 2.1-1.75 2.1-3.5A2.8 2.8 0 007 2.8z"
  })));
}

const styles$S="s16krnsz";const Tooltip=({text})=>/*#__PURE__*/jsxs("div",{className:styles$S,children:[/*#__PURE__*/jsx(SvgIconHelp,{}),/*#__PURE__*/jsx("span",{className:"tooltip",children:text})]});

var _path$g;

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

function SvgErrorsign(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$o({
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path$g || (_path$g = /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  })));
}

var _path$f;

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

function SvgCalendar$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14"
  }, props), _path$f || (_path$f = /*#__PURE__*/React$1.createElement("path", {
    fill: "#B1ABAB",
    d: "M10.865 0c.241 0 .437.196.437.438v.728h1.313c.884 0 1.604.72 1.604 1.605v9.625c0 .885-.72 1.604-1.604 1.604H1.823c-.885 0-1.604-.72-1.604-1.604V2.77c0-.885.719-1.604 1.604-1.604l1.312-.001V.438a.438.438 0 11.875 0v.728h6.417V.438c0-.242.196-.438.438-.438zm2.479 5.541H1.094v6.855a.73.73 0 00.729.729h10.792a.73.73 0 00.729-.73V5.542zm-10.21-3.5h-1.31a.732.732 0 00-.73.73v1.895h12.25V2.771a.73.73 0 00-.728-.73h-1.313v1.022a.437.437 0 11-.875-.001v-1.02H4.01v1.022a.437.437 0 11-.875-.001V2.042z"
  })));
}

const _excluded$5=["options"];function _objectWithoutPropertiesLoose$6(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}// eslint-disable-next-line no-underscore-dangle
const DayPickerInput=DPI.__esModule?DPI.default:DPI;const INPUT_TYPES={CURRENCY:'currency',TEXTAREA:'textarea',NUMBER:'number',SELECT:'select',DATE:'date',RADIO:'radio',TIME:'time'};const styles$R="s12fhcqf";// eslint-disable-next-line react/display-name
const Input=/*#__PURE__*/forwardRef((_ref,ref)=>{let{name,type,label,placeholder,required,LeadingIcon,leadingText,leadingCurrency,error,innerSelect:{options:innerSelectOptions},value,onChange,inputProps,options,tooltipText,selectProps,inputClassName,loading,appendText,variant}=_ref,innerSelectProps=_objectWithoutPropertiesLoose$6(_ref.innerSelect,_excluded$5);const iputClasses=cx({'leading-text':leadingText,'leading-icon':typeof LeadingIcon!=='undefined','leading-currency':leadingCurrency,'big-currency':leadingCurrency&&leadingCurrency.length>2,'append-text':appendText,[inputClassName]:inputClassName,currency:type===INPUT_TYPES.CURRENCY,error});const formatDate=(date,format,locale)=>{dayjs.locale(locale);return !date?date:dayjs(date).format(format).toString();};const Component=()=>{var _inputProps$inputProp;switch(type){case INPUT_TYPES.TEXTAREA:return/*#__PURE__*/jsx("textarea",Object.assign({ref:ref,id:`input-${name}`,name:name,className:inputClassName,placeholder:placeholder,value:value,onChange:onChange},inputProps));case INPUT_TYPES.SELECT:return/*#__PURE__*/jsx(Select,{ref:ref,id:`input-${name}`,name:name,value:options.find(f=>f.value===value)||null,onChange:val=>{// workaround for this: https://github.com/JedWatson/react-select/issues/1631
onChange({persist:()=>{},target:{value:val?val.value:null,name}});},canClear:!required,placeholder:placeholder,options:options,styleName:inputClassName,reactSelectProps:selectProps});case INPUT_TYPES.CURRENCY:return/*#__PURE__*/jsx("input",Object.assign({ref:ref,id:`input-${name}`,name:name,className:iputClasses,placeholder:placeholder,type:"number",value:value,onChange:onChange},inputProps));case INPUT_TYPES.DATE:return/*#__PURE__*/ (// http://react-day-picker.js.org/api/DayPickerInput
// TODO: variable format
jsxs("div",{className:"container-datepicker",children:[/*#__PURE__*/jsx(DayPickerInput,Object.assign({ref:ref,id:`input-${name}`,name:name,placeholder:placeholder,value:!value?value:dayjs(value).format('DD/MM/YYYY').toString(),selectedDay:value,format:"DD/MM/YYYY",formatDate:formatDate,dayPickerProps:Object.assign({},inputProps,{locale:'es-us',months:['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],weekdaysLong:['Lunes','Martes','Miercoles','Jueves','Viernes','Sabado','Domingo'],weekdaysShort:['D','L','M','M','J','V','S'],firstDayOfWeek:1,labels:{nextMonth:'Siguiente mes',previousMonth:'Mes Anterior'}}),onDayChange:val=>{onChange({persist:()=>{},target:{value:val?val.toISOString():undefined,name}});}},inputProps)),!(inputProps!==null&&inputProps!==void 0&&(_inputProps$inputProp=inputProps.inputProps)!==null&&_inputProps$inputProp!==void 0&&_inputProps$inputProp.disabled)&&/*#__PURE__*/jsx("span",{children:"editar"})]}));case INPUT_TYPES.RADIO:return/*#__PURE__*/jsx("div",{className:`radio-options ${variant}`,children:options&&options.map(option=>/*#__PURE__*/jsxs("div",{children:[/*#__PURE__*/jsx("input",Object.assign({ref:ref,id:`input-${option.value}`,name:name,className:iputClasses,type:"radio",value:option.value,onChange:onChange},inputProps,{checked:value===option.value})),/*#__PURE__*/jsx("label",{htmlFor:`input-${option.value}`,children:option.label})]},option.value))});case INPUT_TYPES.TIME:return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("input",Object.assign({ref:ref,id:`input-${name}`,name:name,className:iputClasses,type:type,value:value.length===4?`0${value}`:value,onChange:onChange,pattern:"[0-9]{1,2}:[0-9]{2}"},inputProps)),appendText&&/*#__PURE__*/jsx("span",{className:"append-text",children:appendText})]});default:return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("input",Object.assign({ref:ref,id:`input-${name}`,name:name,className:iputClasses,placeholder:placeholder,type:type,value:value,onChange:onChange},inputProps)),appendText&&/*#__PURE__*/jsx("span",{className:"append-text",children:appendText})]});}};return/*#__PURE__*/jsxs("div",{className:styles$R,children:[label&&/*#__PURE__*/jsx("div",{className:"container-label",children:loading?/*#__PURE__*/jsx("span",{className:"loading-fill"}):/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("label",{htmlFor:`input-${name}`,children:label}),tooltipText&&/*#__PURE__*/jsx(Tooltip,{text:tooltipText}),required&&/*#__PURE__*/jsx("span",{className:"req",children:"*"})]})}),/*#__PURE__*/jsx("div",{className:"container-input",children:loading?/*#__PURE__*/jsx("span",{className:`loading-fill ${type}`}):/*#__PURE__*/jsxs(Fragment,{children:[(LeadingIcon||leadingText||leadingCurrency||type==='date')&&/*#__PURE__*/jsxs("div",{className:"container-leading-icon",children:[type==='date'&&/*#__PURE__*/jsx(SvgCalendar$1,{className:"calendar-icon"}),type!=='date'&&LeadingIcon?/*#__PURE__*/jsx(LeadingIcon,{}):/*#__PURE__*/jsx("span",{children:leadingText||leadingCurrency})]}),Component(),error&&/*#__PURE__*/jsx("div",{className:"error-icon",children:/*#__PURE__*/jsx(SvgErrorsign,{})}),!!innerSelectOptions.length&&/*#__PURE__*/jsx("div",{className:"container-currency",children:/*#__PURE__*/jsx("select",Object.assign({tabIndex:"-1"},innerSelectProps,{children:innerSelectOptions.map(({name:innerSelectOptionsName,value:innerSelectOptionsValue})=>/*#__PURE__*/jsx("option",{value:innerSelectOptionsValue,children:innerSelectOptionsName},innerSelectOptionsValue))}))})]})}),error&&/*#__PURE__*/jsx("p",{className:"error-message",children:error})]});});Input.defaultProps={leadingText:'',type:'text',label:'',placeholder:'',required:false,LeadingIcon:undefined,leadingCurrency:'',error:'',innerSelect:{options:[]},// selectValue: '',
// selectOnChange: () => {},
inputProps:{},options:[],value:'',onChange:()=>{},tooltipText:'',selectProps:{},inputClassName:'',loading:false,appendText:'',variant:''};Input.displayName='Input';

const styles$Q="sihmn3j";const EmbeddedButton=({link})=>{const setEmbedButton=text=>{return `<button role="link" style="width: 286px; height: 40px; font-size:15px; background: #8A72C7;padding: 12px 32px; text-align: center; border-radius: 6px; border: 1px solid #8A72C7; color: white; font-weight: bold;" onclick="window.location='${link}'">${text}</button>`;};const[buttonText,setButtonText]=useState('¡Haz click aquí!');const[embedCode,setEmbedCode]=useState(setEmbedButton(buttonText));const handleTextChange=({target:{value}})=>{setButtonText(value);setEmbedCode(setEmbedButton(value));};useEffect(()=>{setEmbedCode(setEmbedButton(buttonText));},[link]);return/*#__PURE__*/jsx("div",{className:styles$Q,children:/*#__PURE__*/jsxs(CopyText,{children:[/*#__PURE__*/jsx(Input,{name:"inputButtonText",id:"inputButtonText",label:"Escriba el texto que mostrar\xE1 el bot\xF3n:",placeholder:"Escriba el texto que mostrar\xE1 el bot\xF3n",onChange:handleTextChange,value:buttonText}),/*#__PURE__*/jsx(Input,{type:"textarea",name:"inputLinkText",id:"inputLinkText",label:"Copia y pega este c\xF3digo en tu sitio web:",value:embedCode,inputClassName:"text",inputProps:{readOnly:true}})]})});};

var _path$e;

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

function SvgIconHistory(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15"
  }, props), _path$e || (_path$e = /*#__PURE__*/React$1.createElement("path", {
    fill: "#5A56F1",
    d: "M10.417 4.167h-1.25v4.166l3.566 2.117.6-1.008-2.916-1.734V4.167M10 0a7.5 7.5 0 00-7.5 7.5H0l3.3 3.358L6.667 7.5h-2.5c0-3.222 2.611-5.833 5.833-5.833s5.833 2.611 5.833 5.833-2.611 5.833-5.833 5.833a5.788 5.788 0 01-4.117-1.716L4.7 12.8A7.412 7.412 0 0010 15a7.5 7.5 0 000-15"
  })));
}

const styles$P="sesdnre";const HistoryDetails=({date,user,actionName,actionDetails})=>{dayjs.locale('es-us');const[showDetails,setShowDetails]=useState(false);const toggleShowDetails=()=>{setShowDetails(!showDetails);};return/*#__PURE__*/jsxs("div",{className:styles$P,children:[/*#__PURE__*/jsx("div",{className:"icon-container",children:/*#__PURE__*/jsx("div",{children:/*#__PURE__*/jsx(SvgIconHistory,{})})}),/*#__PURE__*/jsxs("div",{className:"container",children:[/*#__PURE__*/jsx("p",{className:"date",children:dayjs(date).format('DD MMMM YYYY')}),/*#__PURE__*/jsx("p",{className:"user-data",children:user}),/*#__PURE__*/jsxs("div",{className:"action-details",children:[/*#__PURE__*/jsxs("div",{className:"resume",onClick:toggleShowDetails,children:[/*#__PURE__*/jsxs("div",{children:[actionName,actionDetails&&actionDetails.length>0&&/*#__PURE__*/jsx("span",{className:showDetails?'show':''})]}),/*#__PURE__*/jsx("div",{className:"hour",children:dayjs(date).format('hh:mm a')})]}),actionDetails&&actionDetails.length>0&&/*#__PURE__*/jsx("ul",{className:showDetails?'show-details':'',children:actionDetails.map(detail=>/*#__PURE__*/jsx("li",{children:detail},detail))})]})]})]});};HistoryDetails.defaultProps={date:'',user:'',actionName:''};

const styles$O="s9m4r58";const Modal=({title,children,modalClassName,size,withHeader,withFooter,full,onClose,closeText,onAccept,acceptText,disableAccept})=>{const[open,setOpen]=useState(false);useEffect(()=>{setTimeout(()=>{setOpen(true);},100);},[]);return/*#__PURE__*/jsx(Portal,{children:/*#__PURE__*/jsx(CSSTransition,{in:open,timeout:300,classNames:"fade",unmountOnExit:true,mountOnEnter:true,children:/*#__PURE__*/jsx("div",{className:[styles$O,modalClassName].join(' '),onClick:!withHeader?onClose:undefined,children:/*#__PURE__*/jsxs("div",{className:`content ${size}`,children:[withHeader&&/*#__PURE__*/jsxs("header",{children:[/*#__PURE__*/jsx("h1",{children:title}),/*#__PURE__*/jsx("a",{onClick:onClose,children:"\xD7"})]}),/*#__PURE__*/jsx("main",{id:"modal-body",className:cx({full}),children:children}),withFooter&&/*#__PURE__*/jsxs("footer",{children:[/*#__PURE__*/jsx(Button,{role:"white",type:"outline",onClick:onClose,children:closeText}),onAccept&&/*#__PURE__*/jsx(Button,{role:"primary",onClick:onAccept,htmlProps:{disabled:disableAccept},children:acceptText})]})]})})})});};Modal.defaultProps={title:'',closeText:'Cancelar',acceptText:'Aceptar',modalClassName:'',size:'lg',withHeader:true,withFooter:false,full:false,submit:null,onAccept:()=>{},disableAccept:false};

const _excluded$4=["src"],_excluded2=["src","hdSrc","previewClassName"];function _objectWithoutPropertiesLoose$5(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const styles$N="s16sfcr4";const modalStyles="mbhmv1m";const Image=_ref=>{let{src}=_ref,rest=_objectWithoutPropertiesLoose$5(_ref,_excluded$4);return/*#__PURE__*/jsx("img",Object.assign({src:src},rest));};const ImagePreview=_ref2=>{let{src,hdSrc,previewClassName}=_ref2,rest=_objectWithoutPropertiesLoose$5(_ref2,_excluded2);const[full,setFull]=useState(false);return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx(Image,Object.assign({src:src,onClick:()=>setFull(true)},rest,{className:[styles$N,previewClassName].join(' ')})),full&&/*#__PURE__*/jsx(Modal,{onClose:()=>setFull(false),modalClassName:modalStyles,withHeader:false,size:"sm",full:true,children:/*#__PURE__*/jsx(Image,Object.assign({src:hdSrc||src},rest))})]});};ImagePreview.defaultProps={hdSrc:'',previewClassName:''};

const styles$M="s1n1i466";const InfoCard=({image,bgImageColor,title,list,detail,buttonTitle,buttonTarget,buttonRole,type})=>{return/*#__PURE__*/jsxs("div",{className:styles$M,children:[image&&/*#__PURE__*/jsx("div",{className:`image${type?`-${type}`:''}`,style:{backgroundColor:bgImageColor},children:/*#__PURE__*/jsx("img",{src:image})}),/*#__PURE__*/jsx("h1",{className:`title${type?`-${type}`:''}`,children:title}),detail&&/*#__PURE__*/jsx("p",{children:detail}),list.length>0&&/*#__PURE__*/jsx("ul",{children:list.map(item=>/*#__PURE__*/jsx("li",{children:/*#__PURE__*/jsx("p",{children:item})},item))}),buttonTitle?/*#__PURE__*/jsx("div",{className:`button${type?`-${type}`:''}`,children:/*#__PURE__*/jsx(Button,{onClick:buttonTarget,role:buttonRole,children:buttonTitle})}):/*#__PURE__*/jsx("div",{className:"blankbutton",onClick:buttonTarget})]});};InfoCard.defaultProps={image:'',bgImageColor:'#FFF',list:[],detail:'',buttonTitle:'',buttonTarget:()=>{},buttonRole:'primary',type:''};

const styles$L="s12wxlir";const InlineList=({rowData,footerData})=>{return/*#__PURE__*/jsxs("div",{className:styles$L,children:[/*#__PURE__*/jsx("ul",{children:rowData.filter(row=>!row.hide).map(row=>/*#__PURE__*/jsxs("li",{children:[row.label&&/*#__PURE__*/jsx("span",{className:"label",children:row.label}),row.name&&/*#__PURE__*/jsx("span",{className:"name",children:row.name}),Object.prototype.hasOwnProperty.call(row,'detail')&&/*#__PURE__*/jsx("span",{className:`detail ${row.className?row.className:''}`,title:typeof row.detail==='string'?row.detail:'',style:row.width&&{maxWidth:row.width&&row.width==='full'?'100%':`${row.width}px`},children:row.detail})]},`inline-row-${row.name}-${row.label}`))}),Object.keys(footerData).length!==0&&footerData.constructor===Object&&/*#__PURE__*/jsx("ul",{className:"footer",children:/*#__PURE__*/jsxs("li",{children:[/*#__PURE__*/jsx("span",{className:"name",children:footerData.name}),/*#__PURE__*/jsx("span",{className:"detail",children:footerData.detail})]})})]});};InlineList.defaultProps={footerData:{}};

const styles$K="sp4jq6h";const Map=({onPinDrop,defaultLat,defaultLng,withGeocoding,withSearchBox,polygonCoords,defaultMarker})=>{const mapDOMRef=/*#__PURE__*/createRef();const searchBoxDOMRef=/*#__PURE__*/createRef();const[marker,setMarker]=useState(null);const[markerLocation,setMarkerLocation]=useState(null);const[mapRef,setMapRef]=useState(null);const[userLocation,setUserLocation]=useState({lat:15.7835,lng:-90.2308});const handleUserDropPin=({latLng})=>{const point={lat:latLng.lat(),lng:latLng.lng()};setMarkerLocation(()=>point);};useEffect(()=>{if(navigator.geolocation){navigator.geolocation.getCurrentPosition(position=>{setUserLocation({lat:position.coords.latitude,lng:position.coords.longitude});},()=>{setUserLocation({lat:defaultLat,lng:defaultLng});});}},[]);useEffect(()=>{if(markerLocation){if(withGeocoding){new Promise((resolve,reject)=>{new google.maps.Geocoder().geocode({location:markerLocation},(res,status)=>{if(status===google.maps.GeocoderStatus.ERROR){reject(status);}else {const political={};const address={};if(res&&res[0]){for(let i=0;i<res[0].address_components.length;i+=1){const comp=res[0].address_components[i];if(comp.types.indexOf('route')>-1){address.route=comp.long_name;}if(comp.types.indexOf('street_number')>-1){address.street_number=comp.long_name;}if(comp.types.indexOf('sublocality')>-1){address.sublocality=comp.long_name;}if(comp.types.indexOf('locality')>-1){address.locality=comp.long_name;}if(comp.types.indexOf('administrative_area_level_1')>-1){political.city=comp;}if(comp.types.indexOf('administrative_area_level_2')>-1){political.state=comp;}if(comp.types.indexOf('country')>-1){political.country=comp;}}}let formattedAddress='';if(address.route!=='Unnamed Road'&&address.route&&address.street_number&&address.sublocality&&address.locality){formattedAddress=`${address.route} ${address.street_number} ${address.sublocality} ${address.locality}`;}resolve({geocode:formattedAddress,political});}});}).then(addr=>onPinDrop(Object.assign({},addr,{marker:markerLocation})));}else {onPinDrop({marker:markerLocation});}if(marker===null){setMarker(new google.maps.Marker({position:markerLocation,map:mapRef}));}else {marker.setPosition(markerLocation);}if(mapRef){mapRef.panTo(markerLocation);}}},[markerLocation]);useEffect(()=>{const{Map:GMap}=window.google.maps;const map=new GMap(mapDOMRef.current,{zoom:16,center:{lat:userLocation.lat,lng:userLocation.lng},disableDefaultUI:true,fullscreenControl:true});setMapRef(map);if(polygonCoords.length>0){const everythingElse=[new google.maps.LatLng(-99,99),new google.maps.LatLng(-90,0),new google.maps.LatLng(-90,90),new google.maps.LatLng(0,-90)];const allowedZone=new google.maps.Polygon({paths:[everythingElse,polygonCoords],strokeColor:'#8a72c7',strokeOpacity:0.8,strokeWeight:2,fillColor:'#b9aadd',fillOpacity:0.35,zIndex:50,clickable:false});allowedZone.setMap(map);map.data.setStyle(feature=>{const percentage=parseFloat(feature.getProperty('percentage'));return {icon:{path:GMap.SymbolPath.CIRCLE,scale:percentage,fillColor:'#00ff00',fillOpacity:0.35,strokeWeight:0},clickable:true};});// map.event.addListener(allowedZone, 'click', () => console.log('pin pin'))
}if(withSearchBox){const defaultBounds=new google.maps.LatLngBounds(new google.maps.LatLng(17.696533,-92.501664),new google.maps.LatLng(13.259823,-87.767745));const box=new google.maps.places.SearchBox(searchBoxDOMRef.current,{bounds:defaultBounds});box.addListener('places_changed',()=>{const places=box.getPlaces();if(places.length===0){return;}handleUserDropPin({latLng:places[0].geometry.location});});}google.maps.event.addListener(map,'click',event=>{handleUserDropPin(event);});if(defaultMarker&&defaultMarker.lat&&defaultMarker.lng){google.maps.event.addListenerOnce(map,'tilesloaded',()=>{setMarkerLocation(()=>defaultMarker);});}},[userLocation]);return/*#__PURE__*/jsxs("div",{className:styles$K,children:[withSearchBox&&/*#__PURE__*/jsx("div",{className:"container-input",children:/*#__PURE__*/jsx("input",{ref:searchBoxDOMRef,placeholder:""})}),/*#__PURE__*/jsx("div",{ref:mapDOMRef,className:"map"})]});};Map.defaultProps={onPinDrop:()=>{},defaultLat:0,defaultLng:0,withGeocoding:false,withSearchBox:true,polygonCoords:[],defaultMarker:null};

const _excluded$3=["children","timeout","isVisible","classNames"];function _objectWithoutPropertiesLoose$4(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const MountAnimation=_ref=>{let{children,timeout=300,isVisible=false,classNames='transition-translate-y'}=_ref,restProps=_objectWithoutPropertiesLoose$4(_ref,_excluded$3);const[isMounted,setIsMounted]=useState(isVisible);useEffect(()=>setIsMounted(isVisible),[isVisible]);return/*#__PURE__*/jsx(CSSTransition,Object.assign({in:isMounted,timeout:timeout,classNames:classNames},restProps,{children:/*#__PURE__*/jsx(Fragment,{children:children})}));};

const styles$J="s1sg6566";const NavSteps=({IconTitle,items,withBorders})=>{return/*#__PURE__*/jsx("div",{className:cx(styles$J),children:/*#__PURE__*/jsxs("ul",{className:withBorders?'bordered':'',children:[IconTitle&&/*#__PURE__*/jsx("li",{className:"icon",children:/*#__PURE__*/jsx(IconTitle,{})}),items&&items.map(item=>/*#__PURE__*/jsx("li",{className:item.active?'active':'',onClick:item.action,children:item.name},item.id))]})});};NavSteps.defaultProps={IconTitle:undefined,withBorders:false};

const styles$I="s1fsykr0";const Loading=()=>/*#__PURE__*/jsx("span",{className:styles$I});

const styles$H="s1x3xx6";const FullLoading=()=>/*#__PURE__*/jsx("div",{className:styles$H,children:/*#__PURE__*/jsx(Loading,{})});

const styles$G="s17y3ens";const CircularProgress$1=({size:_size=20,progress:_progress=0,strokeWidth:_strokeWidth=6})=>{const center=_size/2;const radius=_size/2-_strokeWidth/2;const circumference=2*Math.PI*radius;const offset=(100-_progress)/100*circumference;return/*#__PURE__*/jsx("div",{className:styles$G,children:/*#__PURE__*/jsxs("svg",{className:"progress-ring",width:_size,height:_size,children:[/*#__PURE__*/jsx("circle",{className:"progress-ring__bg",cx:center,cy:center,r:radius,strokeWidth:_strokeWidth}),/*#__PURE__*/jsx("circle",{className:"progress-ring__progress",cx:center,cy:center,r:radius,strokeWidth:_strokeWidth,strokeDasharray:circumference,strokeDashoffset:offset})]})});};

var _circle$2, _circle2$1, _circle3$1;

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

function SvgCircles(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$l({
    className: "circles_svg__loader",
    viewBox: "0 0 24 24"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _circle3$1 || (_circle3$1 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })));
}

const styles$F="s1d80kby";const LoadingSpinner=({size:_size=40})=>/*#__PURE__*/jsx(SvgCircles,{className:styles$F,width:_size,height:_size});

const styles$E="s9bhwaz";const NavTabs=({items,activeItemId})=>{const[activeTab,setActiveTab]=useState(activeItemId);const changeTab=(activeId,callbackClick)=>{setActiveTab(activeId);callbackClick();};return/*#__PURE__*/jsx("div",{className:cx(styles$E),children:/*#__PURE__*/jsx("header",{className:"navigator-tabs",children:items&&items.map(item=>/*#__PURE__*/jsx("div",{className:`${activeTab===item.id?'active':''}`,onClick:()=>changeTab(item.id,item.itemClick),children:item.name},item.id))})});};NavTabs.defaultProps={activeItemId:''};

var __exports$t = {}; var exports$f = __exports$t; var __module$t = { exports: __exports$t };
                    if (typeof module !== "undefined") for (var prop$t in module) { prop$t !== "exports" && (__module$t[prop$t] = module[prop$t]);}Object.defineProperty(exports$f, "__esModule", { value: true });
exports$f.postalCode = void 0;
var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;
function verification$6(isValid, isPotentiallyValid) {
    return { isValid: isValid, isPotentiallyValid: isPotentiallyValid };
}
function postalCode(value, options) {
    if (options === void 0) { options = {}; }
    var minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;
    if (typeof value !== "string") {
        return verification$6(false, false);
    }
    else if (value.length < minLength) {
        return verification$6(false, true);
    }
    return verification$6(true, true);
}
exports$f.postalCode = postalCode;
        
            var __esModule$d = __module$t.exports.__esModule;

var __require__import__7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  postalCode: postalCode,
  __esModule: __esModule$d
});

var __exports$s = {}; var exports$e = __exports$s; var __module$s = { exports: __exports$s };
                    if (typeof module !== "undefined") for (var prop$s in module) { prop$s !== "exports" && (__module$s[prop$s] = module[prop$s]);}Object.defineProperty(exports$e, "__esModule", { value: true });
exports$e.cvv = void 0;
var DEFAULT_LENGTH = 3;
function includes(array, thing) {
    for (var i = 0; i < array.length; i++) {
        if (thing === array[i]) {
            return true;
        }
    }
    return false;
}
function max(array) {
    var maximum = DEFAULT_LENGTH;
    var i = 0;
    for (; i < array.length; i++) {
        maximum = array[i] > maximum ? array[i] : maximum;
    }
    return maximum;
}
function verification$5(isValid, isPotentiallyValid) {
    return { isValid: isValid, isPotentiallyValid: isPotentiallyValid };
}
function cvv(value, maxLength) {
    if (maxLength === void 0) { maxLength = DEFAULT_LENGTH; }
    maxLength = maxLength instanceof Array ? maxLength : [maxLength];
    if (typeof value !== "string") {
        return verification$5(false, false);
    }
    if (!/^\d*$/.test(value)) {
        return verification$5(false, false);
    }
    if (includes(maxLength, value.length)) {
        return verification$5(true, true);
    }
    if (value.length < Math.min.apply(null, maxLength)) {
        return verification$5(false, true);
    }
    if (value.length > max(maxLength)) {
        return verification$5(false, false);
    }
    return verification$5(true, true);
}
exports$e.cvv = cvv;
        
            var __esModule$c = __module$s.exports.__esModule;

var __require__import__6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cvv: cvv,
  __esModule: __esModule$c
});

var __exports$r = {}; var exports$d = __exports$r; var __module$r = { exports: __exports$r };
                    if (typeof module !== "undefined") for (var prop$r in module) { prop$r !== "exports" && (__module$r[prop$r] = module[prop$r]);}Object.defineProperty(exports$d, "__esModule", { value: true });
exports$d.expirationYear = void 0;
var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;
function verification$4(isValid, isPotentiallyValid, isCurrentYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isCurrentYear: isCurrentYear || false,
    };
}
function expirationYear(value, maxElapsedYear) {
    if (maxElapsedYear === void 0) { maxElapsedYear = DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE; }
    var isCurrentYear;
    if (typeof value !== "string") {
        return verification$4(false, false);
    }
    if (value.replace(/\s/g, "") === "") {
        return verification$4(false, true);
    }
    if (!/^\d*$/.test(value)) {
        return verification$4(false, false);
    }
    var len = value.length;
    if (len < 2) {
        return verification$4(false, true);
    }
    var currentYear = new Date().getFullYear();
    if (len === 3) {
        // 20x === 20x
        var firstTwo = value.slice(0, 2);
        var currentFirstTwo = String(currentYear).slice(0, 2);
        return verification$4(false, firstTwo === currentFirstTwo);
    }
    if (len > 4) {
        return verification$4(false, false);
    }
    var numericValue = parseInt(value, 10);
    var twoDigitYear = Number(String(currentYear).substr(2, 2));
    var valid = false;
    if (len === 2) {
        if (String(currentYear).substr(0, 2) === value) {
            return verification$4(false, true);
        }
        isCurrentYear = twoDigitYear === numericValue;
        valid =
            numericValue >= twoDigitYear &&
                numericValue <= twoDigitYear + maxElapsedYear;
    }
    else if (len === 4) {
        isCurrentYear = currentYear === numericValue;
        valid =
            numericValue >= currentYear &&
                numericValue <= currentYear + maxElapsedYear;
    }
    return verification$4(valid, valid, isCurrentYear);
}
exports$d.expirationYear = expirationYear;
        
            var __esModule$b = __module$r.exports.__esModule;

var __require__import__5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  expirationYear: expirationYear,
  __esModule: __esModule$b
});

var __exports$q = {}; var exports$c = __exports$q; var __module$q = { exports: __exports$q };
                    if (typeof module !== "undefined") for (var prop$q in module) { prop$q !== "exports" && (__module$q[prop$q] = module[prop$q]);}Object.defineProperty(exports$c, "__esModule", { value: true });
exports$c.expirationMonth = void 0;
function verification$3(isValid, isPotentiallyValid, isValidForThisYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isValidForThisYear: isValidForThisYear || false,
    };
}
function expirationMonth(value) {
    var currentMonth = new Date().getMonth() + 1;
    if (typeof value !== "string") {
        return verification$3(false, false);
    }
    if (value.replace(/\s/g, "") === "" || value === "0") {
        return verification$3(false, true);
    }
    if (!/^\d*$/.test(value)) {
        return verification$3(false, false);
    }
    var month = parseInt(value, 10);
    if (isNaN(Number(value))) {
        return verification$3(false, false);
    }
    var result = month > 0 && month < 13;
    return verification$3(result, result, result && month >= currentMonth);
}
exports$c.expirationMonth = expirationMonth;
        
            var __esModule$a = __module$q.exports.__esModule;

var __require__import__4$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  expirationMonth: expirationMonth,
  __esModule: __esModule$a
});

var __exports$p = {}; var exports$b = __exports$p; var __module$p = { exports: __exports$p };
                    if (typeof module !== "undefined") for (var prop$p in module) { prop$p !== "exports" && (__module$p[prop$p] = module[prop$p]);}// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.
Object.defineProperty(exports$b, "__esModule", { value: true });
exports$b.isArray = void 0;
exports$b.isArray = Array.isArray ||
    function (arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
    };

            var __esModule$9 = __module$p.exports.__esModule; var isArray = __module$p.exports.isArray;

var __require__import__1$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  __esModule: __esModule$9,
  isArray: isArray
});

function __interopImport$b(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$o = {}; var exports$a = __exports$o; var __module$o = { exports: __exports$o };
                    if (typeof module !== "undefined") for (var prop$o in module) { prop$o !== "exports" && (__module$o[prop$o] = module[prop$o]);}Object.defineProperty(exports$a, "__esModule", { value: true });
exports$a.parseDate = void 0;
var expiration_year_1$2 = __interopImport$b(__require__import__5);
var is_array_1 = __interopImport$b(__require__import__1$4);
function getNumberOfMonthDigitsInDateString(dateString) {
    var firstCharacter = Number(dateString[0]);
    var assumedYear;
    /*
      if the first character in the string starts with `0`,
      we know that the month will be 2 digits.
  
      '0122' => {month: '01', year: '22'}
    */
    if (firstCharacter === 0) {
        return 2;
    }
    /*
      if the first character in the string starts with
      number greater than 1, it must be a 1 digit month
  
      '322' => {month: '3', year: '22'}
    */
    if (firstCharacter > 1) {
        return 1;
    }
    /*
      if the first 2 characters make up a number between
      13-19, we know that the month portion must be 1
  
      '139' => {month: '1', year: '39'}
    */
    if (firstCharacter === 1 && Number(dateString[1]) > 2) {
        return 1;
    }
    /*
      if the first 2 characters make up a number between
      10-12, we check if the year portion would be considered
      valid if we assumed that the month was 1. If it is
      not potentially valid, we assume the month must have
      2 digits.
  
      '109' => {month: '10', year: '9'}
      '120' => {month: '1', year: '20'} // when checked in the year 2019
      '120' => {month: '12', year: '0'} // when checked in the year 2021
    */
    if (firstCharacter === 1) {
        assumedYear = dateString.substr(1);
        return expiration_year_1$2.expirationYear(assumedYear).isPotentiallyValid ? 1 : 2;
    }
    /*
      If the length of the value is exactly 5 characters,
      we assume a full year was passed in, meaning the remaining
      single leading digit must be the month value.
  
      '12202' => {month: '1', year: '2202'}
    */
    if (dateString.length === 5) {
        return 1;
    }
    /*
      If the length of the value is more than five characters,
      we assume a full year was passed in addition to the month
      and therefore the month portion must be 2 digits.
  
      '112020' => {month: '11', year: '2020'}
    */
    if (dateString.length > 5) {
        return 2;
    }
    /*
      By default, the month value is the first value
    */
    return 1;
}
function parseDate(datestring) {
    var date;
    if (/^\d{4}-\d{1,2}$/.test(datestring)) {
        date = datestring.split("-").reverse();
    }
    else if (/\//.test(datestring)) {
        date = datestring.split(/\s*\/\s*/g);
    }
    else if (/\s/.test(datestring)) {
        date = datestring.split(/ +/g);
    }
    if (is_array_1.isArray(date)) {
        return {
            month: date[0] || "",
            year: date.slice(1).join(),
        };
    }
    var numberOfDigitsInMonth = getNumberOfMonthDigitsInDateString(datestring);
    var month = datestring.substr(0, numberOfDigitsInMonth);
    return {
        month: month,
        year: datestring.substr(month.length),
    };
}
exports$a.parseDate = parseDate;
        
            var __esModule$8 = __module$o.exports.__esModule;

var __require__import__0$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  parseDate: parseDate,
  __esModule: __esModule$8
});

function __interopImport$a(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$n = {}; var exports$9 = __exports$n; var __module$n = { exports: __exports$n };
                    if (typeof module !== "undefined") for (var prop$n in module) { prop$n !== "exports" && (__module$n[prop$n] = module[prop$n]);}var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(exports$9, "__esModule", { value: true });
exports$9.expirationDate = void 0;
var parse_date_1 = __interopImport$a(__require__import__0$5);
var expiration_month_1$1 = __interopImport$a(__require__import__4$2);
var expiration_year_1$1 = __interopImport$a(__require__import__5);
function verification$2(isValid, isPotentiallyValid, month, year) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        month: month,
        year: year,
    };
}
function expirationDate(value, maxElapsedYear) {
    var date;
    if (typeof value === "string") {
        value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, "$1/$2");
        date = parse_date_1.parseDate(String(value));
    }
    else if (value !== null && typeof value === "object") {
        var fullDate = __assign$1({}, value);
        date = {
            month: String(fullDate.month),
            year: String(fullDate.year),
        };
    }
    else {
        return verification$2(false, false, null, null);
    }
    var monthValid = expiration_month_1$1.expirationMonth(date.month);
    var yearValid = expiration_year_1$1.expirationYear(date.year, maxElapsedYear);
    if (monthValid.isValid) {
        if (yearValid.isCurrentYear) {
            var isValidForThisYear = monthValid.isValidForThisYear;
            return verification$2(isValidForThisYear, isValidForThisYear, date.month, date.year);
        }
        if (yearValid.isValid) {
            return verification$2(true, true, date.month, date.year);
        }
    }
    if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) {
        return verification$2(false, true, null, null);
    }
    return verification$2(false, false, null, null);
}
exports$9.expirationDate = expirationDate;
        
            var __esModule$7 = __module$n.exports.__esModule;

var __require__import__3$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  expirationDate: expirationDate,
  __esModule: __esModule$7
});

var __exports$m = {}; var exports$8 = __exports$m; var __module$m = { exports: __exports$m };
                    if (typeof module !== "undefined") for (var prop$m in module) { prop$m !== "exports" && (__module$m[prop$m] = module[prop$m]);}Object.defineProperty(exports$8, "__esModule", { value: true });
exports$8.clone = void 0;
function clone(originalObject) {
    if (!originalObject) {
        return null;
    }
    return JSON.parse(JSON.stringify(originalObject));
}
exports$8.clone = clone;
        
            var __esModule$6 = __module$m.exports.__esModule;

var __require__import__4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clone: clone,
  __esModule: __esModule$6
});

var __exports$l = {}; var exports$7 = __exports$l; var __module$l = { exports: __exports$l };
                    if (typeof module !== "undefined") for (var prop$l in module) { prop$l !== "exports" && (__module$l[prop$l] = module[prop$l]);}Object.defineProperty(exports$7, "__esModule", { value: true });
exports$7.findBestMatch = void 0;
function hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) { return result.matchStrength; }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */
    return (numberOfResultsWithMaxStrengthProperty > 0 &&
        numberOfResultsWithMaxStrengthProperty === results.length);
}
function findBestMatch(results) {
    if (!hasEnoughResultsToDetermineBestMatch(results)) {
        return null;
    }
    return results.reduce(function (bestMatch, result) {
        if (!bestMatch) {
            return result;
        }
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */
        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
            return result;
        }
        return bestMatch;
    });
}
exports$7.findBestMatch = findBestMatch;
        
            var __esModule$5 = __module$l.exports.__esModule;

var __require__import__3$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  findBestMatch: findBestMatch,
  __esModule: __esModule$5
});

var __exports$k = {}; var exports$6 = __exports$k; var __module$k = { exports: __exports$k };
                    if (typeof module !== "undefined") for (var prop$k in module) { prop$k !== "exports" && (__module$k[prop$k] = module[prop$k]);}Object.defineProperty(exports$6, "__esModule", { value: true });
exports$6.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
exports$6.isValidInputType = isValidInputType;
        
            var __esModule$4 = __module$k.exports.__esModule;

var __require__import__2$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isValidInputType: isValidInputType,
  __esModule: __esModule$4
});

var __exports$j = {}; var exports$5 = __exports$j; var __module$j = { exports: __exports$j };
                    if (typeof module !== "undefined") for (var prop$j in module) { prop$j !== "exports" && (__module$j[prop$j] = module[prop$j]);}/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */
Object.defineProperty(exports$5, "__esModule", { value: true });
exports$5.matches = void 0;
function matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return (integerRepresentationOfCardNumber >= min &&
        integerRepresentationOfCardNumber <= max);
}
function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return (pattern.substring(0, cardNumber.length) ===
        cardNumber.substring(0, pattern.length));
}
function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
    }
    return matchesPattern(cardNumber, pattern);
}
exports$5.matches = matches;
        
            var __esModule$3 = __module$j.exports.__esModule;

var __require__import__1$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  matches: matches,
  __esModule: __esModule$3
});

function __interopImport$9(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$i = {}; var exports$4 = __exports$i; var __module$i = { exports: __exports$i };
                    if (typeof module !== "undefined") for (var prop$i in module) { prop$i !== "exports" && (__module$i[prop$i] = module[prop$i]);}Object.defineProperty(exports$4, "__esModule", { value: true });
exports$4.addMatchingCardsToResults = void 0;
var clone_1$1 = __interopImport$9(__require__import__4$1);
var matches_1 = __interopImport$9(__require__import__1$3);
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for (i = 0; i < cardConfiguration.patterns.length; i++) {
        var pattern = cardConfiguration.patterns[i];
        if (!matches_1.matches(cardNumber, pattern)) {
            continue;
        }
        var clonedCardConfiguration = clone_1$1.clone(cardConfiguration);
        if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
        }
        else {
            patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
    }
}
exports$4.addMatchingCardsToResults = addMatchingCardsToResults;
        
            var __esModule$2 = __module$i.exports.__esModule;

var __require__import__1$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addMatchingCardsToResults: addMatchingCardsToResults,
  __esModule: __esModule$2
});

var __exports$h = {}; var __module$h = { exports: __exports$h };
                    if (typeof module !== "undefined") for (var prop$h in module) { prop$h !== "exports" && (__module$h[prop$h] = module[prop$h]);}var cardTypes$1 = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [4],
        gaps: [4, 8, 12],
        lengths: [16, 18, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [34, 37],
        gaps: [4, 10],
        lengths: [15],
        code: {
            name: "CID",
            size: 4,
        },
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [[300, 305], 36, 38, 39],
        gaps: [4, 10],
        lengths: [14, 16, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [6011, [644, 649], 65],
        gaps: [4, 8, 12],
        lengths: [16, 19],
        code: {
            name: "CID",
            size: 3,
        },
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [2131, 1800, [3528, 3589]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [
            620,
            [624, 626],
            [62100, 62182],
            [62184, 62187],
            [62185, 62197],
            [62200, 62205],
            [622010, 622999],
            622018,
            [622019, 622999],
            [62207, 62209],
            [622126, 622925],
            [623, 626],
            6270,
            6272,
            6276,
            [627700, 627779],
            [627781, 627799],
            [6282, 6289],
            6291,
            6292,
            810,
            [8110, 8131],
            [8132, 8151],
            [8152, 8163],
            [8164, 8171],
        ],
        gaps: [4, 8, 12],
        lengths: [14, 15, 16, 17, 18, 19],
        code: {
            name: "CVN",
            size: 3,
        },
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [
            493698,
            [500000, 504174],
            [504176, 506698],
            [506779, 508999],
            [56, 59],
            63,
            67,
            6,
        ],
        gaps: [4, 8, 12],
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [
            401178,
            401179,
            438935,
            457631,
            457632,
            431274,
            451416,
            457393,
            504175,
            [506699, 506778],
            [509000, 509999],
            627780,
            636297,
            636368,
            [650031, 650033],
            [650035, 650051],
            [650405, 650439],
            [650485, 650538],
            [650541, 650598],
            [650700, 650718],
            [650720, 650727],
            [650901, 650978],
            [651652, 651679],
            [655000, 655019],
            [655021, 655058],
        ],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVE",
            size: 3,
        },
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [[2200, 2204]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVP2",
            size: 3,
        },
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [606282],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
};
__module$h.exports = cardTypes$1;
var cardTypes$2 = __module$h.exports;

var __require__import__0$4 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), cardTypes$2, {
  'default': cardTypes$2
}));

function __interopImport$8(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$g = {}; var __module$g = { exports: __exports$g };
                    if (typeof module !== "undefined") for (var prop$g in module) { prop$g !== "exports" && (__module$g[prop$g] = module[prop$g]);}var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var cardTypes = __interopImport$8(__require__import__0$4);
var add_matching_cards_to_results_1 = __interopImport$8(__require__import__1$2);
var is_valid_input_type_1 = __interopImport$8(__require__import__2$4);
var find_best_match_1 = __interopImport$8(__require__import__3$2);
var clone_1 = __interopImport$8(__require__import__4$1);
var customCards = {};
var cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard",
};
var ORIGINAL_TEST_ORDER = [
    cardNames.VISA,
    cardNames.MASTERCARD,
    cardNames.AMERICAN_EXPRESS,
    cardNames.DINERS_CLUB,
    cardNames.DISCOVER,
    cardNames.JCB,
    cardNames.UNIONPAY,
    cardNames.MAESTRO,
    cardNames.ELO,
    cardNames.MIR,
    cardNames.HIPER,
    cardNames.HIPERCARD,
];
var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(function (cardType) { return clone_1.clone(findType(cardType)); });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) { ignoreErrorForNotExisting = false; }
    var position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error('"' + name + '" is not a supported card type.');
    }
    return position;
}
function creditCardType$1(cardNumber) {
    var results = [];
    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
        return results;
    }
    if (cardNumber.length === 0) {
        return getAllCardTypes();
    }
    testOrder.forEach(function (cardType) {
        var cardConfiguration = findType(cardType);
        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = find_best_match_1.findBestMatch(results);
    if (bestMatch) {
        return [bestMatch];
    }
    return results;
}
creditCardType$1.getTypeInfo = function (cardType) {
    return clone_1.clone(findType(cardType));
};
creditCardType$1.removeCard = function (name) {
    var position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType$1.addCard = function (config) {
    var existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) {
        testOrder.push(config.type);
    }
};
creditCardType$1.updateCard = function (cardType, updates) {
    var originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) {
        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    }
    if (updates.type && originalObject.type !== updates.type) {
        throw new Error("Cannot overwrite type parameter.");
    }
    var clonedCard = clone_1.clone(originalObject);
    clonedCard = __assign(__assign({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType$1.changeOrder = function (name, position) {
    var currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType$1.resetModifications = function () {
    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType$1.types = cardNames;
__module$g.exports = creditCardType$1;
var index = __module$g.exports;

var __require__import__0$3 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), index, {
  'default': index
}));

var __exports$f = {}; var __module$f = { exports: __exports$f };
                    if (typeof module !== "undefined") for (var prop$f in module) { prop$f !== "exports" && (__module$f[prop$f] = module[prop$f]);}function luhn10$1(identifier) {
    var sum = 0;
    var alt = false;
    var i = identifier.length - 1;
    var num;
    while (i >= 0) {
        num = parseInt(identifier.charAt(i), 10);
        if (alt) {
            num *= 2;
            if (num > 9) {
                num = (num % 10) + 1; // eslint-disable-line no-extra-parens
            }
        }
        alt = !alt;
        sum += num;
        i--;
    }
    return sum % 10 === 0;
}
__module$f.exports = luhn10$1;
var luhn10$2 = __module$f.exports;

var __require__import__0$2 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), luhn10$2, {
  'default': luhn10$2
}));

function __interopImport$7(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$e = {}; var exports$3 = __exports$e; var __module$e = { exports: __exports$e };
                    if (typeof module !== "undefined") for (var prop$e in module) { prop$e !== "exports" && (__module$e[prop$e] = module[prop$e]);}Object.defineProperty(exports$3, "__esModule", { value: true });
exports$3.cardNumber = void 0;
var luhn10 = __interopImport$7(__require__import__0$2);
var getCardTypes = __interopImport$7(__require__import__0$3);
function verification$1(card, isPotentiallyValid, isValid) {
    return {
        card: card,
        isPotentiallyValid: isPotentiallyValid,
        isValid: isValid,
    };
}
function cardNumber(value, options) {
    if (options === void 0) { options = {}; }
    var isPotentiallyValid, isValid, maxLength;
    if (typeof value !== "string" && typeof value !== "number") {
        return verification$1(null, false, false);
    }
    var testCardValue = String(value).replace(/-|\s/g, "");
    if (!/^\d*$/.test(testCardValue)) {
        return verification$1(null, false, false);
    }
    var potentialTypes = getCardTypes(testCardValue);
    if (potentialTypes.length === 0) {
        return verification$1(null, false, false);
    }
    else if (potentialTypes.length !== 1) {
        return verification$1(null, true, false);
    }
    var cardType = potentialTypes[0];
    if (options.maxLength && testCardValue.length > options.maxLength) {
        return verification$1(cardType, false, false);
    }
    if (cardType.type === getCardTypes.types.UNIONPAY &&
        options.luhnValidateUnionPay !== true) {
        isValid = true;
    }
    else {
        isValid = luhn10(testCardValue);
    }
    maxLength = Math.max.apply(null, cardType.lengths);
    if (options.maxLength) {
        maxLength = Math.min(options.maxLength, maxLength);
    }
    for (var i = 0; i < cardType.lengths.length; i++) {
        if (cardType.lengths[i] === testCardValue.length) {
            isPotentiallyValid = testCardValue.length < maxLength || isValid;
            return verification$1(cardType, isPotentiallyValid, isValid);
        }
    }
    return verification$1(cardType, testCardValue.length < maxLength, false);
}
exports$3.cardNumber = cardNumber;
        
            var __esModule$1 = __module$e.exports.__esModule;

var __require__import__2$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cardNumber: cardNumber,
  __esModule: __esModule$1
});

var __exports$d = {}; var exports$2 = __exports$d; var __module$d = { exports: __exports$d };
                    if (typeof module !== "undefined") for (var prop$d in module) { prop$d !== "exports" && (__module$d[prop$d] = module[prop$d]);}Object.defineProperty(exports$2, "__esModule", { value: true });
exports$2.cardholderName = void 0;
var CARD_NUMBER_REGEX = /^[\d\s-]*$/;
var MAX_LENGTH = 255;
function verification(isValid, isPotentiallyValid) {
    return { isValid: isValid, isPotentiallyValid: isPotentiallyValid };
}
function cardholderName(value) {
    if (typeof value !== "string") {
        return verification(false, false);
    }
    if (value.length === 0) {
        return verification(false, true);
    }
    if (value.length > MAX_LENGTH) {
        return verification(false, false);
    }
    if (CARD_NUMBER_REGEX.test(value)) {
        return verification(false, true);
    }
    return verification(true, true);
}
exports$2.cardholderName = cardholderName;
        
            var __esModule = __module$d.exports.__esModule;

var __require__import__1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cardholderName: cardholderName,
  __esModule: __esModule
});

function __interopImport$6(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$c = {}; var __module$c = { exports: __exports$c };
                    if (typeof module !== "undefined") for (var prop$c in module) { prop$c !== "exports" && (__module$c[prop$c] = module[prop$c]);}var __createBinding = (undefined && undefined.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (undefined && undefined.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (undefined && undefined.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var creditCardType = __importStar(__interopImport$6(__require__import__0$3));
var cardholder_name_1 = __interopImport$6(__require__import__1$1);
var card_number_1 = __interopImport$6(__require__import__2$3);
var expiration_date_1 = __interopImport$6(__require__import__3$3);
var expiration_month_1 = __interopImport$6(__require__import__4$2);
var expiration_year_1 = __interopImport$6(__require__import__5);
var cvv_1 = __interopImport$6(__require__import__6);
var postal_code_1 = __interopImport$6(__require__import__7);
var cardValidator = {
    creditCardType: creditCardType,
    cardholderName: cardholder_name_1.cardholderName,
    number: card_number_1.cardNumber,
    expirationDate: expiration_date_1.expirationDate,
    expirationMonth: expiration_month_1.expirationMonth,
    expirationYear: expiration_year_1.expirationYear,
    cvv: cvv_1.cvv,
    postalCode: postal_code_1.postalCode,
};
__module$c.exports = cardValidator;
var valid = __module$c.exports;

const styles$D="sqnbtwe";const NewCardForm=({localeLbl,onSubmit,requestcvv,isLoading})=>{const[numberValue,setNumberValue]=useState('');const[formErrors,setFormErrors]=useState({number:'',name:'',expiration:'',cvv:'',general:''});const[formValidation,setFormValidation]=useState({validName:true,validNumber:false,validExpiration:false,validCVV:!requestcvv});const[expValue,setExpValue]=useState('');const[CVVValue,setCVVValue]=useState('');const skippedCards=['9999994570392223'];const[name,setName]=useState('');const[submitted,setSubmitted]=useState(false);const handleNumberChange=({target:{value}})=>{const trimmedValue=value.replace(/[^0-9]/g,'');const numberLength=value.startsWith('3')?15:16;if(trimmedValue.length>numberLength){return;}const numberValidation=valid.number(trimmedValue);if(numberValidation.isValid||skippedCards.includes(trimmedValue)){setFormValidation(validations=>Object.assign({},validations,{validNumber:true}));setFormErrors(errors=>Object.assign({},errors,{number:''}));}else if(!numberValidation.isValid&&trimmedValue.length===numberLength){setFormErrors(errors=>Object.assign({},errors,{number:localeLbl.cardNumberError}));}else if(!numberValidation.isValid){setFormValidation(validations=>Object.assign({},validations,{validNumber:false}));}setNumberValue(trimmedValue);};const handleExpChange=({target:{value}})=>{const trimmedValue=value.replace(/[^0-9//]/g,'');const currentYear=new Date().getFullYear().toString();if(trimmedValue.length>5){return;}const expValidation=valid.expirationDate(trimmedValue);if(expValidation.isValid){setFormValidation(validations=>Object.assign({},validations,{validExpiration:true}));setFormErrors(errors=>Object.assign({},errors,{expiration:''}));}else if(!expValidation.isValid&&trimmedValue.length===4||trimmedValue.length===3&&Number(trimmedValue[2])<currentYear[2]){setFormErrors(errors=>Object.assign({},errors,{expiration:localeLbl.cardExpError}));}else if(!expValidation.isValid){setFormValidation(validations=>Object.assign({},validations,{validExpiration:false}));}setExpValue(trimmedValue.replace(/\//g,''));};const handleCVVChange=({target:{value}})=>{const digitsCvv=numberValue.startsWith('3')?4:3;if(value.length>digitsCvv){return;}const cvvValidation=valid.cvv(value,digitsCvv);if(cvvValidation.isValid){setFormValidation(validations=>Object.assign({},validations,{validCVV:localeLbl.cvvError}));setFormErrors(errors=>Object.assign({},errors,{cvv:''}));}else if(!cvvValidation.isValid){setFormValidation(validations=>Object.assign({},validations,{validCVV:false}));}setCVVValue(value);};const handleNameChange=({target:{value}})=>{setName(value);};return/*#__PURE__*/jsxs("div",{className:styles$D,children:[/*#__PURE__*/jsx(Input,{name:"card-name",label:localeLbl.cardName,value:name,onChange:handleNameChange,error:formErrors.name,tabindex:"1"}),/*#__PURE__*/jsx(Input,{name:"card-number",label:localeLbl.cardNumber,placeholder:"0000 0000 0000 0000",value:numberValue?numberValue.match(/.{1,4}/g).join(' '):'',onChange:handleNumberChange,error:formErrors.number,tabindex:"2"}),/*#__PURE__*/jsxs("div",{className:"split-row",children:[/*#__PURE__*/jsx(Input,{name:"card-exp",label:localeLbl.cardExp,placeholder:"MM/AA",value:expValue?expValue.match(/.{1,2}/g).join('/'):'',onChange:handleExpChange,error:formErrors.expiration,tabindex:"3"}),requestcvv?/*#__PURE__*/jsx(Input,{name:"card-cvv",type:"number",label:"CVV",placeholder:"000",value:CVVValue,onChange:handleCVVChange,error:formErrors.cvv,tabindex:"4"}):null]}),/*#__PURE__*/jsxs("div",{className:"image-list",children:[/*#__PURE__*/jsx("img",{className:numberValue.length===16&&numberValue[0]==='4'?'active':'',src:"/images/visa.svg"}),/*#__PURE__*/jsx("img",{className:numberValue.length===16&&numberValue[0]==='5'?'active':'',src:"/images/mastercard.svg"}),/*#__PURE__*/jsx("img",{className:numberValue.length===15&&numberValue[0]==='3'?'active':'',src:"/images/amex.svg"})]}),formErrors.general?/*#__PURE__*/jsx("div",{className:"error",children:formErrors.general}):null,/*#__PURE__*/jsx(Button,{onClick:async()=>{setSubmitted(true);try{await onSubmit({name,number:numberValue,expiration:{month:expValue.slice(0,2),year:expValue.slice(2,expValue.length)},cvv:CVVValue});}catch(err){console.error('Failed to save card',err);setFormErrors(errors=>Object.assign({},errors,{general:err.toString()}));}finally{setSubmitted(false);}},htmlProps:{disabled:!Object.values(formValidation).every(item=>item)||submitted,tabIndex:'4'},loading:isLoading,children:localeLbl.formAction})]});};NewCardForm.defaultProps={localeLbl:{cardName:'Nombre de la tarjeta',cardNumber:'Número de tarjeta',cardNumberError:'Número de tarjeta no válido.',cardExp:'Vencimiento',cardExpError:'fecha no válida.',formAction:'Aceptar'},requestcvv:false,isLoading:false};

var _g$4;

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

function SvgWhatsapp$1(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React$1.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#E5E5E5",
    d: "M.513 24.094a.511.511 0 01-.495-.648l1.567-5.72a11.942 11.942 0 01-1.489-5.783C.099 5.358 5.458 0 12.043 0a11.868 11.868 0 018.45 3.503 11.873 11.873 0 013.497 8.45c-.003 6.585-5.363 11.943-11.947 11.943h-.005c-1.924 0-3.83-.47-5.528-1.357L.643 24.077a.484.484 0 01-.13.017z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#FFF",
    d: "M.513 23.581l1.622-5.923c-1-1.734-1.527-3.7-1.526-5.715C.61 5.64 5.74.513 12.043.513a11.358 11.358 0 018.088 3.352 11.36 11.36 0 013.346 8.087c-.003 6.303-5.133 11.431-11.434 11.431h-.005c-1.914 0-3.794-.48-5.464-1.391l-6.061 1.59zm6.342-3.658l.347.205a9.49 9.49 0 004.837 1.325h.004c5.238 0 9.5-4.263 9.503-9.501a9.442 9.442 0 00-2.78-6.722 9.444 9.444 0 00-6.72-2.787c-5.242 0-9.505 4.262-9.507 9.5 0 1.796.502 3.544 1.453 5.057l.226.36-.96 3.506 3.597-.943z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#64B161",
    d: "M.91 23.182l1.566-5.718a11.012 11.012 0 01-1.473-5.517C1.005 5.862 5.957.912 12.04.912a10.962 10.962 0 017.808 3.237 10.966 10.966 0 013.23 7.807c-.003 6.084-4.954 11.035-11.038 11.035h-.005c-1.847 0-3.662-.464-5.274-1.343L.91 23.182z"
  }), /*#__PURE__*/React$1.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M.512 23.58l1.622-5.922c-1-1.734-1.527-3.7-1.526-5.715C.611 5.64 5.74.513 12.042.513c3.059 0 5.93 1.19 8.088 3.351a11.362 11.362 0 013.346 8.088c-.003 6.302-5.132 11.43-11.434 11.43h-.005a11.43 11.43 0 01-5.464-1.39L.513 23.58zm6.342-3.658l.347.206a9.495 9.495 0 004.838 1.324h.003c5.238 0 9.501-4.262 9.504-9.5 0-2.54-.987-4.927-2.781-6.723a9.441 9.441 0 00-6.72-2.786c-5.241 0-9.504 4.262-9.506 9.5A9.47 9.47 0 003.992 17l.226.36-.96 3.505 3.596-.943z"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M9.185 7.164c-.214-.476-.44-.485-.643-.494-.167-.007-.358-.006-.548-.006-.19 0-.5.071-.762.357s-1 .977-1 2.383c0 1.406 1.024 2.764 1.167 2.955.143.19 1.976 3.167 4.88 4.312 2.414.952 2.905.763 3.429.715.523-.047 1.69-.69 1.928-1.358.238-.667.238-1.239.167-1.358-.072-.12-.262-.19-.548-.334-.286-.142-1.69-.834-1.952-.93-.262-.094-.453-.142-.643.144s-.738.93-.905 1.12c-.166.19-.333.215-.619.072-.285-.144-1.206-.445-2.297-1.419-.85-.757-1.423-1.692-1.59-1.978-.166-.286-.002-.427.126-.583.231-.281.619-.786.714-.977.095-.19.048-.357-.024-.5-.071-.143-.627-1.556-.88-2.121z"
  })))));
}

const styles$C="s7uzjjs";const ShareWhatsapp=({name,phone,onSubmit,link,show,timeout,onCancel,country})=>{const[formErrors,setFormErrors]=useState({name:'',phone:''});const[formValidation,setFormValidation]=useState({validName:false,validPhone:false});const[nameValue,setName]=useState(name);const[countryShort]=useState(country);const[phoneValue,setPhoneValue]=useState(phone);const handleNameChange=({target:{value}})=>{if(value){setFormValidation(validations=>Object.assign({},validations,{validName:true}));setFormErrors(errors=>Object.assign({},errors,{name:''}));}else {setFormValidation(validations=>Object.assign({},validations,{validPhone:false}));setFormErrors(errors=>Object.assign({},errors,{name:'El nombre es requerido'}));}setName(value);};const handlePhoneChange=value=>{if(value&&value.length>12){return;}if(value&&value.length===12){setFormValidation(validations=>Object.assign({},validations,{validPhone:true}));setFormErrors(errors=>Object.assign({},errors,{phone:''}));}else {setFormValidation(validations=>Object.assign({},validations,{validPhone:false}));setFormErrors(errors=>Object.assign({},errors,{phone:'Número de teléfono no válido.'}));}setPhoneValue(value);};const clearFormFn=()=>{setFormErrors({name:'',phone:''});setFormValidation({validName:false,validPhone:false});setName('');setPhoneValue('');};const handleSubmit=()=>{const waLink=encodeURI(`https://wa.me/${phoneValue}?text=Hola ${nameValue}, este es tu link de pago ${link}`);window.open(waLink);clearFormFn();onSubmit({name:nameValue,phone:phoneValue});};const handleOnCancel=()=>{clearFormFn();onCancel();};return/*#__PURE__*/jsx(CSSTransition,{in:show,mountOnEnter:true,unmountOnExit:true,timeout:{enter:timeout,exit:300},classNames:"notification",children:/*#__PURE__*/jsx("div",{className:cx(styles$C),children:/*#__PURE__*/jsxs("div",{className:"container",children:[/*#__PURE__*/jsxs("div",{className:"container-title",children:[/*#__PURE__*/jsx("div",{className:"icon",children:/*#__PURE__*/jsx(SvgWhatsapp$1,{})}),/*#__PURE__*/jsx("div",{className:"title",children:/*#__PURE__*/jsx("h2",{children:"Compartir via whatsapp"})})]}),/*#__PURE__*/jsxs("div",{className:"container-form",children:[/*#__PURE__*/jsx(Input,{name:"card-name",label:"Nombre",value:nameValue,onChange:handleNameChange,error:formErrors.name,tabindex:"1",required:true}),/*#__PURE__*/jsxs("label",{className:"phone-label",children:["Tel\xE9fono ",/*#__PURE__*/jsx("span",{className:"req",children:"*"})]}),/*#__PURE__*/jsx(PhoneInput$1,{labels:es,value:phoneValue,defaultCountry:countryShort,onChange:handlePhoneChange,maxLength:"9"}),/*#__PURE__*/jsxs("div",{className:"actions",children:[/*#__PURE__*/jsx(Button,{onClick:handleOnCancel,type:"outline",htmlProps:{tabIndex:'-1'},children:"Cancelar"}),/*#__PURE__*/jsx(Button,{onClick:handleSubmit,disabled:!Object.values(formValidation).every(item=>item),tabindex:"3",role:"secondary",children:"Compartir"})]})]})]})})});};ShareWhatsapp.defaultProps={name:'',phone:'',show:false,timeout:3000,onSubmit:()=>{},country:'GT'};

var _g$3;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

function SvgWhatsapp(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React$1.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#E5E5E5",
    d: "M.513 24.094a.511.511 0 01-.495-.648l1.567-5.72a11.942 11.942 0 01-1.489-5.783C.099 5.358 5.458 0 12.043 0a11.868 11.868 0 018.45 3.503 11.873 11.873 0 013.497 8.45c-.003 6.585-5.363 11.943-11.947 11.943h-.005c-1.924 0-3.83-.47-5.528-1.357L.643 24.077a.484.484 0 01-.13.017z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#FFF",
    d: "M.513 23.581l1.622-5.923c-1-1.734-1.527-3.7-1.526-5.715C.61 5.64 5.74.513 12.043.513a11.358 11.358 0 018.088 3.352 11.36 11.36 0 013.346 8.087c-.003 6.303-5.133 11.431-11.434 11.431h-.005c-1.914 0-3.794-.48-5.464-1.391l-6.061 1.59zm6.342-3.658l.347.205a9.49 9.49 0 004.837 1.325h.004c5.238 0 9.5-4.263 9.503-9.501a9.442 9.442 0 00-2.78-6.722 9.444 9.444 0 00-6.72-2.787c-5.242 0-9.505 4.262-9.507 9.5 0 1.796.502 3.544 1.453 5.057l.226.36-.96 3.506 3.597-.943z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#64B161",
    d: "M.91 23.182l1.566-5.718a11.012 11.012 0 01-1.473-5.517C1.005 5.862 5.957.912 12.04.912a10.962 10.962 0 017.808 3.237 10.966 10.966 0 013.23 7.807c-.003 6.084-4.954 11.035-11.038 11.035h-.005c-1.847 0-3.662-.464-5.274-1.343L.91 23.182z"
  }), /*#__PURE__*/React$1.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M.512 23.58l1.622-5.922c-1-1.734-1.527-3.7-1.526-5.715C.611 5.64 5.74.513 12.042.513c3.059 0 5.93 1.19 8.088 3.351a11.362 11.362 0 013.346 8.088c-.003 6.302-5.132 11.43-11.434 11.43h-.005a11.43 11.43 0 01-5.464-1.39L.513 23.58zm6.342-3.658l.347.206a9.495 9.495 0 004.838 1.324h.003c5.238 0 9.501-4.262 9.504-9.5 0-2.54-.987-4.927-2.781-6.723a9.441 9.441 0 00-6.72-2.786c-5.241 0-9.504 4.262-9.506 9.5A9.47 9.47 0 003.992 17l.226.36-.96 3.505 3.596-.943z"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M9.185 7.164c-.214-.476-.44-.485-.643-.494-.167-.007-.358-.006-.548-.006-.19 0-.5.071-.762.357s-1 .977-1 2.383c0 1.406 1.024 2.764 1.167 2.955.143.19 1.976 3.167 4.88 4.312 2.414.952 2.905.763 3.429.715.523-.047 1.69-.69 1.928-1.358.238-.667.238-1.239.167-1.358-.072-.12-.262-.19-.548-.334-.286-.142-1.69-.834-1.952-.93-.262-.094-.453-.142-.643.144s-.738.93-.905 1.12c-.166.19-.333.215-.619.072-.285-.144-1.206-.445-2.297-1.419-.85-.757-1.423-1.692-1.59-1.978-.166-.286-.002-.427.126-.583.231-.281.619-.786.714-.977.095-.19.048-.357-.024-.5-.071-.143-.627-1.556-.88-2.121z"
  })))));
}

const styles$B="ssgbrdt";const PaymentLink=({linkTitle,linkText,handleOnChange,dueDate,country,inputProps})=>{const[showShareWhatsapp,setShowShareWhatsapp]=useState(false);const handlerEsc=({key})=>{if(key==='Escape'){setShowShareWhatsapp(false);}};useEffect(()=>{window.addEventListener('keydown',handlerEsc);return ()=>{window.removeEventListener('keydown',handlerEsc);};},[]);const onDateChange=event=>{handleOnChange(event.target.value);};const onCancel=()=>{setShowShareWhatsapp(false);};const shareWhatsappAction=()=>{setShowShareWhatsapp(true);};return/*#__PURE__*/jsxs("div",{className:styles$B,children:[/*#__PURE__*/jsx(CopyText,{children:/*#__PURE__*/jsx("textarea",{readOnly:true,id:"copy-me",className:"text",value:linkText})}),/*#__PURE__*/jsx(Divider,{text:"O compartir por"}),/*#__PURE__*/jsxs(Button,{label:"share",onClick:shareWhatsappAction,role:"white",type:"outline",children:[/*#__PURE__*/jsx(SvgWhatsapp,{}),"Whatsapp"]}),dueDate&&/*#__PURE__*/jsx("div",{className:"due-input",children:/*#__PURE__*/jsx(Input,{type:"date",id:"datepicker",name:"datepicker",label:"Fecha de Vencimiento de link",placeholder:"DD/MM/AAAA",onChange:onDateChange,value:dueDate,loading:false,inputProps:inputProps})}),/*#__PURE__*/jsx(ShareWhatsapp,{link:linkText,show:showShareWhatsapp,timeout:3000,onCancel:onCancel,onSubmit:()=>{setShowShareWhatsapp(false);},country:country})]});};PaymentLink.defaultProps={linkTitle:'Link de cobro',linkText:'',handleOnChange:()=>{},dueDate:'',country:'',inputProps:{}};

const styles$A="s11c0jlh";const orderStatusValueDict={pending:'pendiente',paid:'pagada',cancelled:'cancelada',finalized:'finalizada'};const Pill=({type,children})=>/*#__PURE__*/jsx("div",{className:`${styles$A} ${orderStatusValueDict[type]||type}`,children:children});Pill.defaultProps={type:'',children:'pill'};

const styles$z="suar21x";const Placeholder=({image,text,subText,children,isLoading})=>/*#__PURE__*/jsx("div",{className:styles$z,children:!isLoading&&/*#__PURE__*/jsxs(Fragment,{children:[image&&/*#__PURE__*/jsx("img",{src:image}),text&&/*#__PURE__*/jsx("h1",{children:text!==null&&text!==void 0?text:'no hay elementos'}),subText&&/*#__PURE__*/jsx("p",{children:subText}),/*#__PURE__*/jsx("div",{className:"children",children:children})]})});Placeholder.defaultProps={image:'',text:'',subText:'',children:null,isLoading:false};

const styles$y="sjr6hit";const Price=({children,prevprice,horizontal})=>/*#__PURE__*/jsxs("div",{className:[styles$y,horizontal?'hor':''].join(' '),children:[prevprice&&prevprice!==children&&/*#__PURE__*/jsx("p",{className:"product__prevprice",children:prevprice}),/*#__PURE__*/jsx("p",{className:"product__price",children:children})]});Price.defaultProps={prevprice:'',horizontal:false};

/**
 * useDidMount hook
 * Calls a function on mount
 *
 * @param {Function} callback Callback function to be called on mount
 */
function useDidMount(callback) {
    useEffect(function () {
        if (typeof callback === 'function') {
            callback();
        }
    }, []);
}

/**
 *  useDidUpdate hook
 *
 *  Fires a callback on component update
 *  Can take in a list of conditions to fire callback when one of the
 *  conditions changes
 *
 * @param {Function} callback The callback to be called on update
 * @param {Array} conditions The list of variables which trigger update when they are changed
 * @returns {undefined}
 */
function useDidUpdate(callback, conditions) {
    var hasMountedRef = useRef(false);
    if (typeof conditions !== 'undefined' && !Array.isArray(conditions)) {
        conditions = [conditions];
    }
    else if (Array.isArray(conditions) && conditions.length === 0) {
        console.warn('Using [] as the second argument makes useDidUpdate a noop. The second argument should either be `undefined` or an array of length greater than 0.');
    }
    useEffect(function () {
        if (hasMountedRef.current) {
            callback();
        }
        else {
            hasMountedRef.current = true;
        }
    }, conditions);
    useEffect(function () {
        return function () {
            hasMountedRef.current = false;
        };
    }, []);
}

/**
 * useOutsideClickRef hook
 * Checks if a click happened outside a Ref. Handy for dropdowns, modals and popups etc.
 *
 * @param handler Callback to fire on outside click
 * @param when A boolean which which activates the hook only when it is true. Useful for conditionally enable the outside click
 * @returns An array with first item being ref
 */
function useOutsideClickRef(handler, when) {
    if (when === void 0) { when = true; }
    var savedHandler = useRef(handler);
    var _a = useState(null), node = _a[0], setNode = _a[1];
    var memoizedCallback = useCallback(function (e) {
        if (node && !node.contains(e.target)) {
            savedHandler.current(e);
        }
    }, [node]);
    useEffect(function () {
        savedHandler.current = handler;
    });
    var ref = useCallback(function (node) {
        setNode(node);
    }, []);
    useEffect(function () {
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("ontouchstart", memoizedCallback, true);
            return function () {
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("ontouchstart", memoizedCallback, true);
            };
        }
    }, [when, memoizedCallback]);
    return [ref];
}

var _path$d;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

function SvgClose(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$i({
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$d || (_path$d = /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  })));
}

const _excluded$2=["open","title","onClose","children","withOverlay","root","classNames"];function _objectWithoutPropertiesLoose$3(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const styles$x="sz15slt";const SidePanel=_ref=>{let{open=false,title='',onClose=()=>{},children=/*#__PURE__*/jsx(Fragment,{}),withOverlay=false,root='',classNames}=_ref,rest=_objectWithoutPropertiesLoose$3(_ref,_excluded$2);useDidMount(()=>{if(root){const rootNode=document.getElementById(root);if(open)rootNode.classList.add('panel-open');else rootNode.classList.remove('panel-open');}});return/*#__PURE__*/jsxs("div",Object.assign({className:cx(styles$x,classNames)},rest,{children:[/*#__PURE__*/jsx("div",{className:"panel-wrapper",children:/*#__PURE__*/jsx("div",{className:"panel-container",children:/*#__PURE__*/jsxs("div",{className:"panel",children:[/*#__PURE__*/jsxs("div",{className:"panel-header",children:[title&&/*#__PURE__*/jsx("h2",{className:"panel-title",children:title}),/*#__PURE__*/jsx("div",{className:"close-container",children:/*#__PURE__*/jsx("button",{type:"button",className:"close-btn",onClick:onClose,children:/*#__PURE__*/jsx(SvgClose,{})})})]}),/*#__PURE__*/jsx("div",{className:"panel-content",children:children})]})})}),withOverlay&&/*#__PURE__*/jsx("div",{className:"overlay",onClick:onClose})]}));};SidePanel.defaultProps={onExited:()=>{},title:'',withOverlay:false,root:'',classNames:''};

const SidePanelWrapper=({open:_open=false,sidePanelProps:_sidePanelProps={},children:_children=/*#__PURE__*/jsx(Fragment,{})})=>/*#__PURE__*/jsx(Portal,{children:/*#__PURE__*/jsx(MountAnimation,{isVisible:_open,mountOnEnter:true,unmountOnExit:true,classNames:"slide",timeout:400,children:/*#__PURE__*/jsx(SidePanel,Object.assign({open:_open},_sidePanelProps,{children:_children}))})});

var _path$c;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function SvgDrop(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$h({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React$1.createElement("path", {
    d: "M23.333 11.28A1.333 1.333 0 0022 12.613v4.507l-1.973-1.973a3.72 3.72 0 00-5.24 0l-.934.946-3.306-3.32a3.72 3.72 0 00-5.24 0L3.333 14.76V7.28a1.333 1.333 0 011.334-1.333h10.666a1.333 1.333 0 100-2.667H4.667a4 4 0 00-4 4v16.293a3.72 3.72 0 003.706 3.707H20.96c.361-.003.72-.057 1.067-.16a3.653 3.653 0 002.666-3.533V12.613a1.331 1.331 0 00-1.36-1.333zM4.667 24.613a1.334 1.334 0 01-1.334-1.333v-4.76l3.854-3.853a1.04 1.04 0 011.466 0l9.96 9.946H4.667zM22 23.28a1.334 1.334 0 01-.24.72l-6.027-6.053.947-.934a1.026 1.026 0 011.467 0L22 20.893v2.387zm4-20h-1.333V1.947a1.333 1.333 0 10-2.667 0V3.28h-1.333a1.333 1.333 0 000 2.667H22V7.28a1.334 1.334 0 002.667 0V5.947H26a1.333 1.333 0 000-2.667z",
    fill: "#B0AEC7"
  })));
}

var _path$b;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function SvgRefresh(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$g({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React$1.createElement("path", {
    d: "M12.773 9.696h-3.02a.667.667 0 000 1.333h1.6a5.334 5.334 0 01-9.186-3.673.667.667 0 10-1.334 0 6.667 6.667 0 0011.254 4.82v1.18a.667.667 0 101.333 0v-3a.667.667 0 00-.647-.66zM7.5.689a6.667 6.667 0 00-4.587 1.847v-1.18a.667.667 0 00-1.333 0v3a.667.667 0 00.667.666h3a.667.667 0 000-1.333h-1.6a5.333 5.333 0 019.186 3.667.667.667 0 101.334 0A6.667 6.667 0 007.5.689z",
    fill: "#806BB9"
  })));
}

var _path$a;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function SvgTrash(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$f({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React$1.createElement("path", {
    d: "M5.167 11.356a.667.667 0 00.666-.667v-4a.667.667 0 10-1.333 0v4a.667.667 0 00.667.667zm6.666-8H9.167v-.667a2 2 0 00-2-2H5.833a2 2 0 00-2 2v.667H1.167a.667.667 0 000 1.333h.666v7.333a2 2 0 002 2h5.334a2 2 0 002-2V4.69h.666a.667.667 0 100-1.333zm-6.666-.667a.667.667 0 01.666-.667h1.334a.667.667 0 01.666.667v.667H5.167v-.667zm4.666 9.333a.667.667 0 01-.666.667H3.833a.667.667 0 01-.666-.667V4.69h6.666v7.333zm-2-.666a.667.667 0 00.667-.667v-4a.667.667 0 00-1.333 0v4a.667.667 0 00.666.667z",
    fill: "#806BB9"
  })));
}

const styles$w="slt26f9";const SingleDropzone=({onImageDrop,onRemove,image,maxSize,minSize})=>{const[url,setUrl]=useState(image);useEffect(()=>{setUrl(image);},[image]);const onDrop=useCallback(([acceptedFile])=>{if(acceptedFile){onImageDrop(acceptedFile);const urlFile=URL.createObjectURL(acceptedFile);setUrl(urlFile);}else {setUrl('');}},[onImageDrop]);const{getRootProps,getInputProps,isDragActive,fileRejections,open}=useDropzone({accept:'image/*',multiple:false,minSize,maxSize,noClick:!!url,onDrop});const dropClasses=cx('dropzone',{active:isDragActive});const onRemoveFile=()=>{onRemove(url);setUrl('');};return/*#__PURE__*/jsxs("div",{className:styles$w,children:[/*#__PURE__*/jsxs("div",Object.assign({},getRootProps({className:dropClasses}),{children:[/*#__PURE__*/jsx("input",Object.assign({},getInputProps())),/*#__PURE__*/jsx("div",{className:"content",children:url?/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("img",{src:url}),/*#__PURE__*/jsxs("div",{className:"actions",children:[/*#__PURE__*/jsxs(Button,{role:"white",onClick:open,children:[/*#__PURE__*/jsx(SvgRefresh,{}),"Actualizar"]}),/*#__PURE__*/jsxs(Button,{role:"white",onClick:onRemoveFile,children:[/*#__PURE__*/jsx(SvgTrash,{}),"Eliminar"]})]})]}):/*#__PURE__*/jsx(Placeholder,{image:SvgDrop,text:"Sube una imagen desde tu galer\xEDa",subText:"(PNG, JPG, 1MB M\xE1x)"})})]})),fileRejections.length>0&&/*#__PURE__*/jsx("p",{className:"errors",children:"Archivo inv\xE1lido. Aseg\xFArese de usar una imagen que pese menos de 1MB."})]});};SingleDropzone.defaultProps={image:'',maxSize:1000000,minSize:1000};

const styles$v="s177v1bv";const StatusSelect=({inputProps,options,statusType,selectProps,classType})=>{let cs='status';if(statusType==='delivery'){cs='delivery';}return/*#__PURE__*/jsx(Input,Object.assign({type:"select"},inputProps,{inputClassName:[styles$v,`${cs}${inputProps.value}`,classType].join(' '),options:options,selectProps:Object.assign({isClearable:false,isSearchable:false},selectProps)}));};StatusSelect.defaultProps={inputProps:{},selectProps:{},options:[],statusType:'',classType:''};

const styles$u="schz2du";const StarsRating=({rating,color})=>{return/*#__PURE__*/jsxs("div",{className:styles$u,children:[/*#__PURE__*/jsxs("div",{className:"stars-top",style:{width:`${rating}%`,color},children:[/*#__PURE__*/jsx("span",{children:"\u2605"}),/*#__PURE__*/jsx("span",{children:"\u2605"}),/*#__PURE__*/jsx("span",{children:"\u2605"}),/*#__PURE__*/jsx("span",{children:"\u2605"}),/*#__PURE__*/jsx("span",{children:"\u2605"})]}),/*#__PURE__*/jsxs("div",{className:"stars-bottom",style:{color},children:[/*#__PURE__*/jsx("span",{children:"\u2606"}),/*#__PURE__*/jsx("span",{children:"\u2606"}),/*#__PURE__*/jsx("span",{children:"\u2606"}),/*#__PURE__*/jsx("span",{children:"\u2606"}),/*#__PURE__*/jsx("span",{children:"\u2606"})]})]});};StarsRating.defaultProps={rating:0,color:''};

var _g$2;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function SvgCalendar(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React$1.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#565557",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React$1.createElement("rect", {
    width: 18,
    height: 18,
    y: 2,
    rx: 2
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M13 0v4M5 0v4M0 8h18"
  }))));
}

var _g$1;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function SvgClock(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React$1.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#565557",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React$1.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M10 4v6l4 2"
  }))));
}

var _g;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function SvgLocation(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), _g || (_g = /*#__PURE__*/React$1.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#565557",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M18 9c0 7-9 13-9 13S0 16 0 9a9 9 0 0118 0h0z"
  }), /*#__PURE__*/React$1.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 3
  }))));
}

const styles$t="s1m7bo3b";const SuccessOrder=({orderNumber,deliveryDate,adressList})=>{dayjs.locale('es-us');return/*#__PURE__*/jsxs("div",{className:cx(styles$t),children:[/*#__PURE__*/jsx("div",{className:"container-title",children:/*#__PURE__*/jsxs("div",{className:"title",children:[/*#__PURE__*/jsx("h2",{children:"\xA1Orden realizada con \xE9xito!"}),/*#__PURE__*/jsx("p",{children:"Fecha y hora de entrega"}),/*#__PURE__*/jsx("p",{children:"(Aproximado)"})]})}),deliveryDate&&/*#__PURE__*/jsxs("div",{className:"container-schedule",children:[/*#__PURE__*/jsxs("div",{className:"fake-input date",children:[/*#__PURE__*/jsx(SvgCalendar,{}),dayjs(deliveryDate).format('DD MMMM YYYY')]}),/*#__PURE__*/jsxs("div",{className:"fake-input hour",children:[/*#__PURE__*/jsx(SvgClock,{}),dayjs(deliveryDate).format('h:mm A')]})]}),/*#__PURE__*/jsxs("div",{className:"container-details",children:[/*#__PURE__*/jsxs("div",{className:"title-details",children:[/*#__PURE__*/jsxs("div",{children:["Orden #",orderNumber]}),/*#__PURE__*/jsx("div",{className:"line"})]}),/*#__PURE__*/jsx("div",{className:"adress",children:/*#__PURE__*/jsx("ul",{children:adressList&&adressList.map(adress=>/*#__PURE__*/jsxs("li",{children:[/*#__PURE__*/jsx("div",{className:"location-icon",children:/*#__PURE__*/jsx(SvgLocation,{})}),/*#__PURE__*/jsxs("div",{children:[/*#__PURE__*/jsxs("span",{className:"title",children:[adress.title,":"]}),adress.detail]})]},adress.id))})})]})]});};SuccessOrder.defaultProps={deliveryDate:''};

const ZENDESK_INSTANCE='h4bdev';const styles$s="sw2kk8m";const SupportForm=({name,email,phone,onSubmit,show,timeout,onCancel})=>{const[formErrors,setFormErrors]=useState({name:'',phone:'',email:'',subject:'',comment:''});const[formValidation,setFormValidation]=useState({validName:false,validPhone:false,validEmail:true,validComment:false,validSubject:false});const[nameValue,setName]=useState(name);const[emailValue,setEmailValue]=useState(email);const[phoneValue,setPhoneValue]=useState(phone);const[subjectValue,setSubjectValue]=useState();const[commentValue,setCommentValue]=useState();const clearFormFn=()=>{setFormErrors({name:'',phone:'',email:'',subject:'',comment:''});setFormValidation({validName:false,validPhone:false,validEmail:true,validComment:false,validSubject:false});setName('');setPhoneValue('');setSubjectValue('');setCommentValue('');};const handleNameChange=({target:{value}})=>{if(value){setFormValidation(validations=>Object.assign({},validations,{validName:true}));setFormErrors(errors=>Object.assign({},errors,{name:''}));}else {setFormValidation(validations=>Object.assign({},validations,{validPhone:false}));setFormErrors(errors=>Object.assign({},errors,{name:'El nombre es requerido'}));}setName(value);};const handleEmailChange=({target:{value}})=>{if(value){setFormValidation(validations=>Object.assign({},validations,{validEmail:true}));setFormErrors(errors=>Object.assign({},errors,{email:''}));}else {setFormValidation(validations=>Object.assign({},validations,{validEmail:false}));setFormErrors(errors=>Object.assign({},errors,{name:'El email es requerido'}));}setEmailValue(value);};const handlePhoneChange=({target:{value}})=>{if(value.length>8){return;}if(value.length===8){setFormValidation(validations=>Object.assign({},validations,{validPhone:true}));setFormErrors(errors=>Object.assign({},errors,{phone:''}));}else {setFormValidation(validations=>Object.assign({},validations,{validPhone:false}));setFormErrors(errors=>Object.assign({},errors,{phone:'Número de teléfono no válido.'}));}setPhoneValue(value);};const handleSubjectChange=({target:{value}})=>{if(value){setFormValidation(validations=>Object.assign({},validations,{validSubject:true}));setFormErrors(errors=>Object.assign({},errors,{subject:''}));}else {setFormValidation(validations=>Object.assign({},validations,{validSubject:false}));setFormErrors(errors=>Object.assign({},errors,{subject:'El asunto es requerido'}));}setSubjectValue(value);};const handleCommentChange=({target:{value}})=>{if(value){setFormValidation(validations=>Object.assign({},validations,{validComment:true}));setFormErrors(errors=>Object.assign({},errors,{comment:''}));}else {setFormValidation(validations=>Object.assign({},validations,{valueComment:false}));setFormErrors(errors=>Object.assign({},errors,{comment:'La descripción de tu error es obligatoria'}));}setCommentValue(value);};const sendTicketZendesk=(method,route,body={},headers={})=>{const fetchConfig={method,headers:Object.assign({// add default headers here
'Content-Type':'application/json'},headers),body:method!=='GET'?JSON.stringify(body):undefined,mode:'cors',cache:'default'};const apiUrl=`https://${ZENDESK_INSTANCE}.zendesk.com/api/v2/requests.json`;// TODO: if a component gets unmounted mid request, it will log an error
return fetch(apiUrl,fetchConfig).then(r=>{if(!r.ok);if(r.status===204||r.status===404);return r.json();}).then(r=>{if(r){// this is one of those horrible error messages
if(r.status===500||r.status===404);else {// Todo bien 200
return r;}return r;}return null;}).catch(e=>{// eslint-disable-next-line no-console
console.log(e);});};const handleSubmit=()=>{const ticketData={request:{requester:{name:nameValue,email:emailValue},subject:subjectValue,comment:{body:commentValue},custom_fields:[{id:360047313634,value:'Vinoteca'},{id:360047307213,value:phoneValue}]}};const responseZdk=sendTicketZendesk('POST','requests.json',ticketData);clearFormFn();onSubmit({response:responseZdk});};const handleCancel=()=>{clearFormFn();onCancel();};return/*#__PURE__*/jsx(CSSTransition,{in:show,mountOnEnter:true,unmountOnExit:true,timeout:{enter:timeout,exit:300},classNames:"notification",children:/*#__PURE__*/jsx("div",{className:cx(styles$s),children:/*#__PURE__*/jsxs("div",{className:"container",children:[/*#__PURE__*/jsx("div",{className:"container-title",children:/*#__PURE__*/jsx("div",{className:"title",children:/*#__PURE__*/jsx("h2",{children:"Necesito Asesor\xEDa"})})}),/*#__PURE__*/jsxs("div",{className:"container-form",children:[/*#__PURE__*/jsx(Input,{name:"name",label:"Nombre",value:nameValue,onChange:handleNameChange,error:formErrors.name,tabindex:"1",required:true}),/*#__PURE__*/jsx(Input,{name:"email",label:"Email",type:"email",value:emailValue,onChange:handleEmailChange,error:formErrors.email,tabindex:"2",required:true}),/*#__PURE__*/jsx(Input,{name:"phone",type:"number",label:"Tel\xE9fono",value:phoneValue,onChange:handlePhoneChange,error:formErrors.phone,tabindex:"3",required:true}),/*#__PURE__*/jsx(Input,{name:"subject",label:"Asunto",value:subjectValue,onChange:handleSubjectChange,error:formErrors.subject,tabindex:"1",required:true}),/*#__PURE__*/jsx(Input,{name:"comment",type:"textarea",label:"\xBFC\xF3mo podemos ayudarte?",onChange:handleCommentChange,value:commentValue,error:formErrors.comment,required:true}),/*#__PURE__*/jsxs("div",{className:"actions",children:[/*#__PURE__*/jsx(Button,{onClick:handleCancel,htmlProps:{tabIndex:'-1'},type:"outline",children:"cancelar"}),/*#__PURE__*/jsx(Button,{onClick:handleSubmit,disabled:!Object.values(formValidation).every(item=>item),tabindex:"4",role:"secondary",children:"enviar"})]})]})]})})});};SupportForm.defaultProps={name:'',phone:'',email:'',show:false,timeout:3000};

var __exports$b = {}; var exports$1 = __exports$b; var __module$b = { exports: __exports$b };
                    if (typeof module !== "undefined") for (var prop$b in module) { prop$b !== "exports" && (__module$b[prop$b] = module[prop$b]);}!function(e,i){"object"==typeof exports$1&&"undefined"!=typeof __module$b?__module$b.exports=i():"function"==typeof define&&define.amd?define(i):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_isBetween=i();}(undefined,(function(){return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return (r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))};}}));var isBetween = __module$b.exports;

const slug=fromStr=>{if(!fromStr){return '';}let str=fromStr.replace(/^\s+|\s+$/g,'');// Trim
str=str.toLowerCase();// remove accents, swap ñ for n, etc
const from='àáäâèéëêìíïîòóöôùúüûñç·/_,:;';const to='aaaaeeeeiiiioooouuuunc------';for(let i=0,l=from.length;i<l;i+=1){str=str.replace(new RegExp(from.charAt(i),'g'),to.charAt(i));}str=str.replace(/[^a-z0-9 -]/g,'')// remove invalid chars
.replace(/\s+/g,'-')// collapse whitespace and replace by -
.replace(/-+/g,'-');// collapse dashes
return str;};// Define a default UI for filtering
const TextColumnFilter=({column:{filterValue,setFilter}})=>{return/*#__PURE__*/jsx("input",{value:filterValue||'',onChange:e=>{setFilter(e.target.value||undefined);// Set undefined to remove the filter entirely
},placeholder:"Buscar"});};// This is a custom filter UI for selecting
// a unique option from a list
const SelectColumnFilter=({column:{filterValue,setFilter,preFilteredRows,id}})=>{// Calculate the options for filtering
// using the preFilteredRows
const options=React__default.useMemo(()=>{let hasEmpty=false;const optionsSet=new Set();preFilteredRows.forEach(row=>{optionsSet.add(row.values[id]);if(row.values[id]===''){hasEmpty=true;}});if(hasEmpty){return [...optionsSet.values()];}return ['',...optionsSet.values()];},[id,preFilteredRows]);// Render a multi-select box
return/*#__PURE__*/jsx("select",{value:filterValue,onChange:e=>{setFilter(e.target.value||undefined);},children:options.sort().map(option=>/*#__PURE__*/jsx("option",{value:option,children:option},`option-${option!==null?slug(option):'null'}`))});};const DefaultColumnFilter=params=>{const{column:{filter}}=params;switch(filter){case'text':return/*#__PURE__*/jsx(TextColumnFilter,Object.assign({},params));case'select':case'selectDeliveryOrders':case'selectStrict':return/*#__PURE__*/jsx(SelectColumnFilter,Object.assign({},params));case'fuzzyText':return/*#__PURE__*/jsx(TextColumnFilter,Object.assign({},params));default:return null;}};

/* eslint-disable react/prop-types */ // eslint-disable-next-line no-unused-vars
const styles$r="s1xwjmgb";const TablePaginator=({canPreviousPage,previousPage,canNextPage,nextPage,pageIndex,pageOptions,gotoPage,paginationText})=>{const activePage=pageIndex+1;const initialPages=pageOptions.length>5?[1,2,3,4,pageOptions.length]:pageOptions.map(opt=>opt+1);const[pages,setPages]=useState(initialPages);useEffect(()=>{setPages(initialPages);},[pageOptions]);const onPageChange=page=>{if(page===1){gotoPage(page-1);setPages(initialPages);}else if(page===pageOptions.length){gotoPage(page-1);if(pageOptions.length>5){setPages([1,page-3,page-2,page-1,page]);}}else {gotoPage(page-1);if(!pages.includes(page+1)){setPages(actualPages=>actualPages.map(p=>{if(p===1||p===pageOptions.length){return p;}return p+1;}));}else if(!pages.includes(page-1)){setPages(actualPages=>actualPages.map(p=>{if(p===1||p===pageOptions.length){return p;}return p-1;}));}}};return/*#__PURE__*/jsxs("div",{className:styles$r,children:[/*#__PURE__*/jsx("button",{type:"button",onClick:()=>previousPage(),disabled:!canPreviousPage,children:"\u27F5 anterior"}),/*#__PURE__*/jsx("ul",{children:paginationText?/*#__PURE__*/jsxs("li",{children:[activePage," de ",pageOptions.length]}):pages.map(page=>{return/*#__PURE__*/jsxs(Fragment$1,{children:[page===pages[pages.length-1]&&activePage!==page&&activePage+1!==page&&pageOptions.length>5&&/*#__PURE__*/jsx("li",{children:"..."},`dots-${page}`),/*#__PURE__*/jsx("li",{className:`cursor ${pageIndex+1===page?'active':''}`,onClick:()=>onPageChange(page),children:page},page),page===1&&!pages.includes(page+1)&&pageOptions.length>5&&/*#__PURE__*/jsx("li",{children:"..."},`dots-${page}`)]},page);})}),/*#__PURE__*/jsx("button",{type:"button",onClick:()=>nextPage(),disabled:!canNextPage,children:"siguiente \u27F6"})]});};

const styles$q="s17lxzke";const emptyStyles$2="evqublt";function fuzzyTextFilterFn$1(rows,id,filterValue){return matchSorter(rows,filterValue,{keys:[row=>row.values[id]]});}function selectDeliveryOrdersFilterFn$1(rows,id,filterValue){return rows.filter(row=>{const rowValue=row.values[id];if(row.original.orderType==='FULL'&&row.original.orderStatus!=='Anulada'&&String(rowValue).toLowerCase()===String(filterValue).toLowerCase()){return true;}return false;});}function textFilterFn$1(rows,id,filterValue){return rows.filter(row=>{const rowValue=row.values[id];return rowValue!==undefined?String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()):true;});}function selectStrictFilterFn$1(rows,id,filterValue){return rows.filter(row=>{const rowValue=row.values[id];return rowValue!==undefined?String(rowValue).toLowerCase()===String(filterValue).toLowerCase():true;});}const rangeDateFilterFn$1=(rows,id,filterValue)=>{const from=filterValue[0]||null;const to=filterValue[1]||null;dayjs.extend(isBetween);if(from&&to){return rows.filter(r=>from&&r&&r.values&&dayjs(r.values[id]).isBetween(from,to));}return rows;};// Let the table remove the filter if the string is empty
fuzzyTextFilterFn$1.autoRemove=val=>!val;const Table=({columns,data,empty:_empty='',onRowClick:_onRowClick=null,debug:_debug=false,loading:_loading=false,defaultFilters:_defaultFilters={}})=>{const filterTypes=React__default.useMemo(()=>({// Add a new fuzzyTextFilterFn filter type.
fuzzyText:fuzzyTextFilterFn$1,// Or, override the default text filter to use
// "startWith"
selectDeliveryOrders:selectDeliveryOrdersFilterFn$1,text:textFilterFn$1,selectStrict:selectStrictFilterFn$1,dateRange:rangeDateFilterFn$1}),[]);const defaultColumn=React__default.useMemo(()=>({Filter:DefaultColumnFilter,canGroupBy:false,filter:'',// we also have the index and id props
// eslint-disable-next-line react/display-name
Cell:({value})=>/*#__PURE__*/jsx("span",{className:"text",title:value,children:value||''})}),[]);const getQuery=breakpoint=>{let pixelBreak=1;if(breakpoint==='md'){pixelBreak=1024;}else if(breakpoint==='lg'){pixelBreak=1280;}return `(min-width: ${pixelBreak}px)`;};const initialState={};if(_defaultFilters){initialState.filters=Object.keys(_defaultFilters).map(key=>({id:key,value:_defaultFilters[key]}));}// Use the state and functions returned from useTable to build your UI
const{getTableProps,getTableBodyProps,headerGroups,prepareRow,page,// Instead of using 'rows', we'll use page,
// which has only the rows for the active page
// The rest of these things are super handy, too ;)
canPreviousPage,canNextPage,pageOptions,pageCount,gotoPage,nextPage,previousPage,setPageSize,state:{pageIndex,pageSize,sortBy,groupBy,expanded,filters,selectedRowIds}}=useTable({columns,data,defaultColumn,filterTypes,// We also need to pass this so the page doesn't change
// when we edit the data.
// autoResetPage: !skipReset,
// autoResetSelectedRows: !skipReset,
disableMultiSort:true,initialState},useFilters,useGroupBy,useSortBy,useExpanded,usePagination$2);const hasFilters=headerGroups[0].headers.filter(f=>f.filter!=='').length>0;return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsxs("div",Object.assign({},getTableProps(),{className:styles$q,children:[/*#__PURE__*/jsxs("div",{className:"thead",children:[headerGroups.map(headerGroup=>/*#__PURE__*/jsx("div",Object.assign({className:"tr"},headerGroup.getHeaderGroupProps(),{children:headerGroup.headers.map(column=>{const headerProps=column.getHeaderProps();return/*#__PURE__*/jsx(Media,{query:getQuery(column.showUpTo),children:/*#__PURE__*/jsx("div",Object.assign({className:"th"},headerProps,{style:column.style,children:/*#__PURE__*/jsxs("span",Object.assign({},column.getSortByToggleProps(),{children:[column.render('Header'),column.isSorted&&column.isSortedDesc&&'▼',column.isSorted&&!column.isSortedDesc&&'▲']}))}))},`media-${headerProps.key}`);})}),`hg-${headerGroup.id}`)),hasFilters&&headerGroups.map(headerGroup=>/*#__PURE__*/jsx("div",{className:"tr filters",children:headerGroup.headers.map(column=>{return/*#__PURE__*/jsx(Media,{query:getQuery(column.showUpTo),children:/*#__PURE__*/jsx("div",{className:"th filter",style:column.style,children:column.filter&&column.render('Filter')})},`filter-${column.getHeaderProps().key}`);})},`hgf-${headerGroup.id}`))]}),_loading?/*#__PURE__*/jsx("div",{className:"loading",children:/*#__PURE__*/jsx(Loading,{})}):/*#__PURE__*/jsx("div",Object.assign({className:"tbody"},getTableBodyProps(),{children:page.map(row=>{prepareRow(row);return/*#__PURE__*/jsx("div",{className:"tr",onClick:()=>{if(_onRowClick){_onRowClick(row);}},style:{cursor:_onRowClick?'pointer':'default'},children:row.cells.map(cell=>{const cellProps=cell.getCellProps();return/*#__PURE__*/jsx(Media,{query:getQuery(cell.column.showUpTo),children:/*#__PURE__*/jsxs("div",Object.assign({className:"td"},cellProps,{style:cell.column.style,children:[cell.isGrouped&&/*#__PURE__*/ // If it's a grouped cell, add an expander and row count
jsxs(Fragment,{children:[/*#__PURE__*/jsx("span",Object.assign({},row.getToggleRowExpandedProps(),{children:row.isExpanded?'○':'●'})),' ',cell.render('Cell'),`(${row.subRows.length})`]}),!cell.isGrouped&&!cell.isAggregated&&cell.isPlaceholder&&cell.render('Placeholder'),!cell.isGrouped&&!cell.isAggregated&&!cell.isPlaceholder&&cell.render('Cell')]}))},`cell-${cellProps.key}`);})},`row-${row.id}`);})}))]})),pageOptions.length>1&&/*#__PURE__*/jsx(TablePaginator,{canPreviousPage:canPreviousPage,previousPage:previousPage,canNextPage:canNextPage,pageCount:pageCount,pageIndex:pageIndex,pageSize:pageSize,gotoPage:gotoPage,nextPage:nextPage,setPageSize:setPageSize,pageOptions:pageOptions}),pageOptions.length===0&&!_loading?/*#__PURE__*/jsx("p",{className:emptyStyles$2,children:_empty}):null,_debug&&/*#__PURE__*/jsx("pre",{children:/*#__PURE__*/jsx("code",{children:JSON.stringify({pageIndex,pageSize,pageCount,canNextPage,canPreviousPage,sortBy,groupBy,expanded,filters,selectedRowIds},null,2)})})]});};// // Define a custom filter filter function

const importxlsx=()=>import('./xlsx-7304e4cd.js').then(function (n) { return n.x; });dayjs.extend(isBetween);const styles$p="sbq582";const emptyStyles$1="ednfcbm";const buttonsStyles="bhrzgyz";function fuzzyTextFilterFn(rows,id,filterValue){return matchSorter(rows,filterValue,{keys:[row=>row.values[id]]});}function textFilterFn(rows,id,filterValue){return rows.filter(row=>{const rowValue=row.values[id];return rowValue!==undefined?String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()):true;});}function selectStrictFilterFn(rows,id,filterValue){return rows.filter(row=>{const rowValue=row.values[id];return rowValue!==undefined?String(rowValue).toLowerCase()===String(filterValue).toLowerCase():true;});}function selectDeliveryOrdersFilterFn(rows,id,filterValue){return rows.filter(row=>{const rowValue=row.values[id];if(row.original.orderType==='FULL'&&row.original.orderStatus!=='Anulada'&&String(rowValue).toLowerCase()===String(filterValue).toLowerCase()){return true;}return false;});}const rangeDateFilterFn=(rows,id,filterValue)=>{const from=filterValue[0]||null;const to=filterValue[1]||null;if(from&&to){return rows.filter(r=>from&&r&&r.values&&dayjs(r.values[id]).isBetween(from,to));}return rows;};// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove=val=>!val;const getExportFileBlob=async({columns,data,fileType,fileName})=>{const XLSX=await importxlsx();if(fileType==='xlsx'){// XLSX example
const header=columns.map(c=>c.exportValue);const compatibleData=data.map(row=>{const obj={};header.forEach((col,index)=>{obj[col]=row[index];});return obj;});const wb=XLSX.utils.book_new();const ws1=XLSX.utils.json_to_sheet(compatibleData,{header});XLSX.utils.book_append_sheet(wb,ws1,'Data');const d=new Date();const addZero=num=>num<10?`0${num}`:`${num}`;XLSX.writeFile(wb,`${addZero(d.getDay())}${addZero(d.getMonth())}${addZero(d.getYear())}_${fileName}.xlsx`);// Returning false as downloading of file is already taken care of
return false;}// Other formats goes here
return false;};const ExportTable=({columns,data,empty:_empty='',onRowClick:_onRowClick=null,debug:_debug=false,loading:_loading=false})=>{const filterTypes=React__default.useMemo(()=>({// Add a new fuzzyTextFilterFn filter type.
fuzzyText:fuzzyTextFilterFn,// Or, override the default text filter to use
// "startWith"
text:textFilterFn,selectStrict:selectStrictFilterFn,selectDeliveryOrders:selectDeliveryOrdersFilterFn,dateRange:rangeDateFilterFn}),[]);const defaultColumn=React__default.useMemo(()=>({Filter:DefaultColumnFilter,canGroupBy:false,filter:'',// we also have the index and id props
// eslint-disable-next-line react/display-name
Cell:({value})=>/*#__PURE__*/jsx("span",{className:"text",title:value,children:value||''})}),[]);const getQuery=breakpoint=>{let pixelBreak=1;if(breakpoint==='md'){pixelBreak=1024;}else if(breakpoint==='lg'){pixelBreak=1280;}return `(min-width: ${pixelBreak}px)`;};// Use the state and functions returned from useTable to build your UI
const{getTableProps,getTableBodyProps,headerGroups,prepareRow,page,// Instead of using 'rows', we'll use page,
// which has only the rows for the active page
// The rest of these things are super handy, too ;)
canPreviousPage,canNextPage,pageOptions,pageCount,gotoPage,nextPage,previousPage,setPageSize,state:{pageIndex,pageSize,sortBy,groupBy,expanded,filters,selectedRowIds},exportData}=useTable({columns,data,defaultColumn,filterTypes,// We also need to pass this so the page doesn't change
// when we edit the data.
// autoResetPage: !skipReset,
// autoResetSelectedRows: !skipReset,
disableMultiSort:true,getExportFileBlob},useFilters,useGroupBy,useSortBy,useExpanded,usePagination$2,useExportData);const hasFilters=headerGroups[0].headers.filter(f=>f.filter!=='').length>0;return/*#__PURE__*/jsxs(Fragment,{children:[page.length>0&&/*#__PURE__*/jsx("div",{className:buttonsStyles,children:/*#__PURE__*/jsx(Button,{label:"export",role:"primary",type:"outline",onClick:()=>{exportData('xlsx',false);},children:"Exportar a Excel"})}),/*#__PURE__*/jsxs("div",Object.assign({},getTableProps(),{className:styles$p,children:[/*#__PURE__*/jsxs("div",{className:"thead",children:[headerGroups.map(headerGroup=>/*#__PURE__*/jsx("div",Object.assign({className:"tr"},headerGroup.getHeaderGroupProps(),{children:headerGroup.headers.map(column=>{const headerProps=column.getHeaderProps();return/*#__PURE__*/jsx(Media,{query:getQuery(column.showUpTo),children:/*#__PURE__*/jsx("div",Object.assign({className:"th"},headerProps,{style:column.style,children:/*#__PURE__*/jsxs("span",Object.assign({},column.getSortByToggleProps(),{children:[column.render('Header'),column.isSorted&&column.isSortedDesc&&'▼',column.isSorted&&!column.isSortedDesc&&'▲']}))}))},`media-${headerProps.key}`);})}),`hg-${headerGroup.id}`)),hasFilters&&headerGroups.map(headerGroup=>/*#__PURE__*/jsx("div",{className:"tr filters",children:headerGroup.headers.map(column=>/*#__PURE__*/jsx(Media,{query:getQuery(column.showUpTo),children:/*#__PURE__*/jsx("div",{className:"th filter",style:column.style,children:column.filter&&column.render('Filter')})},`filter-${column.getHeaderProps().key}`))},`hgf-${headerGroup.id}`))]}),_loading?/*#__PURE__*/jsx("div",{className:"loading",children:/*#__PURE__*/jsx(Loading,{})}):/*#__PURE__*/jsx("div",Object.assign({className:"tbody"},getTableBodyProps(),{children:page.map(row=>{prepareRow(row);return/*#__PURE__*/jsx("div",{className:"tr",onClick:()=>{if(_onRowClick){_onRowClick(row);}},style:{cursor:_onRowClick?'pointer':'default'},children:row.cells.map(cell=>{const cellProps=cell.getCellProps();return/*#__PURE__*/jsx(Media,{query:getQuery(cell.column.showUpTo),children:/*#__PURE__*/jsxs("div",Object.assign({className:"td"},cellProps,{style:cell.column.style,children:[cell.isGrouped&&/*#__PURE__*/ // If it's a grouped cell, add an expander and row count
jsxs(Fragment,{children:[/*#__PURE__*/jsx("span",Object.assign({},row.getToggleRowExpandedProps(),{children:row.isExpanded?'○':'●'})),' ',cell.render('Cell'),`(${row.subRows.length})`]}),!cell.isGrouped&&!cell.isAggregated&&cell.isPlaceholder&&cell.render('Placeholder'),!cell.isGrouped&&!cell.isAggregated&&!cell.isPlaceholder&&cell.render('Cell')]}))},`cell-${cellProps.key}`);})},`row-${row.id}`);})}))]})),pageOptions.length>1&&/*#__PURE__*/jsx(TablePaginator,{canPreviousPage:canPreviousPage,previousPage:previousPage,canNextPage:canNextPage,pageCount:pageCount,pageIndex:pageIndex,pageSize:pageSize,gotoPage:gotoPage,nextPage:nextPage,setPageSize:setPageSize,pageOptions:pageOptions}),pageOptions.length===0&&!_loading?/*#__PURE__*/jsx("p",{className:emptyStyles$1,children:_empty}):null,_debug&&/*#__PURE__*/jsx("pre",{children:/*#__PURE__*/jsx("code",{children:JSON.stringify({pageIndex,pageSize,pageCount,canNextPage,canPreviousPage,sortBy,groupBy,expanded,filters,selectedRowIds},null,2)})})]});};

const styles$o="svs8va7";const emptyStyles="eam9o94";

function MobileCardDefault({row,onRowClick}){var _cell$column;const[open,setOpen]=React__default.useState(false);const toggleMobDetail=()=>{setOpen(prev=>!prev);};const cell=row.cells.filter(col=>{var _col$column;return (_col$column=col.column)===null||_col$column===void 0?void 0:_col$column.mobileLabel;});const cells=row.cells.filter(col=>{var _col$column2,_col$column2$style;return ((_col$column2=col.column)===null||_col$column2===void 0?void 0:(_col$column2$style=_col$column2.style)===null||_col$column2$style===void 0?void 0:_col$column2$style.display)!='none';});const cellProps=cell!==null&&cell!==void 0&&cell.getCellProps?cell.getCellProps():{};return/*#__PURE__*/jsxs("div",Object.assign({className:"card",style:cell===null||cell===void 0?void 0:(_cell$column=cell.column)===null||_cell$column===void 0?void 0:_cell$column.style},cellProps,{children:[/*#__PURE__*/jsxs("div",{className:"card-title",onClick:toggleMobDetail,children:[/*#__PURE__*/jsx("div",{className:"card-cell",children:cell[0].render('Cell')},`cell-${cell[0].render('Header')}`),/*#__PURE__*/jsx("div",{className:"card-arrow",children:/*#__PURE__*/jsx("span",{className:open?'unfold':''})}),onRowClick&&/*#__PURE__*/jsx("div",{className:"card-arrow-left",onClick:e=>{e.stopPropagation();onRowClick(row);},children:/*#__PURE__*/jsx("span",{})})]}),/*#__PURE__*/jsx("div",{className:`card-detail ${open?'card-open':''}`,children:cells.map(cardCell=>{const cardCellProps=cardCell.getCellProps();return/*#__PURE__*/jsxs("div",{className:"card-cell",children:[/*#__PURE__*/jsx("p",{className:"card-header",children:cardCell.column.Header}),cardCell.render('Cell')]},`cell-${cardCellProps.key}`);})})]}));}

const PaginableTable=({columns,data,empty:_empty='',onRowClick:_onRowClick=null,debug:_debug=false,loading:_loading=false,pageCount:controlledPageCount,mobileCard,fetchData,fetchParams:_fetchParams={},paginationText})=>{const defaultColumn=React__default.useMemo(()=>({Filter:DefaultColumnFilter,canGroupBy:false,filter:'',// eslint-disable-next-line react/display-name
Cell:({value})=>/*#__PURE__*/jsx("span",{className:"text",title:value,children:value||''})}),[]);const getQuery=breakpoint=>{let pixelBreak=1;if(breakpoint==='xs'){pixelBreak=600;}else if(breakpoint==='md'){pixelBreak=1024;}else if(breakpoint==='lg'){pixelBreak=1280;}return `(min-width: ${pixelBreak}px)`;};const MobileCardComponent=mobileCard||MobileCardDefault;const{getTableProps,getTableBodyProps,headerGroups,prepareRow,page,canPreviousPage,canNextPage,pageOptions,pageCount,gotoPage,nextPage,previousPage,setPageSize,state:{pageIndex,pageSize}}=useTable({columns,data,defaultColumn,disableMultiSort:true,initialState:{pageIndex:0},manualPagination:true,pageCount:controlledPageCount,autoResetPage:false},usePagination$2);React__default.useEffect(()=>{fetchData(Object.assign({pageIndex,pageSize},_fetchParams));},[fetchData,pageIndex,pageSize]);return/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsxs("div",Object.assign({},getTableProps(),{className:styles$o,children:[/*#__PURE__*/jsx(Media,{query:getQuery('xs'),children:/*#__PURE__*/jsx("div",{className:"thead",children:headerGroups.map(headerGroup=>/*#__PURE__*/jsx("div",Object.assign({className:"tr"},headerGroup.getHeaderGroupProps(),{children:headerGroup.headers.map(column=>{const headerProps=column.getHeaderProps();return/*#__PURE__*/jsx(Media,{query:getQuery(column.showUpTo),children:/*#__PURE__*/jsx("div",Object.assign({className:"th"},headerProps,{style:column.style,children:/*#__PURE__*/jsx("span",{children:column.render('Header')})}))},`media-${headerProps.key}`);})}),`hg-${headerGroup.id}`))})}),_loading?/*#__PURE__*/jsx("div",{className:"loading",children:/*#__PURE__*/jsx(Loading,{})}):/*#__PURE__*/jsxs("div",Object.assign({className:"tbody"},getTableBodyProps(),{children:[/*#__PURE__*/jsx(Media,{query:getQuery('xs'),children:/*#__PURE__*/jsx(Fragment,{children:page.map(row=>{prepareRow(row);return/*#__PURE__*/jsx("div",{className:"tr",onClick:()=>{if(_onRowClick){_onRowClick(row);}},style:{cursor:_onRowClick?'pointer':'default'},children:row.cells.map(cell=>{const cellProps=cell.getCellProps();return/*#__PURE__*/jsx(Media,{query:getQuery(cell.column.showUpTo),children:/*#__PURE__*/jsxs("div",Object.assign({className:"td"},cellProps,{style:cell.column.style,children:[cell.isGrouped&&/*#__PURE__*/ // If it's a grouped cell, add an expander and row count
jsxs(Fragment,{children:[/*#__PURE__*/jsx("span",Object.assign({},row.getToggleRowExpandedProps(),{children:row.isExpanded?'○':'●'})),' ',cell.render('Cell'),`(${row.subRows.length})`]}),!cell.isGrouped&&!cell.isAggregated&&cell.isPlaceholder&&cell.render('Placeholder'),!cell.isGrouped&&!cell.isAggregated&&!cell.isPlaceholder&&cell.render('Cell')]}))},`cell-${cellProps.key}`);})},`row-${row.id}`);})})}),/*#__PURE__*/jsx(Media,{query:"(max-width: 600px)",children:/*#__PURE__*/jsx(Fragment,{children:page.map(row=>{prepareRow(row);return/*#__PURE__*/jsx("div",{className:"tr",style:{cursor:_onRowClick?'pointer':'default'},children:/*#__PURE__*/jsx(MobileCardComponent,{row:row,onRowClick:_onRowClick})},`row-${row.id}`);})})})]}))]})),pageOptions.length>1&&/*#__PURE__*/jsx(TablePaginator,{canPreviousPage:canPreviousPage,previousPage:previousPage,canNextPage:canNextPage,pageCount:pageCount,pageIndex:pageIndex,pageSize:pageSize,gotoPage:gotoPage,nextPage:nextPage,setPageSize:setPageSize,pageOptions:pageOptions,paginationText:paginationText}),pageOptions.length===0&&!_loading?/*#__PURE__*/jsx("p",{className:emptyStyles,children:_empty}):null,_debug&&/*#__PURE__*/jsx("pre",{children:/*#__PURE__*/jsx("code",{children:JSON.stringify({pageIndex,pageSize,pageCount,canNextPage,canPreviousPage},null,2)})})]});};

const useFilter$1=callback=>{const[state,setState]=useState({filters:{},whereParams:[]});const handler=useCallback((filterSpecifications,currentState)=>{let newWhereParams=[...currentState.whereParams];const{colId:col,value}=filterSpecifications;if(col){const index=newWhereParams.findIndex(param=>col===param.col);const paramObj={col,value};if(index!==-1){newWhereParams[index]=paramObj;}else {newWhereParams.push(paramObj);}if(!value&&value!==false){newWhereParams=newWhereParams.filter(param=>param.col!==col);}}callback({whereParams:newWhereParams});setState(Object.assign({},currentState,{filters:Object.assign({},currentState.filters,{[col]:value}),whereParams:[...newWhereParams]}));},[state]);return {handler,state};};

const usePagination$1=(callback,pageSize,initialPage)=>{const[state,setState]=useState({page:{},currentPage:initialPage,rangeStart:pageSize*initialPage-pageSize+1,rangeEnd:pageSize*initialPage});const handler=({direction,page,whereParams,totalDataCount,numberPage})=>{const pageObj={};if(direction==='next'){pageObj.endCursor=page===null||page===void 0?void 0:page.endCursor;}else {pageObj.startCursor=page===null||page===void 0?void 0:page.startCursor;}setState({page:pageObj,currentPage:numberPage,rangeStart:pageSize*numberPage-pageSize+1,rangeEnd:totalDataCount<pageSize*numberPage?totalDataCount:pageSize*numberPage});if(pageObj.startCursor||pageObj.endCursor){callback({direction,whereParams,page:pageObj});}};return {handler,state};};

const styles$n="see8a64";const MobileRowCard$1=({index,onClick,columns,item:_item={}})=>/*#__PURE__*/jsx("div",{className:cx(styles$n,'table-mobile-card'),onClick:onClick?()=>onClick(_item,index):undefined,children:columns.map(col=>/*#__PURE__*/jsxs("div",{className:"card-row",children:[/*#__PURE__*/jsx("p",{className:"column-name",children:col.name}),/*#__PURE__*/jsx("div",{className:"column-value",children:Object.prototype.hasOwnProperty.call(col,'cellRender')?col.cellRender(col.id,_item):/*#__PURE__*/jsx("p",{className:"default-render",children:String(_item[col.id])})})]},col.id))});

const styles$m="s1kbo9ih";const DesktopRow$1=({rowIndex:_rowIndex=null,onRowClick:_onRowClick=null,rowData:_rowData={},columns:_columns=[],columnsKey:_columnsKey='',getDesktopColumnStyles:_getDesktopColumnStyles=()=>{},matchesQuery:_matchesQuery={}})=>/*#__PURE__*/jsx("div",{className:cx(styles$m,'table2-row',{onRowClick:_onRowClick}),onClick:_onRowClick?()=>_onRowClick(_rowData,_rowIndex):undefined,children:_columns.map(col=>{var _col$showUpTo;return _matchesQuery[(_col$showUpTo=col.showUpTo)!==null&&_col$showUpTo!==void 0?_col$showUpTo:'sm']&&/*#__PURE__*/jsx("div",{style:_getDesktopColumnStyles(col),children:Object.prototype.hasOwnProperty.call(col,'cellRender')?col.cellRender(col.id,_rowData):String(_rowData[col.id])},`${_columnsKey}-${col.id}`);})});

const Filter$1=({column,filtersState,handleFilterChange})=>{var _column$filter$props;return/*#__PURE__*/jsx("div",{className:"filter-container",children:/*#__PURE__*/jsx(Input,Object.assign({type:column.filter.type,name:column.name,id:`${column.name}${column.filter.type}`,placeholder:"Buscar",onChange:handleFilterChange(column.id),value:filtersState[column.id]},(_column$filter$props=column.filter.props)!==null&&_column$filter$props!==void 0?_column$filter$props:{}))});};

const hasProp=Object.prototype.hasOwnProperty;const GLOBAL_MEDIA_QUERIES$1={sm:'(min-width: 1px)',md:'(min-width: 1024px)',lg:'(min-width: 1280px)'};const styles$l="s1liw31k";const getDesktopColumnStyles=col=>{var _col$flex,_col$minWidth,_col$maxWidth,_col$overflow,_col$textOverflow;return {flex:(_col$flex=col.flex)!==null&&_col$flex!==void 0?_col$flex:1,minWidth:(_col$minWidth=col.minWidth)!==null&&_col$minWidth!==void 0?_col$minWidth:0,maxWidth:(_col$maxWidth=col.maxWidth)!==null&&_col$maxWidth!==void 0?_col$maxWidth:'auto',overflow:(_col$overflow=col.overflow)!==null&&_col$overflow!==void 0?_col$overflow:'hidden',textOverflow:(_col$textOverflow=col.textOverflow)!==null&&_col$textOverflow!==void 0?_col$textOverflow:'ellipsis'};};const Table2=({title:_title='',showHeader:_showHeader=true,btnProps:_btnProps={},columns:_columns=[],data:_data=[],pageSize:_pageSize=20,initialPage:_initialPage=1,totalDataCount:_totalDataCount=0,placeholderProps:_placeholderProps={},dataKey:_dataKey='',onRowClick:_onRowClick=null,mobileBreakpoint:_mobileBreakpoint=768,loading:_loading=false,plugins:_plugins=[],pageInfo:_pageInfo=null,onDataChange:_onDataChange=()=>{}})=>{const matchesQuery=useMedia({queries:GLOBAL_MEDIA_QUERIES$1});const isMobile=useMedia({query:`(max-width: ${_mobileBreakpoint}px)`});const isDataKeyStr=typeof _dataKey==='string';const{handler:filterPluginHandler,state:stateFilters}=useFilter$1(_onDataChange);const{handler:paginationPluginHandler,state:statePagination}=usePagination$1(_onDataChange,_pageSize,_initialPage);const handleFilterChange=colId=>({target:{value}})=>{filterPluginHandler({colId,value},stateFilters);paginationPluginHandler({numberPage:1,page:{}});};const handlePageChange=(direction,numberPage)=>{paginationPluginHandler({direction,whereParams:stateFilters.whereParams,page:_pageInfo||statePagination.page,totalDataCount:_totalDataCount,numberPage});};const mobileFilterColumns=useMemo(()=>_columns.filter(col=>Object.prototype.hasOwnProperty.call(col,'filter')).map(col=>Object.assign({},col,{// eslint-disable-next-line react/display-name
cellRender:()=>/*#__PURE__*/jsx(Filter$1,{column:col,filtersState:stateFilters.filters,handleFilterChange:handleFilterChange})})),[_columns,stateFilters.filters]);return/*#__PURE__*/jsxs("div",{className:cx(styles$l,'table2'),children:[_showHeader&&/*#__PURE__*/jsxs("div",{className:"header",children:[_title&&/*#__PURE__*/jsx("h1",{children:_title}),hasProp.call(_btnProps,'onClick')&&/*#__PURE__*/jsx(Button,{type:"primary",onClick:_btnProps.onClick,children:_btnProps.text||'accion'})]}),!isMobile&&/*#__PURE__*/jsxs("div",{className:"columns-header",children:[/*#__PURE__*/jsx("div",{className:"columns",children:_columns.map(col=>{var _col$showUpTo;return matchesQuery[(_col$showUpTo=col.showUpTo)!==null&&_col$showUpTo!==void 0?_col$showUpTo:'sm']&&/*#__PURE__*/jsx("div",{className:"column-header",style:getDesktopColumnStyles(col),children:col.name},col.id);})}),_plugins.includes('filter')&&/*#__PURE__*/jsx("div",{className:"filters",children:_columns.map(col=>{var _col$showUpTo2;return matchesQuery[(_col$showUpTo2=col.showUpTo)!==null&&_col$showUpTo2!==void 0?_col$showUpTo2:'sm']&&/*#__PURE__*/jsx("div",{className:"filter-header",style:Object.assign({},getDesktopColumnStyles(col),{overflow:'unset',textOverflow:'unset'}),children:hasProp.call(col,'filter')&&/*#__PURE__*/jsx(Filter$1,{column:col,filtersState:stateFilters.filters,handleFilterChange:handleFilterChange})},`filter-${col.id}`);})})]}),_loading?/*#__PURE__*/jsx("div",{className:"loading",children:/*#__PURE__*/jsx(LoadingSpinner,{})}):/*#__PURE__*/jsxs("div",{className:cx('body',{isMobile}),children:[isMobile&&_plugins.includes('filter')&&/*#__PURE__*/jsx(MobileRowCard$1,{columns:mobileFilterColumns}),!_data||_data.length===0?/*#__PURE__*/jsx("div",{className:cx('empty-container',{isMobile}),children:/*#__PURE__*/jsx(Placeholder,Object.assign({},_placeholderProps))}):_data.map((d,index)=>/*#__PURE__*/jsx(Fragment$1,{children:isMobile?/*#__PURE__*/jsx(MobileRowCard$1,{index:index,onClick:_onRowClick,columns:_columns,item:d}):/*#__PURE__*/jsx(DesktopRow$1,{rowIndex:index,onRowClick:_onRowClick,rowData:d,columns:_columns,columnsKey:isDataKeyStr?`${d[_dataKey]}`:_dataKey(d),getDesktopColumnStyles:getDesktopColumnStyles,matchesQuery:matchesQuery})},isDataKeyStr?d[_dataKey]:_dataKey(d)))]}),_plugins.includes('pagination')&&!!(_data!==null&&_data!==void 0&&_data.length)&&_totalDataCount>_pageSize&&/*#__PURE__*/jsxs("div",{className:"footer",children:[/*#__PURE__*/jsx("p",{children:`Mostrando ${statePagination.rangeStart}
                a ${statePagination.rangeEnd} de ${_totalDataCount} resultados`}),/*#__PURE__*/jsxs("div",{className:"controllers",children:[(_pageInfo===null||_pageInfo===void 0?void 0:_pageInfo.hasPreviousPage)&&/*#__PURE__*/jsx(Button,{type:"outline",role:"gray",onClick:()=>handlePageChange('prev',statePagination.currentPage-1),children:"Anterior"}),(_pageInfo===null||_pageInfo===void 0?void 0:_pageInfo.hasNextPage)&&/*#__PURE__*/jsx(Button,{type:"outline",role:"gray",onClick:()=>handlePageChange('next',statePagination.currentPage+1),children:"Siguiente"})]})]})]});};Table2.defaultProps={title:'',showHeader:true,btnProps:{},columns:[],data:[],pageSize:20,initialPage:1,totalDataCount:0,placeholderProps:{},dataKey:'',onRowClick:null,mobileBreakpoint:768,loading:false,plugins:[],pageInfo:null,onDataChange:()=>{}};const MemoizedTable2=/*#__PURE__*/memo(Table2);

({name:PropTypes.string.isRequired,id:PropTypes.string.isRequired,flex:PropTypes.number,minWidth:PropTypes.number,maxWidth:PropTypes.number,filter:PropTypes.shape({type:PropTypes.oneOf(['text','number','select','date','range']),props:PropTypes.object}),cellRender:PropTypes.func});PropTypes.shape({label:PropTypes.string.isRequired,icon:PropTypes.string,action:PropTypes.func.isRequired});PropTypes.shape({initialPage:PropTypes.number,pageSize:PropTypes.number.isRequired,startCursor:PropTypes.string,endCursor:PropTypes.string,hasNextPage:PropTypes.bool,hasPreviousPage:PropTypes.bool,totalDataCount:PropTypes.number.isRequired});

var _path$9;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgFilter(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "filter_svg__feather filter_svg__feather-filter"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React$1.createElement("path", {
    d: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z"
  })));
}

var _circle$1, _path$8;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgSearch(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "search_svg__feather search_svg__feather-search"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  })), _path$8 || (_path$8 = /*#__PURE__*/React$1.createElement("path", {
    d: "M21 21l-4.35-4.35"
  })));
}

var _path$7;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgPlus(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "plus_svg__feather plus_svg__feather-plus"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React$1.createElement("path", {
    d: "M12 5v14M5 12h14"
  })));
}

var _path$6;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgDownload(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "download_svg__feather download_svg__feather-download"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React$1.createElement("path", {
    d: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"
  })));
}

var _circle, _circle2, _circle3;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgMoreVertical(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "more-vertical_svg__feather more-vertical_svg__feather-more-vertical"
  }, props), _circle || (_circle = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  })));
}

const _excluded$1=["type","rangeValues","value","onChange","placeholder"];function _objectWithoutPropertiesLoose$2(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const styles$k="s1wwpxde";const InputDate=_ref=>{let{type='date',rangeValues=[],value,onChange=()=>{},placeholder=''}=_ref,rest=_objectWithoutPropertiesLoose$2(_ref,_excluded$1);const[startDate,endDate]=rangeValues;const isRange=type==='range';const handleChange=(date,position='')=>{if(!isRange){onChange(date);}else {const range=position==='start'?[date,endDate]:[startDate,date];onChange(range);}};const commonProps=Object.assign({dateFormat:'dd/MMM/yyyy',placeholderText:placeholder,calendarClassName:'custom-date-picker'},rest);return/*#__PURE__*/jsx("div",{className:styles$k,children:!isRange?/*#__PURE__*/jsx(DatePicker,Object.assign({selected:value||undefined,onChange:handleChange},commonProps)):/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx(DatePicker,Object.assign({selected:startDate||undefined,onChange:date=>handleChange(date,'start'),selectsStart:true,startDate:startDate,endDate:endDate},commonProps)),/*#__PURE__*/jsx(DatePicker,Object.assign({selected:endDate||undefined,onChange:date=>handleChange(date,'end'),selectsEnd:true,startDate:startDate,endDate:endDate,minDate:startDate},commonProps))]})});};

const Filter=({column:{filter,name,id},filtersState,handleFilterChange})=>{var _filter$placeholder,_filter$props,_filter$placeholder2,_filter$props2;const handleDateChange=selected=>{const handler=handleFilterChange(id);handler({target:{value:selected}});};return/*#__PURE__*/jsx("div",{className:"filter-container",children:!filter.type.match(/date|range/)?/*#__PURE__*/jsx(Input,Object.assign({type:filter.type,name:name,id:`${name}${filter.type}`,placeholder:(_filter$placeholder=filter===null||filter===void 0?void 0:filter.placeholder)!==null&&_filter$placeholder!==void 0?_filter$placeholder:'',onChange:handleFilterChange(id),value:filtersState[id]},(_filter$props=filter.props)!==null&&_filter$props!==void 0?_filter$props:{})):/*#__PURE__*/jsx(InputDate,Object.assign({type:filter.type,rangeValues:filter.type==='range'?filtersState[id]:[],value:filter.type==='date'?filtersState[id]:undefined,onChange:handleDateChange,placeholder:(_filter$placeholder2=filter===null||filter===void 0?void 0:filter.placeholder)!==null&&_filter$placeholder2!==void 0?_filter$placeholder2:''},(_filter$props2=filter.props)!==null&&_filter$props2!==void 0?_filter$props2:{}))});};

const useFilter=initState=>{const[state,setState]=useState(initState);const handleFilterChange=useCallback(({colId,value:_value=''})=>{const newState=Object.assign({},state);if(colId){if(!_value){delete newState[colId];}else {newState[colId]=_value;}}setState(newState);},[state]);const resetFilters=()=>{setState(initState!==null&&initState!==void 0?initState:{});};const deleteFilter=colId=>{const newState=Object.assign({},state);delete newState[colId];setState(newState);};return {handleFilterChange,filtersState:state,setState,deleteFilter,resetFilters};};

const usePagination=(pageSize=10,initialPage=1)=>{const initialState={currentPage:initialPage,gqlPagination:{},pageSize};const[state,setState]=useState(initialState);const handlePageChange=({direction:_direction='',pageInfo})=>{let newState={};if(_direction==='next'){newState={currentPage:state.currentPage+1};if(typeof pageInfo!=='undefined'){var _pageInfo$endCursor;newState=Object.assign({},newState,{gqlPagination:{startCursor:'',endCursor:(_pageInfo$endCursor=pageInfo===null||pageInfo===void 0?void 0:pageInfo.endCursor)!==null&&_pageInfo$endCursor!==void 0?_pageInfo$endCursor:''}});}}else {newState={currentPage:state.currentPage-1};if(typeof pageInfo!=='undefined'){var _pageInfo$startCursor;newState=Object.assign({},newState,{gqlPagination:{startCursor:(_pageInfo$startCursor=pageInfo===null||pageInfo===void 0?void 0:pageInfo.startCursor)!==null&&_pageInfo$startCursor!==void 0?_pageInfo$startCursor:'',endCursor:''}});}}setState(s=>Object.assign({},s,newState));};const resetPagination=()=>{setState(initialState);};return {handlePageChange,paginationState:state,resetPagination};};

const styles$j="saf3e7s";const FiltersPortal=/*#__PURE__*/forwardRef(({matchesQuery,columns,onClose,onAccept,isMobile,initFilters},ref)=>{const{handleFilterChange,filtersState,resetFilters,deleteFilter}=useFilter(initFilters);const handlePortalFilterChange=colId=>({target:{value}})=>{handleFilterChange({colId,value});};useImperativeHandle(ref,()=>({resetFilters,deleteFilter,filtersState}),[filtersState]);const handleClose=()=>{resetFilters();onClose();};return/*#__PURE__*/jsx(Portal,{children:/*#__PURE__*/jsx(Modal,{onClose:handleClose,onAccept:onAccept,size:"sm",title:"Filtros Avanzados",withFooter:true,children:/*#__PURE__*/jsx("div",{className:styles$j,children:/*#__PURE__*/jsx("div",{className:"filters",children:columns.map(col=>{var _col$showUpTo;return (isMobile||matchesQuery[(_col$showUpTo=col.showUpTo)!==null&&_col$showUpTo!==void 0?_col$showUpTo:'sm'])&&/*#__PURE__*/jsxs("div",{className:"filter-header",children:[/*#__PURE__*/jsx("p",{className:"filter-label",children:col.name}),col.filter&&/*#__PURE__*/jsx(Filter,{column:col,filtersState:filtersState,handleFilterChange:handlePortalFilterChange})]},`filter-${col.id}`);})})})})});});FiltersPortal.defaultProps={initFilters:{}};FiltersPortal.displayName='FiltersPortal';

const styles$i="sjl3vce";const MobileRowCard=({index,onClick,columns,item:_item={},classNames:_classNames=''})=>/*#__PURE__*/jsx("div",{className:cx(styles$i,'table-mobile-card',_classNames),onClick:onClick?()=>onClick(_item,index):undefined,children:columns.map(col=>/*#__PURE__*/jsxs("div",{className:"card-row",children:[/*#__PURE__*/jsx("p",{className:"column-name",children:col.name}),/*#__PURE__*/jsx("div",{className:"column-value",children:Object.prototype.hasOwnProperty.call(col,'cellRender')?col.cellRender(col.id,_item):/*#__PURE__*/jsx("p",{className:"default-render",children:String(_item[col.id])})})]},col.id))});

const styles$h="s1tu51q2";const DesktopRow=({rowIndex:_rowIndex=null,onRowClick:_onRowClick=null,rowData:_rowData={},columns:_columns=[],columnsKey:_columnsKey='',matchesQuery:_matchesQuery={},classNames:_classNames=''})=>/*#__PURE__*/jsx("div",{className:cx(styles$h,'table3-row',_classNames,{onRowClick:_onRowClick}),onClick:_onRowClick?()=>_onRowClick(_rowData,_rowIndex):undefined,children:_columns.map(col=>{var _col$showUpTo,_col$styles;return _matchesQuery[(_col$showUpTo=col.showUpTo)!==null&&_col$showUpTo!==void 0?_col$showUpTo:'sm']&&/*#__PURE__*/jsx("div",{className:"table-row",style:(_col$styles=col.styles)!==null&&_col$styles!==void 0?_col$styles:{},children:Object.prototype.hasOwnProperty.call(col,'cellRender')?col.cellRender(col.id,_rowData):String(_rowData[col.id])},`${_columnsKey}-${col.id}`);})});

const ActiveFilters=({columns,filtersState,deleteFilter})=>/*#__PURE__*/jsx("div",{className:"active-filters",children:Object.entries(filtersState).map(([colId,value])=>{var _column$filter;const column=columns.find(({id})=>id===colId);return/*#__PURE__*/jsxs("span",{children:[`${column===null||column===void 0?void 0:column.name}: ${(_column$filter=column.filter)!==null&&_column$filter!==void 0&&_column$filter.text?column.filter.text(value):value}`,/*#__PURE__*/jsx("span",{onClick:()=>deleteFilter(colId),children:"\xD7"})]},colId);})});

const styles$g="s1p9qys8";const Menu=({menu})=>/*#__PURE__*/jsx("ul",{className:styles$g,children:!!menu.length&&menu.map(({label,action},i)=>/*#__PURE__*/jsx("li",{onClick:action,children:label},`${label}-${i}`))});

const Footer=/*#__PURE__*/forwardRef(({text:_text='',handlePageChange:_handlePageChange=()=>{},pageInfo:_pageInfo={},loading:_loading=false},ref)=>{const{hasPreviousPage=false,hasNextPage=false,pageSize=10,initialPage=1}=_pageInfo;const{handlePageChange:handlePluginPageChange,paginationState,resetPagination}=usePagination(pageSize,initialPage);const currentItemPageIndex=pageSize*paginationState.currentPage;const defaultText=`
    Mostrando ${currentItemPageIndex-pageSize+1} a ${Math.min(currentItemPageIndex,_pageInfo===null||_pageInfo===void 0?void 0:_pageInfo.totalDataCount)} de ${_pageInfo===null||_pageInfo===void 0?void 0:_pageInfo.totalDataCount} resultados
    `;useImperativeHandle(ref,()=>({resetPagination,paginationState}),[paginationState]);useDidUpdate(()=>{_handlePageChange(paginationState);},[paginationState]);return/*#__PURE__*/jsxs("div",{className:"footer",children:[/*#__PURE__*/jsx("p",{children:_text||defaultText}),/*#__PURE__*/jsxs("div",{className:"controllers",children:[/*#__PURE__*/jsx(Button,{type:"outline",role:"gray",onClick:()=>handlePluginPageChange({direction:'previous',pageInfo:_pageInfo}),htmlProps:{disabled:_loading||!hasPreviousPage},children:"Anterior"}),/*#__PURE__*/jsx(Button,{type:"outline",role:"gray",onClick:()=>handlePluginPageChange({direction:'next',pageInfo:_pageInfo}),htmlProps:{disabled:_loading||!hasNextPage},children:"Siguiente"})]})]});});Footer.displayName='Footer';

const GLOBAL_MEDIA_QUERIES={sm:'(min-width: 1px)',md:'(min-width: 1024px)',lg:'(min-width: 1280px)'};const styles$f="s1h899hx";const getIcon=iconName=>{switch(iconName){case'download':return/*#__PURE__*/jsx(SvgDownload,{});case'add':return/*#__PURE__*/jsx(SvgPlus,{});default:return undefined;}};const Table3=({title:_title='',showHeader:_showHeader=true,columns:_columns=[],data:_data=[],placeholderProps:_placeholderProps={},dataKey:_dataKey='',onRowClick:_onRowClick=null,mobileBreakpoint:_mobileBreakpoint=768,loading:_loading=false,plugins:_plugins=[],pageInfo:_pageInfo={},onDataChange:_onDataChange=()=>{},features:_features=[],setRowClassNames:_setRowClassNames=null,menu:_menu=[],footerText:_footerText='',placeholderGlobalSearch:_placeholderGlobalSearch='Buscar',initFilters:_initFilters={}})=>{const matchesQuery=useMedia({queries:GLOBAL_MEDIA_QUERIES});const isMobile=useMedia({query:`(max-width: ${_mobileBreakpoint}px)`});const[tableState,setTableState]=useState({filters:_initFilters});const[filtersOpen,setFiltersOpen]=useState(false);const[menuOpen,setMenuOpen]=useState(false);const footerRef=useRef();const filtersRef=useRef();const isDataKeyStr=typeof _dataKey==='string';const displayColumns=useMemo(()=>_columns.filter(col=>{var _col$filter;return !((_col$filter=col.filter)!==null&&_col$filter!==void 0&&_col$filter.filterOnly);}),[_columns]);const filterColumns=useMemo(()=>_columns.filter(col=>!!col.filter),[_columns]);const onGlobalSearchChange=({target:{value:_value=''}})=>{if(_plugins.includes('filter')&&filtersRef.current){filtersRef.current.resetFilters();}if(_plugins.includes('pagination')&&footerRef.current){footerRef.current.resetPagination();}setTableState(s=>Object.assign({},s,{globalSearchValue:_value}));};const onFilterAccept=()=>{setFiltersOpen(false);if(_plugins.includes('pagination')&&footerRef.current){footerRef.current.resetPagination();}setTableState(s=>{const newState=Object.assign({},s,{filters:filtersRef.current.filtersState});if(_plugins.includes('globalSearch')){newState.globalSearchValue='';}return newState;});};const handleActiveFilterDelete=id=>{const newFiltersState=Object.assign({},tableState.filters);delete newFiltersState[id];setTableState({filters:newFiltersState});filtersRef.current.deleteFilter(id);};const handleClickOutsideMenu=()=>setMenuOpen(false);const[menuRef]=useOutsideClickRef(handleClickOutsideMenu);const handlePaginationChange=paginationState=>{setTableState(s=>Object.assign({},s,{pagination:paginationState}));};useDidUpdate(()=>_onDataChange(tableState),[tableState]);return/*#__PURE__*/jsxs("div",{className:cx('table3',styles$f,{hasShadow:_features.includes('shadow')&&!isMobile}),children:[_showHeader&&/*#__PURE__*/jsxs("div",{className:cx('header',{mobile:isMobile}),children:[_title&&/*#__PURE__*/jsx("h1",{children:_title}),/*#__PURE__*/jsxs("div",{className:'header-actions',children:[_plugins.includes('globalSearch')&&/*#__PURE__*/jsx("div",{className:"global-search-container",children:/*#__PURE__*/jsx(Input,{type:"text",name:"globalSearch",placeholder:_placeholderGlobalSearch,onChange:onGlobalSearchChange,value:tableState.globalSearchValue,LeadingIcon:SvgSearch})}),_plugins.includes('filter')&&/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx(Button,{type:"outline",role:"white",onClick:()=>setFiltersOpen(true),children:/*#__PURE__*/jsx(SvgFilter,{})}),/*#__PURE__*/jsx(CSSTransition,{in:filtersOpen,timeout:200,classNames:"portal-fade",mountOnEnter:true,children:/*#__PURE__*/jsx(FiltersPortal,{ref:filtersRef,matchesQuery:matchesQuery,isMobile:isMobile,columns:filterColumns,onClose:()=>setFiltersOpen(false),onAccept:onFilterAccept,initFilters:_initFilters})})]}),!!_menu.length&&/*#__PURE__*/jsx(Fragment,{children:_menu.length>1?/*#__PURE__*/jsxs("div",{className:cx('menu-container',{active:menuOpen}),children:[/*#__PURE__*/jsx(Button,{type:"outline",role:"white",onClick:()=>setMenuOpen(state=>!state),children:/*#__PURE__*/jsx(SvgMoreVertical,{})}),/*#__PURE__*/jsx(CSSTransition,{in:menuOpen,timeout:200,classNames:"menu-open",mountOnEnter:true,unmountOnExit:true,children:/*#__PURE__*/jsx("div",{className:"menu-items-container",ref:menuRef,children:/*#__PURE__*/jsx(Menu,{menu:_menu.map(item=>{const i=Object.assign({},item);i.action=()=>{setMenuOpen(false);item.action();};return i;})})})})]}):/*#__PURE__*/jsx("div",{className:"action-container",children:/*#__PURE__*/jsxs(Button,{type:"outline",role:"white",onClick:_menu[0].action,children:[_menu[0].icon&&getIcon(_menu[0].icon),/*#__PURE__*/jsx("span",{children:_menu[0].label})]})})})]})]}),!!tableState.filters&&!!Object.keys(tableState.filters).length&&/*#__PURE__*/jsx(ActiveFilters,{columns:filterColumns,filtersState:tableState.filters,deleteFilter:handleActiveFilterDelete}),!isMobile&&/*#__PURE__*/jsx("div",{className:"columns-header",children:/*#__PURE__*/jsx("div",{className:"columns",children:displayColumns.map(col=>{var _col$showUpTo,_col$styles;return matchesQuery[(_col$showUpTo=col.showUpTo)!==null&&_col$showUpTo!==void 0?_col$showUpTo:'sm']&&/*#__PURE__*/jsx("div",{className:"column-header",style:(_col$styles=col.styles)!==null&&_col$styles!==void 0?_col$styles:{},children:col.name},col.id);})})}),_loading?/*#__PURE__*/jsx("div",{className:"loading",children:/*#__PURE__*/jsx(LoadingSpinner,{})}):/*#__PURE__*/jsx("div",{className:cx('body',{mobile:isMobile}),children:!_data||_data.length===0?/*#__PURE__*/jsx("div",{className:cx('empty-container',{mobile:isMobile}),children:/*#__PURE__*/jsx(Placeholder,Object.assign({},_placeholderProps))}):_data.map((d,index)=>/*#__PURE__*/jsx(Fragment$1,{children:isMobile?/*#__PURE__*/jsx(MobileRowCard,{index:index,onClick:_onRowClick,columns:displayColumns,item:d,classNames:_setRowClassNames?_setRowClassNames(d):''}):/*#__PURE__*/jsx(DesktopRow,{rowIndex:index,onRowClick:_onRowClick,rowData:d,columns:displayColumns,columnsKey:isDataKeyStr?`${d[_dataKey]}`:_dataKey(d),matchesQuery:matchesQuery,classNames:_setRowClassNames?_setRowClassNames(d):''})},isDataKeyStr?d[_dataKey]:_dataKey(d)))}),_plugins.includes('pagination')&&!!(_data!==null&&_data!==void 0&&_data.length)&&/*#__PURE__*/jsx(Footer,{text:_footerText,ref:footerRef,handlePageChange:handlePaginationChange,pageInfo:_pageInfo,loading:_loading})]});};Table3.defaultProps={title:'',showHeader:true,btnProps:{},columns:[],data:[],placeholderProps:{},dataKey:'',onRowClick:null,mobileBreakpoint:768,loading:false,plugins:[],pageInfo:{},onDataChange:()=>{},setRowClassNames:null,menu:[],features:[],footerText:'',placeholderGlobalSearch:'Buscar',initFilters:{}};const MemoizedTable3=/*#__PURE__*/memo(Table3);

const styles$e="s1e30swi";const Toggle=/*#__PURE__*/forwardRef(({isActive,onToggle,inputProps,type},ref)=>/*#__PURE__*/jsxs("div",{className:`${styles$e} ${isActive?'active':''} ${type}`,role:"checkbox",tabIndex:"0","aria-checked":"false",onClick:()=>onToggle(!isActive),children:[/*#__PURE__*/jsx("input",Object.assign({ref:ref,type:"checkbox",className:"toggle-switch-checkbox",name:"toggleSwitch",id:"toggleSwitch",checked:isActive,onChange:()=>onToggle(!isActive)},inputProps)),/*#__PURE__*/jsx("span",{"aria-hidden":"true"})]}));Toggle.displayName='Toggle';Toggle.propTypes={type:PropTypes.string,isActive:PropTypes.bool.isRequired,onToggle:PropTypes.func.isRequired,inputProps:PropTypes.object};Toggle.defaultProps={type:'primary',inputProps:{}};

var __exports$a = {}; var exports = __exports$a; var __module$a = { exports: __exports$a };
                    if (typeof module !== "undefined") for (var prop$a in module) { prop$a !== "exports" && (__module$a[prop$a] = module[prop$a]);}!function(t,n){"object"==typeof exports&&"undefined"!=typeof __module$a?__module$a.exports=n():"function"==typeof define&&define.amd?define(n):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_objectSupport=n();}(undefined,(function(){return function(t,n,e){var i=n.prototype,r=function(t){var n,r=t.date,o=t.utc,a={};if(!((n=r)instanceof Date)&&!(n instanceof Array)&&n instanceof Object){if(!Object.keys(r).length)return new Date;var u=o?e.utc():e();Object.keys(r).forEach((function(t){var n,e;a[(n=t,e=i.$utils().p(n),"date"===e?"day":e)]=r[t];}));var d=a.day||(a.year||a.month>=0?1:u.date()),c=a.year||u.year(),f=a.month>=0?a.month:a.year||a.day?0:u.month(),s=a.hour||0,h=a.minute||0,b=a.second||0,y=a.millisecond||0;return o?new Date(Date.UTC(c,f,d,s,h,b,y)):new Date(c,f,d,s,h,b,y)}return r},o=i.parse;i.parse=function(t){t.date=r.bind(this)(t),o.bind(this)(t);};var a=i.set,u=i.add,d=function(t,n,e,i){if(void 0===i&&(i=1),n instanceof Object){var r=Object.keys(n),o=this;return r.forEach((function(e){o=t.bind(o)(n[e]*i,e);})),o}return t.bind(this)(n*i,e)};i.set=function(t,n){return n=void 0===n?t:n,d.bind(this)((function(t,n){return a.bind(this)(n,t)}),n,t)},i.add=function(t,n){return d.bind(this)(u,t,n)},i.subtract=function(t,n){return d.bind(this)(u,t,n,-1)};}}));var objectSupport = __module$a.exports;

dayjs.extend(objectSupport);const style="s1lv6yyg";const DAYS={MONDAY:'Lunes',TUESDAY:'Martes',WEDNESDAY:'Miércoles',THURSDAY:'Jueves',FRIDAY:'Viernes',SATURDAY:'Sábado',SUNDAY:'Domingo'};const defaultDays=Object.entries(DAYS).map(([enumKey,enumValue])=>({id:enumKey,name:enumValue,isActive:false,hours:[{startTime:'8:00',endTime:'18:00'}]}));const TimeSchedule=({selectedDays,onScheduleChange,isLoading})=>{const newSelectedDays=defaultDays.map(day=>{let newDay=Object.assign({},day);const finded=selectedDays.find(({id})=>id===newDay.id);if(finded){finded.name=day.name;newDay=finded;}return newDay;});const toggleDay=dayId=>{const copySchedule=[...newSelectedDays];const idx=newSelectedDays.findIndex(({id})=>id===dayId);if(idx!==null){copySchedule[idx].isActive=!copySchedule[idx].isActive;}onScheduleChange(copySchedule);};const addHoursToDay=(dayId,hours)=>{const idx=newSelectedDays.findIndex(({id})=>id===dayId);const newState=[...newSelectedDays];const starTime=Number(hours.at(-1).endTime.split(':')[0])+1;const endTime=starTime+1;newState[idx].hours=[...newState[idx].hours,{startTime:`${starTime}:00`,endTime:`${endTime}:00`}];onScheduleChange(newState);};const deleteHoursFromDay=(dayId,hourIdx)=>{const idx=newSelectedDays.findIndex(({id})=>id===dayId);const newState=[...newSelectedDays];newState[idx].hours.splice(hourIdx,1);onScheduleChange(newState);};const updateDayHours=(dayId,hourIdx,key,value)=>{const idx=newSelectedDays.findIndex(({id})=>id===dayId);const newState=[...newSelectedDays];newState[idx].hours[hourIdx][key]=value;onScheduleChange(newState);};const handleTimeScheduleInputOnChange=({id,currentIdx,key,value})=>{// let previousValueTime
// if (key === 'startTime') {
//   previousValueTime =
//     hours[currentIdx - (hours.length > 1 ? 1 : 0)].endTime.split(
//       ':',
//     )
// } else {
//   previousValueTime = hours[currentIdx].startTime.split(':')
// }
// const previousTimeDate = dayjs({
//   hour: previousValueTime[0],
//   minute: previousValueTime[1],
// })
// const currentValueTime = value.split(':')
// const currentValueDate = dayjs({
//   hour: currentValueTime[0],
//   minute: currentValueTime[1],
// })
// if (
//   previousValueTime &&
//   previousTimeDate.diff(currentValueDate) > 0
// ) {
//   return
// }
updateDayHours(id,currentIdx,key,value);};return/*#__PURE__*/jsx("div",{className:style,children:isLoading?/*#__PURE__*/jsx("div",{className:"card-loader"}):/*#__PURE__*/jsx("div",{className:"days",children:newSelectedDays.map(({id,name,isActive,hours})=>/*#__PURE__*/jsxs("div",{className:"day-container",children:[/*#__PURE__*/jsx(Checkbox,{label:name,name:`chk-${id}`,checked:isActive,onClick:()=>toggleDay(id),type:"secondary"}),/*#__PURE__*/jsx("div",{className:"hours",children:hours.map((hour,i)=>/*#__PURE__*/jsx(TimeScheduleInput// eslint-disable-next-line react/no-array-index-key
,{index:i,values:hour,onActionClick:(_,action)=>{if(action==='add'){addHoursToDay(id,hours);}if(action==='delete'){deleteHoursFromDay(id,i);}},onChange:(value,key)=>handleTimeScheduleInputOnChange({id,currentIdx:i,key,value,hours}),actionBtnType:i===0?'add':'delete',hasAction:hour.endTime!=='24'},`${id}-${i}`))})]},id))})});};TimeSchedule.defaultProps={selectedDays:[],isLoading:false};

const styles$d="s1thosib";const TimeScheduleInput=({values:{startTime,endTime},disabled,actionBtnType,onChange,hasAction,index,parentID,onActionClick})=>/*#__PURE__*/jsxs("div",{className:styles$d,children:[/*#__PURE__*/jsx("input",{type:"time",value:startTime.length===4?`0${startTime}`:startTime,onChange:({target})=>onChange(target.value,'startTime',parentID,index),pattern:"[0-9]{1,2}:[0-9]{2}",disabled:disabled}),/*#__PURE__*/jsx("span",{children:"-"}),/*#__PURE__*/jsx("input",{type:"time",value:endTime,onChange:({target})=>onChange(target.value,'endTime',parentID,index),pattern:"[0-9]{1,2}:[0-9]{2}",disabled:disabled}),/*#__PURE__*/jsx("div",{children:hasAction&&!disabled&&/*#__PURE__*/jsx(Button,{onClick:()=>onActionClick(parentID,actionBtnType,index),role:"white",type:"outline",children:actionBtnType==='add'?'+':'×'})})]});TimeScheduleInput.defaultProps={timeOpts:{startInput:{minTime:'00:01',maxTime:'00:00'},endInput:{minTime:'00:01',maxTime:'00:00'}},values:{startTime:'',endTime:''},disabled:false,actionBtnType:'add',onChange:()=>{},hasAction:true,parentID:'',onActionClick:()=>{}};

const styles$c="snfqjzb";const WizardNew=({children,data,activeStepIndex,onBack,onNext,itemsSteps})=>/*#__PURE__*/jsxs("div",{className:styles$c,children:[/*#__PURE__*/jsx(NavigationSteps,Object.assign({},itemsSteps)),children.map((child,index)=>activeStepIndex===index?/*#__PURE__*/React__default.cloneElement(child,{// eslint-disable-next-line react/no-array-index-key
key:`complete-state-${index}`,stepIndex:index,activeStepIndex,onNext,onBack,stepsLength:children.length,data}):null)]});WizardNew.defaultProps={onNext:()=>{},onBack:()=>{}};

var _path$5;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgConfigurationIcon(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$6({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React$1.createElement("path", {
    d: "M18.9 11.66a1 1 0 010-1.32l1.28-1.44a1 1 0 00.12-1.17l-2-3.46a1 1 0 00-1.07-.48l-1.88.38a1 1 0 01-1.15-.66l-.61-1.83a1 1 0 00-.95-.68h-4a1 1 0 00-1 .68l-.56 1.83a1 1 0 01-1.15.66L4 3.79a1 1 0 00-1 .48L1 7.73a1 1 0 00.1 1.17l1.27 1.44a1 1 0 010 1.32L1.1 13.1a1 1 0 00-.1 1.17l2 3.46a1 1 0 001.07.48l1.88-.38a1 1 0 011.15.66l.61 1.83a1 1 0 001 .68h4a1 1 0 00.95-.68l.61-1.83a1 1 0 011.15-.66l1.88.38a1 1 0 001.07-.48l2-3.46a1 1 0 00-.12-1.17l-1.35-1.44zM17.41 13l.8.9-1.28 2.22-1.18-.24a3 3 0 00-3.45 2L11.92 19H9.36L9 17.86a3 3 0 00-3.45-2l-1.18.24-1.3-2.21.8-.9a3 3 0 000-4l-.8-.9 1.28-2.2 1.18.24a3 3 0 003.45-2L9.36 3h2.56l.38 1.14a3 3 0 003.45 2l1.18-.24 1.28 2.22-.8.9a3 3 0 000 3.98zm-6.77-6a4 4 0 100 8 4 4 0 000-8zm0 6a2 2 0 110-4 2 2 0 010 4z",
    fill: "currentColor"
  })));
}

const styles$b="s1o06fk2";const WizardStep$1=({children,stepIndex,submitName,onSubmit,disableSubmit,onBack,canSkip,onSkip,isValid,title,description,Image,stepsLength,infoLink,loading,hideStepCount,advancedButtonAction})=>/*#__PURE__*/jsxs("div",{className:styles$b,children:[/*#__PURE__*/jsxs("div",{className:"col-1",children:[Image&&/*#__PURE__*/jsx(Image,{}),/*#__PURE__*/jsxs("div",{className:"text-container",children:[/*#__PURE__*/jsx("h1",{className:"title",children:title}),/*#__PURE__*/jsx("p",{className:"description",children:description}),infoLink&&/*#__PURE__*/jsx("a",{className:"more-info",href:infoLink,target:"_blank",rel:"noreferrer",children:"M\xE1s informaci\xF3n"}),advancedButtonAction&&/*#__PURE__*/jsxs(Button,{label:"share",onClick:advancedButtonAction,role:"white",type:"outline",children:[/*#__PURE__*/jsx(SvgConfigurationIcon,{}),"Opciones avanzadas"]})]}),/*#__PURE__*/jsxs("div",{className:"steps-count",children:[stepIndex?/*#__PURE__*/jsx(ArrowButton,{onClick:onBack,disabled:loading}):/*#__PURE__*/jsx("div",{className:"placeholder-arrow"}),!hideStepCount&&/*#__PURE__*/jsxs("p",{children:[stepIndex+1," de ",stepsLength]})]})]}),/*#__PURE__*/jsxs("div",{className:`col-2 ${stepIndex+1===stepsLength?'success':''}`,children:[/*#__PURE__*/jsx("div",{className:"section-container",children:children}),/*#__PURE__*/jsxs("div",{className:"btn-container",children:[canSkip&&/*#__PURE__*/jsx(Button,{onClick:onSkip,role:"white",type:"outline",children:"Omitir"}),/*#__PURE__*/jsx(Button,{className:"save",onClick:onSubmit,htmlProps:{disabled:loading||!isValid||disableSubmit},loading:loading,children:submitName})]})]})]});WizardStep$1.defaultProps={submitName:'Siguiente',disableSubmit:false,onSubmit:()=>{},onBack:()=>{},canSkip:false,onSkip:()=>{},// currentStep: '',
infoLink:null,isValid:true,Image:null,loading:false,description:'',hideStepCount:false,advancedButtonAction:null};

const WizardStep=({children})=>{return/*#__PURE__*/jsx("div",{className:"section-container",children:children});};

var _path$4;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgSuccessCheck(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React$1.createElement("path", {
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  })));
}

var _path$3;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgError(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
    clipRule: "evenodd"
  })));
}

var _path$2;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgWarning(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  })));
}

const styles$a="s18ktscx";const FloatingNotification=({type,title,message,onClose,onClick,show,timeout})=>{const notificationClasses=cx(styles$a,type);const Icon=()=>{switch(type){case'success':return/*#__PURE__*/jsx(SvgSuccessCheck,{});case'error':return/*#__PURE__*/jsx(SvgError,{});case'warn':return/*#__PURE__*/jsx(SvgWarning,{});default:// TODO: info icon
return/*#__PURE__*/jsx(SvgSuccessCheck,{});}};return/*#__PURE__*/jsx(CSSTransition,{in:show,mountOnEnter:true,unmountOnExit:true,timeout:{enter:timeout,exit:300},classNames:"notification",children:/*#__PURE__*/jsxs("div",{className:cx(notificationClasses,{'on-click':onClick}),onClick:onClick,children:[/*#__PURE__*/jsx("div",{className:"container-icon",children:/*#__PURE__*/jsx(Icon,{})}),/*#__PURE__*/jsxs("div",{className:"container-text",children:[/*#__PURE__*/jsx("p",{className:"title",children:title}),/*#__PURE__*/jsx("p",{className:"message",children:message})]}),/*#__PURE__*/jsx("div",{className:"container-close",children:/*#__PURE__*/jsx("button",{type:"button",onClick:e=>{e.stopPropagation();onClose(e);},children:/*#__PURE__*/jsx("svg",{className:"",viewBox:"0 0 20 20",fill:"currentColor",children:/*#__PURE__*/jsx("path",{fillRule:"evenodd",d:`M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0
                    01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z`,clipRule:"evenodd"})})})})]})});};FloatingNotification.defaultProps={title:'',onClose:()=>{},onClick:null,show:false,timeout:3000};

var _path$1;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgSuccess(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  })));
}

const styles$9="s1aknx8i";const InlineNotification=({type,title,message})=>{const notificationClasses=cx(styles$9,type);const Icon=()=>{switch(type){case'error':return/*#__PURE__*/jsx(SvgError,{});case'warning':return/*#__PURE__*/jsx(SvgWarning,{});default:return/*#__PURE__*/jsx(SvgSuccess,{});}};const content=()=>{if(Array.isArray(message)){return/*#__PURE__*/jsx("ul",{children:message.map(m=>/*#__PURE__*/jsx("li",{children:m},m))});}return message;};return/*#__PURE__*/jsxs("div",{className:notificationClasses,children:[/*#__PURE__*/jsx("div",{className:"container-icon",children:/*#__PURE__*/jsx(Icon,{})}),/*#__PURE__*/jsxs("div",{className:"container-text",children:[/*#__PURE__*/jsx("h3",{children:title}),/*#__PURE__*/jsx("div",{children:content()})]})]});};InlineNotification.defaultProps={title:'Notification',message:''};

const styles$8="siadpie";const AddImage$1=({onClick,boxLabel})=>/*#__PURE__*/jsxs("div",{className:cx(styles$8,'add-image'),onClick:onClick,children:[/*#__PURE__*/jsx("span",{}),boxLabel&&/*#__PURE__*/jsx("p",{children:boxLabel})]});AddImage$1.defaultProps={boxLabel:''};

const styles$7="sbtj0ic";const GalleryItem$1=({url,isSelected,isFav,onClick,onFavImageSelect,canFav,canSelect,onImageRemove,loading})=>/*#__PURE__*/jsxs("div",{className:cx(styles$7,{selected:isSelected,loading}),onClick:()=>onClick(url),children:[/*#__PURE__*/jsx(CSSTransition,{in:loading,mountOnEnter:true,timeout:{enter:300,exit:700},classNames:"fade",children:/*#__PURE__*/jsx("div",{className:"loading-container",children:/*#__PURE__*/jsx(CircularProgress$1,{progress:loading?25:100,strokeWidth:3,size:30})})}),(canSelect||canFav)&&/*#__PURE__*/jsxs("div",{className:"actions",children:[canSelect&&/*#__PURE__*/jsx("input",{type:"checkbox",checked:isSelected,onChange:()=>onClick(url)}),canFav&&/*#__PURE__*/jsx("span",{className:isFav?'active':'',onClick:e=>{e.stopPropagation();onFavImageSelect(url);}})]}),/*#__PURE__*/jsx("div",{className:"delete-container",children:/*#__PURE__*/jsx("span",{className:"delete",onClick:e=>{e.stopPropagation();onImageRemove(url);}})}),/*#__PURE__*/jsx("img",{src:url,alt:"a galley inage"})]});GalleryItem$1.defaultProps={isSelected:false,isFav:false,canFav:false,canSelect:false,loading:true};

const styles$6="sifta3c";const Gallery=({urls,selectedUrls,favUrl,onImageSelect,onFavImageSelect,onImageDrop,onImageRemove,asyncUpload,loadedUrls,canFav,canSelect,maxFiles,maxSize,label})=>{const onDrop=useCallback(acceptedFiles=>{acceptedFiles.forEach(file=>onImageDrop(file));},[onImageDrop]);return/*#__PURE__*/jsx(Dropzone$2,{onDrop:onDrop,noClick:true,maxFiles:maxFiles,maxSize:maxSize,disabled:urls.length===maxFiles,children:({getRootProps,getInputProps,isDragActive,open})=>/*#__PURE__*/jsxs("div",Object.assign({className:cx(styles$6,{active:isDragActive})},getRootProps(),{children:[/*#__PURE__*/jsx(CSSTransition,{in:isDragActive,timeout:200,classNames:"fade",mountOnEnter:true,unmountOnExit:true,children:/*#__PURE__*/jsx("span",{className:"drag-active",children:/*#__PURE__*/jsx(AddImage$1,{boxLabel:label})})}),/*#__PURE__*/jsx("input",Object.assign({},getInputProps())),/*#__PURE__*/jsx("div",{className:"dotted",children:/*#__PURE__*/jsx(AddImage$1,{onClick:open,boxLabel:label})}),urls.map(url=>/*#__PURE__*/jsx(GalleryItem$1,{url:url,onClick:onImageSelect,isSelected:selectedUrls.includes(url),isFav:url===favUrl,onFavImageSelect:onFavImageSelect,onImageRemove:onImageRemove,canFav:canFav,canSelect:canSelect,loading:asyncUpload&&!loadedUrls.includes(url)},url))]}))});};Gallery.defaultProps={urls:[],loadedUrls:[],selectedUrls:[],favUrl:'',asyncUpload:true,canFav:false,canSelect:false,onImageSelect:()=>{},onFavImageSelect:()=>{},maxFiles:8,maxSize:2000000,label:'Añadir imagen'};

const styles$5="s12x8isr";const AddImage=({onClick,boxLabel})=>/*#__PURE__*/jsxs("div",{className:cx(styles$5,'add-image'),onClick:onClick,children:[/*#__PURE__*/jsx("span",{}),boxLabel&&/*#__PURE__*/jsx("p",{children:boxLabel})]});AddImage.defaultProps={boxLabel:''};

const styles$4="si7ran5";const CircularProgress=({size:_size=20,progress:_progress=0,strokeWidth:_strokeWidth=6})=>{const center=_size/2;const radius=_size/2-_strokeWidth/2;const circumference=2*Math.PI*radius;const offset=(100-_progress)/100*circumference;return/*#__PURE__*/jsx("div",{className:styles$4,children:/*#__PURE__*/jsxs("svg",{className:"progress-ring",width:_size,height:_size,children:[/*#__PURE__*/jsx("circle",{className:"progress-ring__bg",cx:center,cy:center,r:radius,strokeWidth:_strokeWidth}),/*#__PURE__*/jsx("circle",{className:"progress-ring__progress",cx:center,cy:center,r:radius,strokeWidth:_strokeWidth,strokeDasharray:circumference,strokeDashoffset:offset})]})});};CircularProgress.defaultProps={size:20,strokeWidth:6};

const styles$3="s13633sd";const GalleryItem=({item,isSelected,isFav,onClick,onFavImageSelect,canFav,canSelect,onImageRemove,loading,canDelete,size})=>/*#__PURE__*/jsxs("div",{className:cx(styles$3,{selected:isSelected,loading}),style:{width:size,height:size},onClick:()=>onClick(item),children:[/*#__PURE__*/jsx(CSSTransition,{in:loading,mountOnEnter:true,timeout:{enter:300,exit:700},classNames:"fade",children:/*#__PURE__*/jsx("div",{className:"loading-container",children:/*#__PURE__*/jsx(CircularProgress,{progress:loading?25:100,strokeWidth:3,size:30})})}),(canSelect||canFav)&&/*#__PURE__*/jsxs("div",{className:"actions",children:[canSelect&&/*#__PURE__*/jsx("input",{type:"checkbox",checked:isSelected,onChange:()=>onClick(item)}),canFav&&/*#__PURE__*/jsx("span",{className:isFav?'active':'',onClick:e=>{e.stopPropagation();onFavImageSelect(item);}})]}),canDelete&&!loading&&/*#__PURE__*/jsx("div",{className:"delete-container",children:/*#__PURE__*/jsx("span",{className:"delete",onClick:e=>{e.stopPropagation();onImageRemove(item);}})}),/*#__PURE__*/jsx("img",{src:item.url,alt:"a galley inage"})]});GalleryItem.defaultProps={isSelected:false,isFav:false,canFav:false,canSelect:false,loading:true,canDelete:false,onFavImageSelect:()=>{},size:'5rem'};

const styles$2="s7zrxc1";const Gallery2=({items,selectedIds,favUrl,onImageSelect,onFavImageSelect,onImageDrop,onImageRemove,asyncUpload,loadedIds,canFav,canSelect,maxFiles,maxSize,label,canAdd,canDelete,itemSize})=>{const onDrop=useCallback(acceptedFiles=>{if(acceptedFiles.length){onImageDrop(acceptedFiles);}},[onImageDrop]);return/*#__PURE__*/jsx(Dropzone$2,{onDrop:onDrop,noClick:true,maxFiles:maxFiles,maxSize:maxSize,disabled:items.length===maxFiles,accept:['.png','.jpeg','.jpg'],children:({getRootProps,getInputProps,isDragActive,open})=>/*#__PURE__*/jsxs("div",Object.assign({className:cx(styles$2,{active:isDragActive})},getRootProps(),{children:[canAdd&&/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx(CSSTransition,{in:isDragActive,timeout:200,classNames:"fade",mountOnEnter:true,unmountOnExit:true,children:/*#__PURE__*/jsx("span",{className:"drag-active",children:/*#__PURE__*/jsx(AddImage,{boxLabel:label})})}),/*#__PURE__*/jsx("input",Object.assign({},getInputProps())),/*#__PURE__*/jsx("div",{className:"dotted",children:/*#__PURE__*/jsx(AddImage,{onClick:open,boxLabel:label})})]}),items.map(item=>/*#__PURE__*/jsx(GalleryItem,{item:item,onClick:onImageSelect,isSelected:selectedIds.includes(item.id),isFav:item.url===favUrl,onFavImageSelect:onFavImageSelect,onImageRemove:onImageRemove,canFav:canFav,canSelect:canSelect,loading:asyncUpload&&!loadedIds.includes(item.id),canDelete:canDelete,itemSize:itemSize},item.id))]}))});};Gallery2.defaultProps={items:[],loadedIds:[],selectedIds:[],favUrl:'',asyncUpload:false,canFav:false,canSelect:false,onImageSelect:()=>{},onFavImageSelect:()=>{},maxFiles:8,maxSize:2000000,label:'Añadir imagen',canAdd:false,canDelete:false,itemSize:'5rem'};

var __exports$9 = {}; var __module$9 = { exports: __exports$9 };
                    if (typeof module !== "undefined") for (var prop$9 in module) { prop$9 !== "exports" && (__module$9[prop$9] = module[prop$9]);}__module$9.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};
var ErrorCorrectLevel$1 = __module$9.exports;

var __require__import__3$1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), ErrorCorrectLevel$1, {
  'default': ErrorCorrectLevel$1
}));

var __exports$8 = {}; var __module$8 = { exports: __exports$8 };
                    if (typeof module !== "undefined") for (var prop$8 in module) { prop$8 !== "exports" && (__module$8[prop$8] = module[prop$8]);}var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

__module$8.exports = QRMath;
var math$2 = __module$8.exports;

var __require__import__2$2 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), math$2, {
  'default': math$2
}));

function __interopImport$5(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$7 = {}; var __module$7 = { exports: __exports$7 };
                    if (typeof module !== "undefined") for (var prop$7 in module) { prop$7 !== "exports" && (__module$7[prop$7] = module[prop$7]);}var math$1 = __interopImport$5(__require__import__2$2);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math$1.gexp(math$1.glog(this.get(i) ) + math$1.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math$1.glog(this.get(0) ) - math$1.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math$1.gexp(math$1.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

__module$7.exports = QRPolynomial;
var Polynomial$2 = __module$7.exports;

var __require__import__4 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), Polynomial$2, {
  'default': Polynomial$2
}));

var __exports$6 = {}; var __module$6 = { exports: __exports$6 };
                    if (typeof module !== "undefined") for (var prop$6 in module) { prop$6 !== "exports" && (__module$6[prop$6] = module[prop$6]);}__module$6.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};
var mode$1 = __module$6.exports;

var __require__import__0$1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), mode$1, {
  'default': mode$1
}));

function __interopImport$4(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$5 = {}; var __module$5 = { exports: __exports$5 };
                    if (typeof module !== "undefined") for (var prop$5 in module) { prop$5 !== "exports" && (__module$5[prop$5] = module[prop$5]);}var Mode = __interopImport$4(__require__import__0$1);
var Polynomial$1 = __interopImport$4(__require__import__4);
var math = __interopImport$4(__require__import__2$2);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial$1([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial$1([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

__module$5.exports = QRUtil;
var util$1 = __module$5.exports;

var __require__import__3 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), util$1, {
  'default': util$1
}));

var __exports$4 = {}; var __module$4 = { exports: __exports$4 };
                    if (typeof module !== "undefined") for (var prop$4 in module) { prop$4 !== "exports" && (__module$4[prop$4] = module[prop$4]);}function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

__module$4.exports = QRBitBuffer;
var BitBuffer$1 = __module$4.exports;

var __require__import__2$1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), BitBuffer$1, {
  'default': BitBuffer$1
}));

function __interopImport$3(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$3 = {}; var __module$3 = { exports: __exports$3 };
                    if (typeof module !== "undefined") for (var prop$3 in module) { prop$3 !== "exports" && (__module$3[prop$3] = module[prop$3]);}var ECL = __interopImport$3(__require__import__3$1);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
};

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
};

__module$3.exports = QRRSBlock;
var RSBlock$1 = __module$3.exports;

var __require__import__1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), RSBlock$1, {
  'default': RSBlock$1
}));

function __interopImport$2(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$2 = {}; var __module$2 = { exports: __exports$2 };
                    if (typeof module !== "undefined") for (var prop$2 in module) { prop$2 !== "exports" && (__module$2[prop$2] = module[prop$2]);}var mode = __interopImport$2(__require__import__0$1);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

__module$2.exports = QR8bitByte;
var _8BitByte = __module$2.exports;

var __require__import__0 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), _8BitByte, {
  'default': _8BitByte
}));

function __interopImport$1(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports$1 = {}; var __module$1 = { exports: __exports$1 };
                    if (typeof module !== "undefined") for (var prop$1 in module) { prop$1 !== "exports" && (__module$1[prop$1] = module[prop$1]);}var BitByte = __interopImport$1(__require__import__0);
var RSBlock = __interopImport$1(__require__import__1);
var BitBuffer = __interopImport$1(__require__import__2$1);
var util = __interopImport$1(__require__import__3);
var Polynomial = __interopImport$1(__require__import__4);

function QRCode$2(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode$2.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode$2.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode$2.PAD0 = 0xEC;
QRCode$2.PAD1 = 0x11;

QRCode$2.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$2.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$2.PAD1, 8);
	}

	return QRCode$2.createBytes(buffer, rsBlocks);
};

QRCode$2.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

__module$1.exports = QRCode$2;
var QRCode$3 = __module$1.exports;

var __require__import__2 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), QRCode$3, {
  'default': QRCode$3
}));

function __interopImport(ex) {
                        if (ex.__esModule) {
                            return ex;
                        }

                        if ('default' in ex) {
                            return ex.default;
                        } 

                        return ex;
                    }
                var __exports = {}; var __module = { exports: __exports };
                    if (typeof module !== "undefined") for (var prop in module) { prop !== "exports" && (__module[prop] = module[prop]);}
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __interopImport(React$1);

__interopImport(__require__import__1$5); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __interopImport(__require__import__2);

var ErrorCorrectLevel = __interopImport(__require__import__3$1); // TODO: pull this off of the QRCode class type so it matches.


// Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000',
  includeMargin: false
};
var MARGIN_SIZE = 4; // This is *very* rough estimate of max amount of QRCode allowed to be covered.
// It is "wrong" in a lot of ways (area is a terrible way to estimate, it
// really should be number of modules covered), but if for some reason we don't
// get an explicit height or width, I'd rather default to something than throw.

var DEFAULT_IMG_SCALE = 0.1;

function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        // M0 0h7v1H0z injects the space with the move and drops the comma,
        // saving a char per operation
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      } // end of row, clean up or skip


      if (x === row.length - 1) {
        if (!cell) {
          // We would have closed the op above already so this can only mean
          // 2+ light modules in a row.
          return;
        }

        if (start === null) {
          // Just a single dark module.
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          // Otherwise finish the current line.
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }

        return;
      }

      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join('');
} // We could just do this in generatePath, except that we want to support
// non-Path2D canvas, so we need to keep it an explicit step.


function excavateModules(modules, excavation) {
  return modules.slice().map(function (row, y) {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }

    return row.map(function (cell, x) {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }

      return false;
    });
  });
}

function getImageSettings(props, cells) {
  var imageSettings = props.imageSettings,
      size = props.size,
      includeMargin = props.includeMargin;

  if (imageSettings == null) {
    return null;
  }

  var margin = includeMargin ? MARGIN_SIZE : 0;
  var numCells = cells.length + margin * 2;
  var defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  var scale = numCells / size;
  var w = (imageSettings.width || defaultSize) * scale;
  var h = (imageSettings.height || defaultSize) * scale;
  var x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  var y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  var excavation = null;

  if (imageSettings.excavate) {
    var floorX = Math.floor(x);
    var floorY = Math.floor(y);
    var ceilW = Math.ceil(w + x - floorX);
    var ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }

  return {
    x: x,
    y: y,
    h: h,
    w: w,
    excavation: excavation
  };
} // For canvas we're going to switch our drawing mode based on whether or not
// the environment supports Path2D. We only need the constructor to be
// supported, but Edge doesn't actually support the path (string) type
// argument. Luckily it also doesn't support the addPath() method. We can
// treat that as the same thing.


var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }

  return true;
}();

var QRCodeCanvas =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(QRCodeCanvas, _React$PureComponent);

  function QRCodeCanvas() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(QRCodeCanvas)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_canvas", void 0);

    _defineProperty(_assertThisInitialized(_this), "_image", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      imgLoaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleImageLoad", function () {
      _this.setState({
        imgLoaded: true
      });
    });

    return _this;
  }

  _createClass(QRCodeCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._image && this._image.complete) {
        this.handleImageLoad();
      }

      this.update();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props$imageSett, _nextProps$imageSetti;

      var currentSrc = (_this$props$imageSett = this.props.imageSettings) === null || _this$props$imageSett === void 0 ? void 0 : _this$props$imageSett.src;
      var nextSrc = (_nextProps$imageSetti = nextProps.imageSettings) === null || _nextProps$imageSetti === void 0 ? void 0 : _nextProps$imageSetti.src;

      if (currentSrc !== nextSrc) {
        this.setState({
          imgLoaded: false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$props = this.props,
          value = _this$props.value,
          size = _this$props.size,
          level = _this$props.level,
          bgColor = _this$props.bgColor,
          fgColor = _this$props.fgColor,
          includeMargin = _this$props.includeMargin,
          imageSettings = _this$props.imageSettings; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var margin = includeMargin ? MARGIN_SIZE : 0;
        var numCells = cells.length + margin * 2;
        var calculatedImageSettings = getImageSettings(this.props, cells);

        if (imageSettings != null && calculatedImageSettings != null) {
          if (calculatedImageSettings.excavation != null) {
            cells = excavateModules(cells, calculatedImageSettings.excavation);
          }
        } // We're going to scale this so that the number of drawable units
        // matches the number of cells. This avoids rounding issues, but does
        // result in some potentially unwanted single pixel issues between
        // blocks, only in environments that don't support Path2D.


        var pixelRatio = window.devicePixelRatio || 1;
        canvas.height = canvas.width = size * pixelRatio;
        var scale = size / numCells * pixelRatio;
        ctx.scale(scale, scale); // Draw solid background, only paint dark modules.

        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, numCells, numCells);
        ctx.fillStyle = fgColor;

        if (SUPPORTS_PATH2D) {
          // $FlowFixMe: Path2D c'tor doesn't support args yet.
          ctx.fill(new Path2D(generatePath(cells, margin)));
        } else {
          cells.forEach(function (row, rdx) {
            row.forEach(function (cell, cdx) {
              if (cell) {
                ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
              }
            });
          });
        }

        if (this.state.imgLoaded && this._image && calculatedImageSettings != null) {
          ctx.drawImage(this._image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
          _this$props2.value;
          var size = _this$props2.size;
          _this$props2.level;
          _this$props2.bgColor;
          _this$props2.fgColor;
          var style = _this$props2.style;
          _this$props2.includeMargin;
          var imageSettings = _this$props2.imageSettings,
          otherProps = _objectWithoutProperties(_this$props2, ["value", "size", "level", "bgColor", "fgColor", "style", "includeMargin", "imageSettings"]);

      var canvasStyle = _objectSpread({
        height: size,
        width: size
      }, style);

      var img = null;
      var imgSrc = imageSettings && imageSettings.src;

      if (imageSettings != null && imgSrc != null) {
        img = React.createElement("img", {
          src: imgSrc,
          style: {
            display: 'none'
          },
          onLoad: this.handleImageLoad,
          ref: function ref(_ref) {
            return _this2._image = _ref;
          }
        });
      }

      return React.createElement(React.Fragment, null, React.createElement("canvas", _extends$1({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this2._canvas = _ref2;
        }
      }, otherProps)), img);
    }
  }]);

  return QRCodeCanvas;
}(React.PureComponent);

_defineProperty(QRCodeCanvas, "defaultProps", DEFAULT_PROPS);

var QRCodeSVG =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(QRCodeSVG, _React$PureComponent2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, _getPrototypeOf(QRCodeSVG).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          size = _this$props3.size,
          level = _this$props3.level,
          bgColor = _this$props3.bgColor,
          fgColor = _this$props3.fgColor,
          includeMargin = _this$props3.includeMargin,
          imageSettings = _this$props3.imageSettings,
          otherProps = _objectWithoutProperties(_this$props3, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "imageSettings"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return null;
      }

      var margin = includeMargin ? MARGIN_SIZE : 0;
      var numCells = cells.length + margin * 2;
      var calculatedImageSettings = getImageSettings(this.props, cells);
      var image = null;

      if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }

        image = React.createElement("image", {
          xlinkHref: imageSettings.src,
          height: calculatedImageSettings.h,
          width: calculatedImageSettings.w,
          x: calculatedImageSettings.x + margin,
          y: calculatedImageSettings.y + margin,
          preserveAspectRatio: "none"
        });
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var fgPath = generatePath(cells, margin);
      return React.createElement("svg", _extends$1({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: fgPath
      }), image);
    }
  }]);

  return QRCodeSVG;
}(React.PureComponent);

_defineProperty(QRCodeSVG, "defaultProps", DEFAULT_PROPS);

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _objectSpread({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
__module.exports = QRCode;var QRCode$1 = __module.exports;

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgDownArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "-6 0 20 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React$1.createElement("path", {
    d: "M12.71 5.79a1 1 0 00-1.42 0L8 9.09V1.5a1 1 0 00-2 0v7.59l-3.29-3.3a1.004 1.004 0 00-1.42 1.42l5 5a1 1 0 00.33.21.94.94 0 00.76 0 1 1 0 00.33-.21l5-5a1 1 0 000-1.42z",
    fill: "currentColor"
  })));
}

const styles$1="sz2uh3l";const CodeQR=({qrString,buttonProps})=>{const downloadRef=useRef();return/*#__PURE__*/jsxs("div",{className:styles$1,id:"qrcode",children:[/*#__PURE__*/jsx(QRCode$1,{value:qrString,size:200}),/*#__PURE__*/jsx("a",{ref:downloadRef,children:/*#__PURE__*/jsxs(Button,Object.assign({},buttonProps,{onClick:()=>{downloadRef.current.href=document.querySelector('#qrcode > canvas').toDataURL();downloadRef.current.download='qrCode.png';},children:["Descargar",/*#__PURE__*/jsx(SvgDownArrow,{})]}))})]});};CodeQR.defaultProps={buttonProps:{}};

const _excluded=["defaultCountry","value","onChangePhoneInput","preferredCountries","onlyCountries","label","loading","tooltipText","required","inputProps"];function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return {};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}const PhoneInput=P.default?P.default:P;const styles="sicaprn";const InputPhone=_ref=>{let{defaultCountry,value,onChangePhoneInput,preferredCountries,onlyCountries,label,loading,tooltipText,required,inputProps}=_ref,extraProps=_objectWithoutPropertiesLoose(_ref,_excluded);return/*#__PURE__*/ (// TODO: can change component language
jsxs("div",{className:styles,children:[label&&/*#__PURE__*/jsx("div",{className:"container-label",children:loading?/*#__PURE__*/jsx("span",{className:"loading-fill"}):/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/jsx("label",{htmlFor:`input-${inputProps.name}`,children:label}),tooltipText&&/*#__PURE__*/jsx(Tooltip,{text:tooltipText}),required&&/*#__PURE__*/jsx("span",{className:"req",children:"*"})]})}),/*#__PURE__*/jsx(PhoneInput,Object.assign({disableCountryGuess:true,countryCodeEditable:false,localization:es$1,placeholder:"Selecciona tu pa\xEDs",value:value,country:defaultCountry,onChange:onChangePhoneInput,enableSearch:true,preferredCountries:preferredCountries,searchPlaceholder:"Buscar",onlyCountries:onlyCountries,disableSearchIcon:true,inputProps:Object.assign({},inputProps,{required})},extraProps))]}));};InputPhone.defaultProps={onChangePhoneInput:()=>{},defaultCountry:'gt',value:'',preferredCountries:[],onlyCountries:[],label:'',loading:false,tooltipText:'',required:false,inputProps:{}};

const withSuspense=Story=>/*#__PURE__*/jsx(Suspense,{fallback:/*#__PURE__*/jsx("div",{children:"Loading..."}),children:/*#__PURE__*/jsx(Story,{})});

export { Accordion, AccountAvatar, AccountDetail, ActionCard, AddressList, ArrowButton, Banner, Breadcrumb, Button, Calendar, CardPayoff, CardPayoffDetail, CardPayoffResume as CardPayoffLead, CardPayoffTotal, CardSection, CardSectionAction, CategorySelector$1 as CategorySelector, CategorySelector as CategorySelectorModal, Checkbox, CheckboxList, CircularProgress$1 as CircularProgress, CodeQR, CompleteState, CompleteStateStep, ConfirmAction, CopyText, DashboardCard, DashboardChart as DashboardWeeklyChart, Divider, Droplist, Dropzone$1 as Dropzone, Dropzone as DropzoneFiles, DropzoneFiles2, EmbeddedButton, ExportTable as ExportableTable, FloatingNotification, FullLoading, Gallery, Gallery2, AddImage$1 as GalleryAddImage, HistoryDetails, ImagePreview, InfoCard, InlineList, InlineNotification, Input, InputDate, InputPhone, index$1 as Layouts, Loading, LoadingSpinner, Map, Menu$1 as Menu, Modal, MountAnimation, NavSteps, NavTabs, NavigationSteps, NewCardForm, PaginableTable, PaymentLink, Pill, Placeholder, Portal, Price, RadioList, Select, ShareWhatsapp, SidePanelWrapper as SidePanel, SingleDropzone, StarsRating, StatusSelect, SuccessOrder, SupportForm, Table, MemoizedTable2 as Table2, MemoizedTable3 as Table3, TablePaginator, TimeSchedule, TimeScheduleInput, Toggle, TopBar, WizardNew as Wizard, WizardStep$1 as WizardStep, WizardStep as WizardStepFull, withSuspense };
